import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FrontService } from '../../front.service';
import { Menu } from '../../../models/menu.model';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { QuickDesign } from '../../../models/quick-design.model';
import { QuickDesignService } from '../../../services/quick-deisgn.service';
import { Element } from '../../../models/element.model';
import { ElementService } from '../../../services/element.service';
import { Subscription } from 'rxjs/Subscription';
import { MasterService } from '../../../services/master.service';
import { StyleService } from '../../../services/style.service';
import { Style } from '../../../models/style.model';

import { APP_CONFIG } from '../../../app.config';
import { TemplateService } from '../../../services/template.service';
import { Template } from '../../../models/template.model';

import * as bootstrap from 'bootstrap';
import { MyDesktopService } from '../../../services/mydesktop.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Auth } from '../../../models/auth.model';
import { ClientService } from '../../../services/client.service';
import { StorageService } from '../../../services/storage.service';
import { Client } from '../../../models/client.model';
import * as juice from 'juice';
import * as moment from 'moment';

import * as beautify from 'beautify';

import { Select2OptionData } from 'ng2-select2';
import { ImageLibraryService } from '../../../shared/imagelibrary.service';
import { UserService } from '../../../services/user.service';
import { PasteService } from '../../../services/paste.service';
import { SupportService } from '../../../services/support.service';
import { Subject } from 'rxjs';
import { ParticaService } from '../../../services/partica.service';

import { environment } from '../../../../environments/environment';
import { VaultService } from '../../../services/vault.service';
import { CampaignService } from '../../../services/campaign.service';
import { DomainService } from '../../../services/domain.service';

declare var $: any;
declare var swal: any;
declare var CKEDITOR: any;
declare var introJs: any;
declare var Aviary: any;
declare var _bugHerd: any;
declare var grapesjs: any;

// import * as grapesjs from 'grapesjs';

@Component({
  selector: 'app-template-front-build',
  templateUrl: './template-front-build.component.html',
  styleUrls: ['./template-front-build.component.css']
})

export class TemplateFrontBuildComponent implements OnInit, OnDestroy, AfterViewInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  loading = false;
  subLoading = false;
  mainLoading = false;
  activateInsertListing = false;
  loadingInsertListing = false;
  menus: Menu[] = [];
  id: number;
  category: string;
  template: Template;
  quickDesigns: QuickDesign[] = [];
  elements: Element[] = [];
  style: Style;

  s2SuburbValueModalInit = false;
  s2SuburbValue = '';
  s2SuburbData: Array<Select2OptionData>;
  s2SuburbOptions: Select2Options;

  s2CampaignValue;
  s2CampaignData: Array<Select2OptionData>;
  s2CampaignOptions: Select2Options;

  s2ClassificationValue = '';
  s2ClassificationData: Array<Select2OptionData>;
  s2ClassificationOptions: Select2Options;
  s2StatusValue = '';
  s2StatusData: Array<Select2OptionData>;
  s2StatusOptions: Select2Options;
  s2StatusDisabled = true;
  s2SubStatusValue = '';
  s2SubStatusData: Array<Select2OptionData>;
  s2SubStatusOptions: Select2Options;
  s2SubStatusDisabled = true;
  s2AvailableValue = '1';
  s2AvailableData: Array<Select2OptionData>;
  s2AvailableOptions: Select2Options;
  s2AvailableDisabled = true;
  s2AgentIdValue = '';
  s2AgentIdData: Array<Select2OptionData>;
  s2AgentIdOptions: Select2Options;

  s2PriceFromValue = '';
  s2PriceFromData: Array<Select2OptionData>;
  s2PriceFromOptions: Select2Options;

  s2PriceToValue = '';
  s2PriceToData: Array<Select2OptionData>;
  s2PriceToOptions: Select2Options;

  s2BedFromValue = '';
  s2BedFromData: Array<Select2OptionData>;
  s2BedFromOptions: Select2Options;

  s2BedToValue = '';
  s2BedToData: Array<Select2OptionData>;
  s2BedToOptions: Select2Options;

  s2BathFromValue = '';
  s2BathFromData: Array<Select2OptionData>;
  s2BathFromOptions: Select2Options;

  s2BathToValue = '';
  s2BathToData: Array<Select2OptionData>;
  s2BathToOptions: Select2Options;

  s2CarFromValue = '';
  s2CarFromData: Array<Select2OptionData>;
  s2CarFromOptions: Select2Options;

  s2CarToValue = '';
  s2CarToData: Array<Select2OptionData>;
  s2CarToOptions: Select2Options;

  s2OrderByValue = 'modifydateDesc';
  s2OrderByData: Array<Select2OptionData>;
  s2OrderByOptions: Select2Options;

  s2BasedOnValue = '';
  s2BasedOnData: Array<Select2OptionData>;
  s2BasedOnOptions: Select2Options;
  s2BasedOnDisabled = true;

  s2OfficeIdValue = '';
  s2OfficeIdData: Array<Select2OptionData>;
  s2OfficeIdOptions: Select2Options;
  s2SelectingCategory = false;
  pdfButtonClicked = false;
  imgButtonClicked = false;
  qdtButtonClicked = false;
  qdoButtonClicked = false;
  fbButtonClicked = false;
  twitterButtonClicked = false;
  linkedinButtonClicked = false;
  savePopupShow = true;

  editor: any;
  selectedFileHolder: any;
  selectedListingIDs = [];
  editorWidth = '900px';
  editorDevice = 'Desktop View';
  is_save = false;
  new_template_name = '';

  price_sale: any[] = [];
  price_rent: any[] = [];

  imageUrl = '';
  is_style_visible = false;

  mdListingsForm: FormGroup;
  libraryStorageForm: FormGroup;

  mdListings: any[] = [];
  mdSuburbs: any[] = [];
  mdTypes: any[] = [];
  mdClassifications: any[] = [];
  mdStatuses: any[] = [];
  mdCustomParams: any[] = [];

  elementListingHtml: any[] = [];

  element_parent_id = 0;
  element_listing_limit = 0;
  element_listing_index = 0;

  element_file_limit = 1;

  is_help_box_open = false;

  client: Client;

  // Start of Image Library related variables
  files = [];
  subFiles = [];
  tempFiles = [];
  images = [];
  selected_image = [];
  libraryType = 'owned';
  libraryPath = '';
  base_path = '';
  libraryFolder = '';
  sid: number;
  is_new_folder = false;
  is_new_image = false;
  is_on_level3 = false;
  level = 0;
  folder_name1 = '';
  folder_name2 = '';
  // End of Image Library related variables
  selectedListings = [];
  selectedFile = [];

  mdListingCount = 0;
  mdListingTotal = 0;
  mdListingPages = [];
  mdListingCurrentPage = 1;

  clientSetting: any;
  groupSetting: any;

  supportLink = '';

  authUser: Auth;
  clientAgents = [];
  templateAgent: any;

  is_local_search = 0;

  inlineJS = [];

  plugins = [];

  enable_contenteditable = false;
  enable_zoom = false;
  ckeditor_active = false;

  isMultipleOffice = false;
  multipleOffice = [];

  is_highlightable = true;
  _tmp_selected_element: any;

  _tmp_order_id: number;
  _tmp_order_images = {};

  _sender: any;

  listingImages: any[];
  oldPosImages: any[];
  newPosImages: any[];

  init_colorpicker = false;
  color_selected_element: any;

  template_custom_attribute: {
    name: 'custom-width',
    width: '10px'
  };

  image_editor: any;
  image_model: any;

  property_guide_skip = false;
  updateable_link_type = 'url';

  showScreenshot = false;
  showPartica = false;
  showImageLibrary = false;

  // listing filter related variables
  canSearch = false;
  isDatePeriodNeeded = false;
  filterPeriodType = 'n/a';

  listingSearchValues: string;
  isSendToVault = false;
  vaultTemplateId = 0;
  mainColor = '';

  showDesignlyPreviousPage = false;
  showDesignlyNextPage = false;
  designlyPreviousLink = '';
  designlyNextLink = '';

  campaigns = [];

  @ViewChild('builderHtml') builder: ElementRef;
  @ViewChild('mdPropSearchModal') mdPropSearchModal: ElementRef;
  @ViewChild('mdPropSearchModalClose') mdPropSearchModalClose: ElementRef;

  @ViewChild('mdLibrarySearchModal') mdLibrarySearchModal: ElementRef;
  @ViewChild('mdLibrarySearchModalClose') mdLibrarySearchModalClose: ElementRef;

  @ViewChild('mdParticaSearchModal') mdParticaSearchModal: ElementRef;
  @ViewChild('mdParticaSearchModalClose') mdParticaSearchModalClose: ElementRef;

  @ViewChild('itemFile') itemFile: ElementRef;

  constructor(public frontService: FrontService,
              private templateService: TemplateService,
              private quickDesignService: QuickDesignService,
              private elementService: ElementService,
              private styleService: StyleService,
              private myDesktopService: MyDesktopService,
              private clientService: ClientService,
              private storageService: StorageService,
              private route: ActivatedRoute,
              private router: Router,
              private imageService: ImageLibraryService,
              private userService: UserService,
              private pasteService: PasteService,
              private supportService: SupportService,
              private particaService: ParticaService,
              private ref: ChangeDetectorRef,
              private vaultService: VaultService,
              private campaignService: CampaignService,
              private domainService: DomainService
            ) {
                const $this = this;
                window['onPdfCheck'] = function() {
                  $this.onPdfDownloadCheck();
                };

                window['onModalLinkTypeChange'] = function() {
                  $this.onModalLinkTypeChange();
                };

                window['onClickSend'] = function(link, val) {
                  $this.onClickSend(link, val);
                };

                window['onAnchorPaste'] = function() {
                  $this.onAnchorPaste();
                };
              }

  ngOnInit() {
    this.authUser = this.frontService.authService.auth;
    this.supportLink = this.frontService.supportLink;
    const $this = this;
    this.client = this.authUser.client;
    this.loading = true;
    this.frontService.fullPageContent = true;
    this.frontService.loadMenu(this.menus);

    this.clientSetting = this.frontService.authService.auth.client;
    this.groupSetting = this.clientSetting.group.master;

    this.is_local_search = this.client.is_local_search;

    this.templateAgent = this.authUser.user;

    if ( this.authUser.client.group_id === 12 ) {
      this.mainColor = '#FFB914';
    } else {
     this.mainColor = '#37aae1';
    }

    this.campaignService.httpGetCampaigns({
      type: 'custom'
    });

    this.campaignService.campaignGetAll
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.campaigns = response.data;
          let campaignData = [];

          if ( this.authUser.provider === 'domain' ) {
            campaignData = [
              {id: '', text: 'Select Category'},
              {id: 'Sales', text: 'Sales'},
              {id: 'Rental', text: 'Rental'},
              {id: 'Share', text: 'Share'},
              {id: 'Sold', text: 'Sold'},
              {id: 'NewHomes', text: 'New Homes'}
            ];
          } else {
            campaignData = [
              {id: '', text: 'Select Category'},
              {id: 'Sales', text: 'Sales'},
              {id: 'Rental', text: 'Rental'},
              {id: 'Sold', text: 'Sold'}
            ];
          }

          this.campaigns.forEach( campaign => {
            campaignData.push(
              {id: `custom_${campaign.ID}`, text: campaign.name}
            );
          });

          const newCampaigns = campaignData.map( (el) => {
            return { id: el.id, text: el.text};
          });

          this.s2CampaignData = <any>newCampaigns;
        }
      }
    );

    this.campaignService.campaignPostTemplate
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          $this.saveHtml(this.editor);
          // swal(
          //   'Saved to Selected Categories',
          //   '',
          //   'success'
          // );
          this.s2CampaignValue = '';
          $('#selectCampaign').modal('hide');

          this.ref.detectChanges();
        }
      }
    );

    const tempAgentUsers = this.authUser.client.users.slice(0);
    this.clientAgents = tempAgentUsers.sort(function(a, b) {
      const x = a.firstname.toLowerCase();
      const y = b.firstname.toLowerCase();
      return x < y ? -1 : x > y ? 1 : 0;
    });

    this.imageService.is_builder = true;

    
    this.s2CampaignOptions = {
      width: '100%',
      placeholder: 'Select a Campaign Type',
      minimumResultsForSearch: -1
    };

    this.s2SuburbOptions = {
      width: '100%',
      placeholder: 'Select a Suburb',
      allowClear: true,
      ajax: {
        headers: {
          'Authorization' : 'Bearer ' + this.authUser.__token
        },
        url: this.frontService.appConfig.API_ENDPOINT + '/locations',
        dataType: 'json',
        delay: 500,
        data: function (params) {
          return {
            name: params.term
          };
        },
        processResults: function (data, params) {
          const results = data.data.map(
            (obj) => {
              return {id: obj.name, text: obj.name};
            }
          );
          results.unshift({id: 'all', text: 'All Suburb'});

          return {
            results: results
          };
        },
        cache: true
      },
      minimumInputLength: 2
    };

    if (this.is_local_search) {
      this.s2SuburbOptions['multiple'] = true;
    }

    this.s2SuburbData = <any>[
      {id: '', text: 'Select a Suburb'},
      {id: ' ', text: 'Select a Suburb'}
    ];

    if ( this.authUser.provider === 'vaultre' ) {
      this.s2ClassificationData = <any>[
        {id: '', text: 'Select a Category'},
        {id: 'residential', text: 'Residential'},
        {id: 'commercial', text: 'Commercial'},
        {id: 'business', text: 'Business'},
        {id: 'rural', text: 'Rural'},
        {id: 'land', text: 'Land'},
        {id: 'holidayRental', text: 'Holiday Rental'},
      ];
    } else if ( this.authUser.provider === 'domain' ) {
      this.s2ClassificationData = <any>[
        {id: '', text: 'Select a Category'},
        {id: 'residential', text: 'Residential'},
        // {id: 'commercial', text: 'Commercial'},
        // {id: 'business', text: 'Business'}
      ];
    } else {
      this.s2ClassificationData = <any>[
        {id: '', text: 'Select a Category'},
        {id: 'residential', text: 'Residential'},
        {id: 'commercial', text: 'Commercial'},
        {id: 'business', text: 'Business'},
        {id: 'rural', text: 'Rural'},
        {id: 'livestock', text: 'Livestock'},
        {id: 'clearingsale', text: 'Clearing Sale'},
      ];
    }

    this.s2ClassificationOptions = {
      width: '100%',
      placeholder: 'Select a Category',
      minimumResultsForSearch: -1
    };

    this.s2StatusData = <any>[
      {id: '', text: 'Select a Type'},
      {id: ' ', text: 'All Types'},
      {id: 'listing', text: 'Sales'},
      {id: 'rental', text: 'Rental'},
      {id: 'auction', text: 'Auction'},
      {id: 'settled', text: 'Sold'},
      {id: 'leased', text: 'Leased'},
      {id: 'conditional', text: 'Conditional'},
      {id: 'unconditional', text: 'Unconditional'},
    ];

    this.s2StatusOptions = {
      width: '100%',
      placeholder: 'Select a Type',
      minimumResultsForSearch: -1
    };

    this.s2SubStatusData = <any>[];

    this.s2SubStatusOptions = {
      width: '100%',
      placeholder: 'Select a Sub Type',
      minimumResultsForSearch: -1,
    };

    this.s2SubStatusValue = 'management';

    this.s2SubStatusData = [
      {id: 'all', text: 'All'},
      {id: 'prospect', text: 'Prospect'},
      {id: 'appraisal', text: 'Appraisal'},
      {id: 'management', text: 'Management'},
    ];

    this.s2BasedOnOptions = {
      width: '100%',
      placeholder: 'Select based on',
      minimumResultsForSearch: -1
    };

    this.s2BasedOnData = [
      {id: '', text: 'Select based on'},
      {id: ' ', text: 'Select based on'},
      {id: 'unconditional', text: 'Unconditional'},
      {id: 'settled', text: 'Settled'}
    ];

    this.s2AgentIdData = <any>this.clientAgents.map(
      (obj) => {
        return {id: obj.agent_id, text: obj.firstname + ' ' + obj.lastname};
      }
    );
    this.s2AgentIdData.unshift({id: ' ', text: 'All Agents'});
    this.s2AgentIdData.unshift({id: '', text: 'Select an Agent'});

    this.s2AgentIdOptions = {
      width: '100%',
      placeholder: 'Select an Agent',
      minimumResultsForSearch: -1
    };

    this.s2AvailableOptions = {
      width: '100%',
      placeholder: 'Show Available Only',
      minimumResultsForSearch: -1
    };

    this.s2AvailableData = [
      {id: '1', text: 'Yes'},
      {id: '0', text: 'No'},
    ];

    if ( this.authUser.multiple.length > 1 ) {
      this.isMultipleOffice = true;
      this.s2OfficeIdData = <any>this.authUser.multiple.map(
        (obj) => {
          return {id: obj.groupid, text: obj.office};
        }
      );

      this.s2OfficeIdData.unshift({id: '', text: 'Select an Office'});

      this.s2OfficeIdOptions = {
        width: '100%',
        placeholder: 'Select an Office',
        minimumResultsForSearch: -1
      };
    }


    this.price_sale = [
      {id: '50000', text: '$50,000'},
      {id: '100000', text: '$100,000'},
      {id: '150000', text: '$150,000'},
      {id: '200000', text: '$200,000'},
      {id: '250000', text: '$250,000'},
      {id: '300000', text: '$300,000'},
      {id: '350000', text: '$350,000'},
      {id: '400000', text: '$400,000'},
      {id: '450000', text: '$450,000'},
      {id: '500000', text: '$500,000'},
      {id: '550000', text: '$550,000'},
      {id: '600000', text: '$600,000'},
      {id: '650000', text: '$650,000'},
      {id: '700000', text: '$700,000'},
      {id: '750000', text: '$750,000'},
      {id: '800000', text: '$800,000'},
      {id: '850000', text: '$850,000'},
      {id: '900000', text: '$900,000'},
      {id: '950000', text: '$950,000'},
      {id: '1000000', text: '$1,000,000'},
      {id: '1100000', text: '$1,100,000'},
      {id: '1200000', text: '$1,200,000'},
      {id: '1300000', text: '$1,300,000'},
      {id: '1400000', text: '$1,400,000'},
      {id: '1500000', text: '$1,500,000'},
      {id: '1600000', text: '$1,600,000'},
      {id: '1700000', text: '$1,700,000'},
      {id: '1800000', text: '$1,800,000'},
      {id: '1900000', text: '$1,900,000'},
      {id: '2000000', text: '$2,000,000'},
      {id: '2250000', text: '$2,250,000'},
      {id: '2500000', text: '$2,500,000'},
      {id: '2750000', text: '$2,750,000'},
      {id: '3000000', text: '$3,000,000'},
      {id: '3500000', text: '$3,500,000'},
      {id: '4000000', text: '$4,000,000'},
      {id: '5000000', text: '$5,000,000'},
      {id: '6000000', text: '$6,000,000'},
      {id: '7000000', text: '$7,000,000'},
      {id: '8000000', text: '$8,000,000'},
      {id: '9000000', text: '$9,000,000'},
      {id: '10000000', text: '$10,000,000'},
      {id: '11000000', text: '$11,000,000'},
      {id: '12000000', text: '$12,000,000'}
    ];

    this.price_rent = [
      {id: '50', text: '$50'},
      {id: '100', text: '$100'},
      {id: '150', text: '$150'},
      {id: '200', text: '$200'},
      {id: '250', text: '$250'},
      {id: '300', text: '$300'},
      {id: '350', text: '$350'},
      {id: '400', text: '$400'},
      {id: '450', text: '$450'},
      {id: '500', text: '$500'},
      {id: '550', text: '$550'},
      {id: '600', text: '$600'},
      {id: '650', text: '$650'},
      {id: '700', text: '$700'},
      {id: '750', text: '$750'},
      {id: '800', text: '$800'},
      {id: '850', text: '$850'},
      {id: '900', text: '$900'},
      {id: '950', text: '$950'},
      {id: '1000', text: '$1,000'},
      {id: '1500', text: '$1,500'},
      {id: '2000', text: '$2,000'},
      {id: '3000', text: '$3,000'},
      {id: '4000', text: '$4,000'},
      {id: '5000', text: '$5,000'}
    ];

    this.s2PriceFromData = this.s2PriceToData = <any>this.price_sale;

    this.s2PriceToData.unshift({id: ' ', text: 'Any'});
    this.s2PriceToData.unshift({id: '', text: 'Any'});

    this.s2PriceFromData = this.s2PriceToData;

    this.s2PriceToOptions = this.s2PriceFromOptions = {
      width: '100%',
      placeholder: 'Any',
      minimumResultsForSearch: -1
    };

    this.s2BedFromData = <any>[
      {id: '1', text: '1'},
      {id: '2', text: '2'},
      {id: '3', text: '3'},
      {id: '4', text: '4'},
      {id: '5', text: '5'},
    ];
    this.s2BedFromData.unshift({id: ' ', text: 'Any'});
    this.s2BedFromData.unshift({id: '', text: 'Any'});

    this.s2BedFromOptions = {
      width: '100%',
      placeholder: 'Any',
      minimumResultsForSearch: -1
    };

    this.s2BathFromData = this.s2CarFromData = this.s2BedToData = this.s2BathToData = this.s2CarToData = this.s2BedFromData;

    this.s2BathFromOptions = this.s2CarFromOptions = this.s2BedFromOptions;
    this.s2BathToOptions = this.s2CarToOptions = this.s2BedToOptions = this.s2BedFromOptions;

    let s2OrderByData = [];
    if ( this.authUser.provider === 'vaultre') {
      s2OrderByData = <any>[
        {id: 'modifydateDesc', text: 'Sort by: Newest Modified'},
        {id: 'modifydate', text: 'Sort by: Oldest Modified'}
      ];
    } else {
      s2OrderByData = <any>[
        {id: 'modifydateDesc', text: 'Sort by: Newest Modified'},
        {id: 'modifydate', text: 'Sort by: Oldest Modified'},
        {id: 'suburb', text: 'Sort by: Suburb (A-Z)'},
        {id: 'suburbDesc', text: 'Sort by: Suburb (Z-A)'},
      ];
    }

    this.s2OrderByData = s2OrderByData;

    this.s2OrderByOptions = {
      width: '100%',
      minimumResultsForSearch: -1
    };

    this.route.params.subscribe(
      (params: Params) => {
        this.id = this.storageService.template_id = +params['id'];
        this.category = params['type'];

        this.templateService.httpGetTemplate(this.id);
      }
    );

    this.templateService.templateChanged
    .takeUntil(this.destroy$)
    .subscribe(
      (template: Template) => {
        this.template = template;
        if ( this.template ) {
          if ( this.template.user_agent_id !== this.templateAgent.id) {
            const agentIndex = this.clientAgents.findIndex(c => +c.id === this.template.user_agent_id);
            if (typeof agentIndex !== 'undefined' && agentIndex !== -1) {
              this.templateAgent = this.clientAgents[agentIndex];
            }
          }

          if ( this.template.media_attribute.size === 'custom' ) {
            // add 2.65mm or 10px
            const width = String(this.template.media_attribute.custom_width);
            let custom_width: any;
            if ( width.split('px').length > 1 ) {
              const _width = width.split('px');
              // tslint:disable-next-line:radix
              custom_width = ( parseInt(_width[0]) + 10 ) + 'px';
            }

            if ( width.split('mm').length > 1 ) {
              const _width = width.split('mm');
              // tslint:disable-next-line:radix
              custom_width = ( parseInt(_width[0]) + 2.65 ) + 'mm';
            }

            this.template_custom_attribute = {
              name: this.template.media_attribute.slug,
              width: custom_width
            };
          }

          this.quickDesignService.httpGetQuickDesigns(
            {
              category_id: this.template.category_id,
              client_id: [0, this.client.ID],
              group_id: this.template.group_id,
              media_attribute_id: this.template.media_attribute_id,
              department_id: this.template.department_id,
              provider: ['all', this.authUser.provider]
            }
          );
        }
      }
    );

    this.imageService.fileChanged
    .takeUntil(this.destroy$)
    .subscribe(
      (file: any) => {
        const imageLibraryModel = this.editor.getSelected();
        const imagePath = this.getLink(file);

        imageLibraryModel.set('src', imagePath);

        setTimeout(
          () => {
            this.mdLibrarySearchModalClose.nativeElement.click();
            this.showImageLibrary = false;
            this.subLoading = false;

            this.ref.detectChanges();
          }, 200
        );

      }
    );

    this.storageService.storageMigrateToS3
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.image_model.set('src', response.data.new_url);
          this.editor.Modal.close();

          swal(
            'Image Saved',
            // tslint:disable-next-line:max-line-length
            'Your image has been edited and saved but the image may still be loading, you can save your template and continue while the image is still loading.',
            'success'
          );
          $('.tui-editor-backdrop').css('display', 'none');

          this.ref.detectChanges();
        }
      }
    );

    this.quickDesignService.quickDesignsChanged
    .takeUntil(this.destroy$)
    .subscribe(
      (quickDesigns: any) => {
        if (typeof quickDesigns !== 'undefined' &&
          typeof quickDesigns.status !== 'undefined' &&
            quickDesigns.status === 'success' ) {

          quickDesigns = quickDesigns.data;

          this.quickDesigns = quickDesigns;

          const elementServiceArgs = {
            category_id: this.template.category_id,
            client_id: [0, this.client.ID],
            group_id: this.template.group_id,
            media_attribute_id: this.template.media_attribute_id,
            department_id: this.template.department_id,
            is_active: 1,
            provider: ['all', this.authUser.provider]
          };

          if (this.template.master.show_element === 1) {
            elementServiceArgs.client_id = [0];
          } else if (this.template.master.show_element === 2) {
            elementServiceArgs.client_id = [this.client.ID];
          }

          this.elementService.httpGetElements(elementServiceArgs);
        }
      }
    );

    this.elementService.elementsChanged
    .takeUntil(this.destroy$)
    .subscribe(
      (elements: Element[]) => {
        if ( typeof elements !== 'undefined' && elements.length > 0 ) {
          this.elements = elements;
          this.styleService.httpGetStyles(
            {
              category_id: this.template.category_id,
              group_id: this.template.group_id,
              media_attribute_id: this.template.media_attribute_id,
              department_id: this.template.department_id,
              client_id: [0, this.template.client_id],
            }
          );

          this.loading = false;
        }
      }
    );

    this.elementService.elementListingHtml
    .takeUntil(this.destroy$)
    .subscribe(
      (htmls: any) => {
        if ( typeof htmls !== 'undefined' && htmls.status === 'success' ) {
          this.elementListingHtml = htmls.data;

          this.loading = false;
          this.subLoading = false;
          this.mainLoading = false;
          this.loadingInsertListing = false;

          this.ref.detectChanges();
        }
      }
    );

    this.styleService.stylesChanged
    .takeUntil(this.destroy$)
    .subscribe(
      (styles: any) => {
        if ( typeof styles !== 'undefined' && styles.status === 'success' ) {
          if ( styles.data.length > 0 ) {
            styles = styles.data;

            let styleIndex = styles.findIndex(styl => styl.client_id === this.template.client_id);

            if (styleIndex === -1) {
              styleIndex = 0;
            }

            if (this.template.master.enable_ckeditor === 1) {
              this.plugins = ['grapesjs-tui-editor', 'gjs-plugin-ckeditor'];
              this.ckeditor_active = true;
            } else {
              this.plugins = ['grapesjs-tui-editor'];
            }

            if (this.template.master.enable_contenteditable === 1) {
              this.enable_contenteditable = true;
            }

            this.initEditor();

            this.style = styles[styleIndex];
            this.initBuild();
            this.initStyle();
          } else {
            swal(
              'Missing Builder Style',
              'Contact MyDesign Support',
              'error'
            );
          }
        }
      }
    );

    this.templateService.templateBuild
    .takeUntil(this.destroy$)
    .subscribe(
      (template: any) => {

        if ( typeof template.ID !== 'undefined' ) {
          this.loading = false;

          if ( this.isSendToVault ) {
            this.vaultService.httpSendTemplate({
              title: `MD3: ${this.template.title}`,
              subject: this.template.title,
              content: '',
              propertyTemplate: false,
              template_id: this.template.ID
            });
          } else {
            let swalTitle = 'Saved!';
            let swalContent = 'Your template has been saved.';
            let imageExtension = 'jpg';

            if (template.category_id === 6 || template.category_id === 7) {
              imageExtension = 'png';
            }
            if (this.pdfButtonClicked === true) {
              const pdf_url = $this.frontService.appConfig.S3_URL + template.additional_data.pdf_path;

              const link = document.createElement('a');
              link.download = $this.template.title + '.pdf';
              link.href = pdf_url;
              link.target = '_blank';
              document.body.appendChild(link);
              link.click();
              link.remove();

              this.pdfButtonClicked = false;

              swalTitle = 'Downloaded';
              swalContent = `Your template has been downloaded. <br>
              When printing PDF make sure to select the \'Fit to Page\' or \'Scale to Fit\' options to ensure print quality
              `;
            }

          if (this.imgButtonClicked === true) {
            const pdf_url = $this.frontService.appConfig.S3_URL + template.additional_data.image_path;

              const link = document.createElement('a');
              link.download = $this.template.title + '_' + $this.template.thumbnail;
              link.href = pdf_url;
              link.target = '_blank';
              document.body.appendChild(link);
              link.click();
              link.remove();

              this.imgButtonClicked = false;

              swalTitle = 'Downloaded';
              swalContent = 'Your template has been downloaded.';

            }

          if (this.fbButtonClicked === true) {
            this.imageUrl = $this.frontService.appConfig.S3_URL + template.additional_data.image_path;

              window.open(
                'https://www.facebook.com/sharer/sharer.php?u=' + this.imageUrl + '?_=' + new Date().getTime(),
                'sharer',
                'toolbar=0,status=0,width=626,height=436'
              );
              this.fbButtonClicked = false;

              return true;
            }

          if (this.twitterButtonClicked === true) {
            this.imageUrl = $this.frontService.appConfig.S3_URL + template.additional_data.image_path;

              window.open(
                'https://twitter.com/home?status=' + this.imageUrl + '?_=' + new Date().getTime(),
                'sharer',
                'toolbar=0,status=0,width=626,height=436'
              );
              this.twitterButtonClicked = false;

              return true;
            }

          if (this.linkedinButtonClicked === true) {
            this.imageUrl = $this.frontService.appConfig.S3_URL + template.additional_data.image_path;

              window.open(
                'https://www.linkedin.com/shareArticle?mini=true&url=' + this.imageUrl + '?_=' + new Date().getTime(),
                'sharer',
                'toolbar=0,status=0,width=626,height=436'
              );
              this.linkedinButtonClicked = false;

              return true;
            }

            if (this.loading === false && this.savePopupShow === true) {
              swal({
                title: swalTitle,
                html: swalContent,
                type: 'success'
              });
            }
            this.savePopupShow = true;
          }
        }
      }
    );

    this.vaultService.onVaultSendTemplate.subscribe(
      (vault: any) => {
        if ( typeof vault !== 'undefined' && vault.status === 'success' ) {
          this.loading = false;
          swal({
            title: 'Template has been added/saved to your VaultRE account',
            type: 'success',
            html:
            // tslint:disable-next-line:max-line-length
            '<a target="_blank" href="https://login.vaultre.com.au/cgi-bin/clientvault/emarketing/bulk.cgi?messagetype=designly&designlytemplateid=' + vault.data.id + '" class="btn btn-primary">View</a>',
            showCancelButton: false,
            showConfirmButton: false,
            focusConfirm: false
          });
        }
      }
    );

    this.myDesktopService.myDesktopsListingsChanged
    .takeUntil(this.destroy$)
    .subscribe(
      (listings: any) => {
        $('#propertyList').find('.no-result').remove();

        if ( typeof listings !== 'undefined' && listings
          && typeof listings.data !== 'undefined' && listings.data && listings.data.length > 0 ) {
          this.subLoading = false;

          this.mdListings = listings.data;
          this.mdListingCount = listings.count;
          this.mdListingTotal = listings.total;

          this.mdListingPages = [];

          if ( this.mdListingTotal > 50 && this.frontService.authService.getApp() === 'MyDesign3' ) {
            const pageNumber = Math.ceil(this.mdListingTotal / 50);

            for (let page = 1; page <= pageNumber; page++) {
              this.mdListingPages.push(page);
            }
          }

          if ( this.frontService.authService.getApp() === 'Designly' && this.authUser.provider === 'vaultre' ) {
            this.showDesignlyPreviousPage = false;
            this.showDesignlyNextPage = false;

            if ( listings.prev !== null ) {
              this.designlyPreviousLink = listings.prev;
              this.showDesignlyPreviousPage = true;
            }

            if ( listings.next !== null ) {
              this.designlyNextLink = listings.next;
              this.showDesignlyNextPage = true;
            }
          }

          this.mdSuburbs = [];
          this.mdTypes = [];
          this.mdClassifications = [];
          this.mdStatuses = [];

          for (const listing of listings.data) {
            if ( typeof listing.address_suburb !== 'undefined' && !this.mdSuburbs.includes(listing.address_suburb)) {
              this.mdSuburbs.push(listing.address_suburb);
            }
            this.mdSuburbs.sort();
            if ( typeof listing.listing_type !== 'undefined' && !this.mdTypes.includes(listing.listing_type)) {
              this.mdTypes.push(listing.listing_type);
            }
          }
        }

        if ( typeof listings !== 'undefined' && listings
          && typeof listings.data !== 'undefined' && listings.data && listings.data.length === 0 ) {
          this.subLoading = false;
          this.mdListings = listings.data;
          this.mdListingTotal = 0;
          this.mdListingCount = 0;
          this.mdListingCurrentPage = 1;
          this.mdListingPages = [];

          $('#propertyList').prepend(
            $('<h2>').addClass('no-result').html('No result found!')
          );
        }
      }
    );

    this.myDesktopService.myDesktopCustomParams
    .takeUntil(this.destroy$)
    .subscribe(
      (dataCustomParams: any[]) => {
        if ( typeof dataCustomParams !== 'undefined' && dataCustomParams.length > 0 ) {
          this.mdCustomParams = dataCustomParams;
          const _params = dataCustomParams.slice();
          _params.forEach( (param) => {
            const _key = Object.keys(param)[0];
            const _values = param[_key];
            const _index = this.selectedListings.findIndex(sListings => sListings.id === +_key);

            if ( _index !== -1) {
              this.selectedListings[_index]['inspections'] = null;
              if ( typeof _values.inspections !== 'undefined' ) {
                this.selectedListings[_index]['inspections'] = _values.inspections;
              }
              this.selectedListings[_index]['sales'] = null;
              if ( typeof _values.sales !== 'undefined' ) {
                this.selectedListings[_index]['sales'] = _values.sales;
              }
            }
          });

          this.activateInsertListing = true;
          this.loadingInsertListing = false;
          this.subLoading = false;

          if (this.selectedListingIDs.length === 0 ) {
            this.activateInsertListing = false;
          }
        }
      }
    );

    this.mdListingsForm = new FormGroup({
      'suburb': new FormControl(''),
      'classification': new FormControl(''),
      'listingtype': new FormControl(''),
      'status': new FormControl(''),
      'substatus': new FormControl(''),
      'available': new FormControl(''),
      'officeid': new FormControl(''),
      'agentid': new FormControl(''),
      'pricefrom': new FormControl(''),
      'priceto': new FormControl(''),
      'bedfrom': new FormControl(''),
      'bedto': new FormControl(''),
      'bathfrom': new FormControl(''),
      'bathto': new FormControl(''),
      'carfrom': new FormControl(''),
      'carto': new FormControl(''),
      'local_search': new FormControl('0'),
      'client_id': new FormControl(''),
      'orderby': new FormControl('modifydateDesc'),
      'multioffice': new FormControl(false),
      'basedon': new FormControl('')
    });

    this.libraryStorageForm = new FormGroup({
      'type': new FormControl('owned')
    });

    this.supportService.onScreenshot
    .subscribe(
      ( response: boolean ) => {
        if ( response ) {
          this.showScreenshot = true;
          $('#supportModal').modal('hide');
        }
      }
    );

    this.supportService.onProcessed
    .subscribe(
      ( response: boolean ) => {
        if ( response ) {
          this.loading = false;
        }
      }
    );

    this.imageService.onCloseLibrary
    .takeUntil(this.destroy$)
    .subscribe(
      (response) => {
        if ( response ) {
        this.mdLibrarySearchModalClose.nativeElement.click();
        this.showImageLibrary = false;

        this.ref.detectChanges();
      }
    });

    this.particaService.onBuilderModalClose
    .takeUntil(this.destroy$)
    .subscribe(
      (response) => {
        if (response) {
          this.mdParticaSearchModalClose.nativeElement.click();
          this.showPartica = false;

          this.ref.detectChanges();
        }
      }
    );

    this.particaService.onBuilderInsertArticle
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && typeof response.articleId !== 'undefined' ) {
          this.onSelectedArticle(response);
          this.mdParticaSearchModalClose.nativeElement.click();
          this.showPartica = false;

          this.ref.detectChanges();
        }
      }
    );

    this.vaultService.onVaultGetListing
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && typeof response.status !== 'undefined' ) {
          this.activateInsertListing = true;
          this.loadingInsertListing = false;
          this.subLoading = false;

          if (this.selectedListingIDs.length === 0 ) {
            this.activateInsertListing = false;
          }

          if ( typeof response.data !== 'undefined' && typeof response.data.id !== 'undefined' ) {
            this.mdListings = this.mdListings.filter( (listing, index) => {
              if ( response.data.id === listing.id ) {
                listing.url = response.data.url;
                listing.inspections = response.data.inspections;

                return listing;
              }

              return listing;
            });
          }

          this.ref.detectChanges();
        }
      }
    );

    this.domainService.onGetDomainListing
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && typeof response.status !== 'undefined' ) {
          this.activateInsertListing = true;
          this.loadingInsertListing = false;
          this.subLoading = false;

          if (this.selectedListingIDs.length === 0 ) {
            this.activateInsertListing = false;
          }

          if ( typeof response.data !== 'undefined' && typeof response.data.id !== 'undefined' ) {
            this.mdListings = this.mdListings.filter( (listing, index) => {

              if ( response.data.id === String(listing.id) ) {
                listing.agent1 = listing.agent_primary = response.data.agents[0];
                listing.agent2 = response.data.agents[1];

                return listing;
              }

              return listing;
            });
          }

          console.log(this.mdListings);
        }
      }
    );
  }

  initEditor() {
    const $this = this;

    this.editor = grapesjs.init({
      container : '#builder-html',
      height: '100%',
      panels: {
        defaults: []
      },
      deviceManager: {
        devices: [
          {name: 'Desktop', width: '900px' },
          {name: 'Desktop view', width: '901px' },
          {name: 'Mobile portrait', width: '330px'},
          {name: 'A4 portrait', width: '821px'},
          {name: 'A4 landscape', width: '1144px'},
          {name: 'A3 portrait', width: '1104px'},
          {name: 'A3 landscape', width: '97%'},
          {name: 'FB cover', width: '832px'},
          {name: 'FB post', width: '944px'},
          {name: 'IG post', width: '1092px'},
          {name: 'DL card', width: '821px'},
          {name: 'Portrait 1200x1800', width: '197mm' },
          {name: 'Portrait 1200x2400', width: '1178px' },
          {name: 'Landscape 1800x1200', width: '1168px' },
          {name: 'Landscape 1750x1130', width: '1168px' },
          this.template_custom_attribute
        ],
      },
      storageManager: {
        type: 'remote',
        autosave: false,
        autoload: false
      },
      autorender: false,
      plugins: this.plugins,
      pluginsOpts: {
        'grapesjs-tui-editor': {
          config: {
            includeUI: {
              menuBarPosition: 'top'
            }
          },
          hideHeader: 1,
          onApply: function(imageEditor, imageModel) {
            $this.image_editor = imageEditor;
            $this.image_model = imageModel;

            const migrateData = [];
            migrateData['template_id'] = $this.template.ID;
            migrateData['client_id'] = $this.template.client_id;
            migrateData['file'] = imageEditor.toDataURL({
              'format': 'png'
            });

            $this.storageService.httpPostMigrateToS3( migrateData );
            $('.tui-editor-backdrop').css('display', 'block');
          },
          apiUrl: this.frontService.appConfig.API_ENDPOINT
        }
      },
      copyPaste: false,
      avoidInlineStyle: false,
      keepEmptyTextNodes: true,
      forceClass: false,
      showDevices: false
    });

    if (this.ckeditor_active) {
      CKEDITOR.config.coreStyles_bold = { element: 'b', overrides: 'strong' };
      CKEDITOR.on('dialogDefinition', function(ev) {
        try {
          const dialogName = ev.data.name;
          const dialogDefinition = ev.data.definition;

          if (dialogName === 'link') {
              const informationTab = dialogDefinition.getContents('target');
              const targetField = informationTab.get('linkTargetType');
              targetField['default'] = '_blank';
          }
        } catch (exception) {
            alert('Error ' + ev.message);

        }
      });

      CKEDITOR.on('instanceReady', function (e) {
          const editor = e.editor;
          editor.on('paste', function(ev) {
            if (!$this.pasteService.paste_alert) {
            swal({
              title: `MyDesign has detected that you have pasted text from another system.
                      Please note only text from notepad or text editor will guarantee no formatting issues.`,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              cancelButtonText: 'Close',
              confirmButtonText: 'Do not show this message again',
              confirmButtonClass: 'btn-paste-warning',
              cancelButtonClass: 'btn-paste-cancel'
            }).then(function (data) {
              $this.pasteService.paste_alert = true;
              const user = {
                paste_alert: 1
              };
              $this.userService.httpPutUserByAgentID($this.frontService.authService.auth.agentid, user);
            }).catch(swal.noop);
          }
          });

          editor.disableAutoInline = true;
       });
    }

    const comps = this.editor.DomComponents;

    const originalTable = comps.getType('table');
    const originalCell = comps.getType('cell');
    const originalRow = comps.getType('row');
    const originalTBody = comps.getType('tbody');

    const originalImage = comps.getType('image');
    const originalDefault = comps.getType('default');
    const originalText = comps.getType('text');
    const originalTextNode = comps.getType('textnode');

    const originalLink = comps.getType('link');

    comps.addType('comment', {
      model: originalTextNode.model.extend({
        toHTML() {
          return `<!--${this.get('content')}-->`;
        },
      }, {
        isComponent(el) {
          if (el.nodeType === 8) {
            return {
              tagName: 'NULL', // just need this to avoid some parser rule
              type: 'comment',
              content: el.textContent
            };
          }
        },
      }),
      view: originalTextNode.view.extend({
        render: function() {
          const content = String(this.model.attributes.content);

          if ( content.includes('PIDLIST') ) {
            return this;
          }

          this.el = document.createComment(this.model.attributes.content);
          return this;
        }
      })
    });

    comps.addType('table', {
      model: originalTable.model.extend({
        defaults: Object.assign({}, originalTable.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          hoverable: false,
          selectable: false,
          toolbar: null
        })
      }),
      view: originalTable.view
    });

    comps.addType('tbody', {
      model: originalTBody.model.extend({
        defaults: Object.assign({}, originalTBody.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          toolbar: null
        })
      }),
      view: originalTBody.view
    });

    comps.addType('row', {
      model: originalRow.model.extend({
        defaults: Object.assign({}, originalRow.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          toolbar: null
        })
      }),
      view: originalRow.view
    });

    comps.addType('cell', {
      model: originalCell.model.extend({
        defaults: Object.assign({}, originalCell.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          toolbar: null
        })
      }),
      view: originalCell.view
    });

    comps.addType('mdspacer', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          toolbar: null
        }),
      }, {
        isComponent: function(el) {
          const elm = $(el);
          if ( elm.hasClass('md-spacer') ) {
            return {type: 'mdspacer'};
          }
        },
      }),
      view: originalDefault.view
    });

    comps.addType('md-removable', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          copyable: false,
          layerable: true
        }),
      }, {
        isComponent(el) {
          const elm = $(el);
          if ( elm.hasClass('md-removable') ) {
            return {type: 'md-removable'};
          }
        },
      }),
      view: originalDefault.view
    });

    comps.addType('text', {
      model: originalText.model.extend({
        defaults: Object.assign({}, originalText.model.prototype.defaults, {
          hoverable: false,
          editable: true,
          draggable: false,
          droppable: false,
          copyable: false,
          badgable: false
        }),
      }),
      view: originalText.view
    });

    comps.addType('md-prop-search', {
      model: originalImage.model.extend({
        defaults: Object.assign({}, originalImage.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          copyable: false,
          badgable: false,
          stylable: true
        }),
      }, {
        isComponent: function(el) {
          const elm = $(el);
          if ( elm.hasClass('md-prop-search') ) {
            return {type: 'md-prop-search'};
          }
        },
      }),
      view: originalImage.view.extend({
        events: {
          mouseleave: 'handleMouseLeave',
          click: 'handleClick'
        },
        handleMouseLeave: function(e) {
          $this.enable_zoom = false;
          $this.disableZoom();

        },
        handleClick: function(e) {
          $this.enable_zoom = true;
          $this.enableZoom();

          const parentEl = this.model.view.$el.parent();
          const iframeLeft = $('iframe').offset().left;
          const panelWidth = $('.gjs-pn-views-container').width();
          const iframeScrollTop = $('iframe').contents().find('body').scrollTop();
          const parentOffsetTop =  (iframeScrollTop + parentEl.offset().top + 2) + 'px';
          let parentOffsetLeft = ((iframeLeft - panelWidth) + parentEl.offset().left - 8) + 'px';

          if ( $this.frontService.authService.getApp() === 'Designly' ) {
            parentOffsetLeft = (iframeLeft + parentEl.offset().left) + 'px';
          }

          $('#tb_overwrite').remove();
          $('head').append(`
            <style id="tb_overwrite">
            .tb_overwrite {
              top:` + parentOffsetTop + ` !important;
              left: ` + parentOffsetLeft + ` !important;
            }
            </style>
          `);
        },
        render: function() {
          originalImage.view.prototype.render.apply(this, arguments);

          const tb = this.model.get('toolbar');

          const editorTbExist = tb.find(
            function (tbi) {
              return tbi.command === 'tui-image-editor';
            }
          );

          if (typeof editorTbExist === 'undefined') {
            tb.push({
              attributes: {class: 'fa fa-pencil', title: 'Edit Image'},
              command: 'tui-image-editor',
            });
          }

          if ($this.template.category_id !== 7 &&
             $this.template.category_id !== 1 &&
             $this.template.category_id !== 2 &&
             $this.template.category_id !== 3) {

            const isExist2 = tb.find(
              function (tbi) {
                return tbi.command === 'md-el-image-fit';
              }
            );

            if (typeof isExist2 === 'undefined') {
              tb.push({
                attributes: {class: 'fa fa-expand', title: 'Fit Image'},
                command: 'md-el-image-fit',
              });
            }
          }

          const isExist = tb.find(
            function (tbi) {
              return tbi.command === 'md-el-prop-search';
            }
          );

          if (typeof isExist === 'undefined') {
            tb.push({
              attributes: {class: 'fa fa-search', title: 'Property Search'},
              command: 'md-el-prop-search',
            });
          }

          this.model.set('toolbar', tb);

          return this;
        }
      })
    });

    comps.addType('md-library-search', {
      model: originalImage.model.extend({
        defaults: Object.assign({}, originalImage.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          copyable: false,
          badgable: false,
          stylable: true,
        }),
      }, {
        isComponent: function(el) {
          const elm = $(el);
          if ( elm.hasClass('md-library-search') ) {
            return {type: 'md-library-search'};
          }
        },
      }),
      view: originalImage.view.extend({
        events: {
          mouseleave: 'handleMouseLeave',
          click: 'handleClick'
        },
        handleMouseLeave: function(e) {
          $this.enable_zoom = false;
          $this.disableZoom();
        },
        handleClick: function(e) {
          $this.enable_zoom = true;
          $this.enableZoom();

          const parentEl = this.model.view.$el.parent();
          const iframeLeft = $('iframe').offset().left;
          const panelWidth = $('.gjs-pn-views-container').width();
          const iframeScrollTop = $('iframe').contents().find('body').scrollTop();
          const parentOffsetTop =  (iframeScrollTop + parentEl.offset().top + 2) + 'px';
          let parentOffsetLeft = ((iframeLeft - panelWidth) + parentEl.offset().left - 8) + 'px';

          if ( $this.frontService.authService.getApp() === 'Designly' ) {
            parentOffsetLeft = (iframeLeft + parentEl.offset().left) + 'px';
          }

          $('#tb_overwrite').remove();
          $('head').append(`
            <style id="tb_overwrite">
            .tb_overwrite {
              top:` + parentOffsetTop + ` !important;
              left: ` + parentOffsetLeft + ` !important;
            }
            </style>
          `);
        },
        render: function() {
          originalImage.view.prototype.render.apply(this, arguments);

          const tb = this.model.get('toolbar');

          const editorTbExist = tb.find(
            function (tbi) {
              return tbi.command === 'tui-image-editor';
            }
          );

          if (typeof editorTbExist === 'undefined') {
            tb.push({
              attributes: {class: 'fa fa-pencil', title: 'Edit Image'},
              command: 'tui-image-editor',
            });
          }

          const isExist = tb.find(
            function (tbi) {
              return tbi.command === 'md-el-image-gallery';
            }
          );

          if (typeof isExist === 'undefined') {
            tb.push({
              attributes: {class: 'fa fa-image', title: 'Image Gallery'},
              command: 'md-el-image-gallery',
            });
          }

          if ($this.template.category_id !== 7 &&
             $this.template.category_id !== 1 &&
             $this.template.category_id !== 2 &&
             $this.template.category_id !== 3) {
            const isExist2 = tb.find(
              function (tbi) {
                return tbi.command === 'md-el-image-fit';
              }
            );

            if (typeof isExist2 === 'undefined') {
              tb.push({
                attributes: {class: 'fa fa-expand', title: 'Fit Image'},
                command: 'md-el-image-fit',
              });
            }
          }

          this.model.set('toolbar', tb);

          return this;
        }
      })
    });

    if ( this.authUser.provider === 'mydesktop' ) {
      comps.addType('md-article-search', {
        model: originalImage.model.extend({
          defaults: Object.assign({}, originalImage.model.prototype.defaults, {
            draggable: false,
            droppable: false,
            removable: false,
            copyable: false,
            badgable: false,
            stylable: true
          }),
        }, {
          isComponent: function(el) {
            const elm = $(el);
            if ( elm.hasClass('md-article-search') ) {
              return {type: 'md-article-search'};
            }
          },
        }),
        view: originalImage.view.extend({
          events: {
            mouseleave: 'handleMouseLeave',
            click: 'handleClick'
          },
          handleMouseLeave: function(e) {
            $this.enable_zoom = false;
            $this.disableZoom();

          },
          handleClick: function(e) {
            $this.enable_zoom = true;
            $this.enableZoom();

            const parentEl = this.model.view.$el.parent();
            const iframeLeft = $('iframe').offset().left;
            const panelWidth = $('.gjs-pn-views-container').width();
            const iframeScrollTop = $('iframe').contents().find('body').scrollTop();
            const parentOffsetTop =  (iframeScrollTop + parentEl.offset().top + 2) + 'px';
            let parentOffsetLeft = ((iframeLeft - panelWidth) + parentEl.offset().left - 8) + 'px';

            if ( $this.frontService.authService.getApp() === 'Designly' ) {
              parentOffsetLeft = (iframeLeft + parentEl.offset().left) + 'px';
            }

            $('#tb_overwrite').remove();
            $('head').append(`
              <style id="tb_overwrite">
              .tb_overwrite {
                top:` + parentOffsetTop + ` !important;
                left: ` + parentOffsetLeft + ` !important;
              }
              </style>
            `);
          },
          render: function() {
            originalImage.view.prototype.render.apply(this, arguments);

            const tb = this.model.get('toolbar');

            const editorTbExist = tb.find(
              function (tbi) {
                return tbi.command === 'tui-image-editor';
              }
            );

            if (typeof editorTbExist === 'undefined') {
              tb.push({
                attributes: {class: 'fa fa-pencil', title: 'Edit Image'},
                command: 'tui-image-editor',
              });
            }

            const isExist = tb.find(
              function (tbi) {
                return tbi.command === 'md-el-article-search';
              }
            );

            if (typeof isExist === 'undefined') {
              tb.push({
                attributes: {class: 'fa fa-search article-search', title: 'Article Search'},
                command: 'md-el-article-search',
              });
            }

            this.model.set('toolbar', tb);
            return this;
          }
        })
      });
    }

    comps.addType('mdbox', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          droppable: false,
          highlightable: false,
          layerable: true,
          badgable: false,
        }),
      }, {
        isComponent: function(el) {
          const elm = $(el);
          if ( elm.hasClass('md-box') ) {
            return {type: 'mdbox'};
          }
        },
      }),
      // view: originalDefault.view
      view: originalDefault.view
    });

    comps.addType('custom-link', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          highlightable: false,
          layerable: true,
          badgable: false,
          selectable: false,
          copyable: false,
          stylable: false,
          hoverable: false,
          editable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);
          if ( elm.hasClass('md-updatable-anchor') ) {
            // elm.attr('draggable', false);
            return {type: 'custom-link'};
          }
        },
      }),
      // view: originalDefault.view
      view: originalDefault.view.extend({
        events: {
          dblclick: 'handleClick'
        },
        handleClick: function(e) {
          const linkElement = $(this.el);
          const dataLink = $(linkElement).data('link');
          let linkTitle = '';

          let anchorText = linkElement.html();
          let anchorLink = linkElement.attr('href');
          let html = '';

          const is_mail = String(anchorLink).includes('mailto');
          const is_phone = String(anchorLink).includes('tel');

          let isHttps = false;

          if ( is_mail ) {
            anchorLink = String(anchorLink).replace('mailto:', '');
            $this.updateable_link_type = 'mail';
          } else if ( is_phone) {
            anchorLink = String(anchorLink).replace('tel:', '');
            $this.updateable_link_type = 'tel';
          } else {
            if ( String(anchorLink).includes('https') ) {
              isHttps = true;
            } else {
              isHttps = false;
            }

            anchorLink = String(anchorLink).replace('https://', '').replace('http://', '').replace('data%md3%-', 'data-');
            $this.updateable_link_type = 'url';
          }

          if (linkElement.children().is('img')) {
            html = `
            <div class="row" style="text-align: left">
              <div class="col-md-12" style="margin-bottom: 10px;">
                <label for="mdl-link-type">Link Type</label>
                <select id="mdl-link-type"
                 class="form-control" style="border: 1px solid #d3d3d3 !important">
                  <option value="url" ` + ( is_mail || is_phone ? '' : 'selected') + `>URL</option>
                  <option value="mail" ` + ( is_mail ? 'selected' : '') + `>Mail</option>
                  <option value="tel" ` + ( is_phone ? 'selected' : '') + `>Telephone</option>
                </select>
              </div>
              <div class="mdl-link-holder col-md-3 ` + ( (is_mail || is_phone) ? 'hidden' : '') + `">
                <select id="mdl-url-types" class="form-control" style="border: 1px solid #d3d3d3 !important">
                  <option value="http://" ` + ( !isHttps ? 'selected' : '') + `>http://</option>
                  <option value="https://" ` + ( isHttps ? 'selected' : '') + `>https://</option>
                </select>
              </div>
              <div class="col-md-9">
                <input
                  id="anchorLink"
                  placeholder="Href"
                  value="` + $.trim(anchorLink) + `"
                  onpaste="onAnchorPaste()"
                  class="form-control mb-1"
                  style="border: 1px solid #e8e8e8">
              </div>
            `;
          } else {
            html = `
            <p>Please enter your desired url below.
            Please note this will not update the link in your settings, only the link for this field.</a>
            <br />
            <br />
            Link Name:
             <input
              id="anchorText"
              placeholder="Label"
              value="` + $.trim(anchorText) + `"
              class="form-control mb-1"
              style="border: 1px solid #e8e8e8">
            <br />
            <div class="row" style="text-align: left">
              <div class="col-md-12" style="margin-bottom: 10px;">
                <label for="mdl-link-type">Link Type</label>
                <select id="mdl-link-type" onchange="onModalLinkTypeChange()"
                 class="form-control" style="border: 1px solid #d3d3d3 !important">
                  <option value="url" ` + ( ( is_mail || is_phone ) ? '' : 'selected') + `>URL</option>
                  <option value="mail" ` + ( is_mail ? 'selected' : '') + `>Mail</option>
                  <option value="tel" ` + ( is_phone ? 'selected' : '') + `>Telephone</option>
                </select>
              </div>
              <div class="mdl-link-holder col-md-3 ` + ( ( is_mail || is_phone ) ? 'hidden' : '') + `">
                <select id="mdl-url-types" class="form-control" style="border: 1px solid #d3d3d3 !important">
                  <option value="http://" ` + ( !isHttps ? 'selected' : '') + `>http://</option>
                  <option value="https://" ` + ( isHttps ? 'selected' : '') + `>https://</option>
                </select>
              </div>
              <div class="col-md-9">
                <input
                  id="anchorLink"
                  placeholder="Href"
                  value="` + $.trim(anchorLink) + `"
                  onpaste="onAnchorPaste()"
                  class="form-control mb-1"
                  style="border: 1px solid #e8e8e8">
              </div>
            `;
          }

          if (dataLink === undefined) {
            linkTitle = 'Link Destination';
          } else {
            linkTitle = dataLink;
          }

          const model = this.model;
          swal({
            title: linkTitle,
            html: html,
            showCancelButton: true,
            confirmButtonText: 'Update',
            showLoaderOnConfirm: true,
            preConfirm: function (data) {
              return new Promise(function (resolve, reject) {
                setTimeout(function() {
                    resolve();
                }, 200);
              });
            },
            allowOutsideClick: false
          }).then(function (data) {

            const anchorType = $('#mdl-link-type').val();
            anchorText = $('#anchorText').val();
            anchorLink = $('#anchorLink').val();

            if ( anchorType === 'url' ) {
              if ( !String(anchorLink).includes('{%') ) {
                anchorLink = String(anchorLink).replace('https://', '').replace('http://', '').replace('data-', 'data%md3%-');

                const url_type = $('#mdl-url-types').val();
                anchorLink = url_type + anchorLink;
              }
            } else {
              if ( String(anchorLink).includes('{%') ) {
                anchorLink = anchorLink;
              } else {
                if ( anchorType === 'tel' ) {
                  anchorLink = 'tel:' + anchorLink;
                } else {
                  anchorLink = 'mailto:' + anchorLink;
                }
              }
            }

            if (linkElement.children().is('img')) {
              model.setAttributes({'href': anchorLink, 'data-updated': true});
            } else {
              model.set('content', anchorText);
              model.setAttributes({'href': anchorLink, 'data-updated': true});
            }

          }).catch(swal.noop);
        },
        render: function() {
          originalDefault.view.prototype.render.apply(this, arguments);

          // Fix dragging issue of anchor tag element
          const model = this.model;
          model.addAttributes({draggable: false});

          return this;
        }
      })
    });

    comps.addType('span-b-em-u-i-strong', {
      model: originalText.model.extend({
        defaults: Object.assign({}, originalText.model.prototype.defaults, {
          editable: false,
          selectable: false,
          badgable: false,
          droppable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);
          if ( elm.is('span') || elm.is('b') || elm.is('em') || elm.is('u') || elm.is('i') || elm.is('strong') ) {
            return {type: 'span-b-em-u-i-strong'};
          }
        },
      }),
      view: originalText.view.extend({
        events: {
          dblclick: 'handleClick'
        },
        handleClick: function(e) {
          const parentEl = this.model.view.$el.parents('p');

          parentEl.trigger('dblclick');
        }
      })
    });

    // comps.addType('custom-image', {
    //   model: originalDefault.model.extend({
    //     defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
    //       draggable: false
    //     })
    //   })
    // });

    comps.addType('p-editable-w-spans', {
      model: originalText.model.extend({
        defaults: Object.assign({}, originalText.model.prototype.defaults, {
          droppable: false,
          badgable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);
          if ( elm.is('p') && ( elm.has('span') || elm.has('b') || elm.has('em') || elm.has('u') || elm.has('i') || elm.has('strong')) ) {
            return {type: 'p-editable-w-spans'};
          }
        },
      }),
      view: originalText.view
    });

    comps.addType('md-content-editable', {
      model: {
        isComponent(el) {
          const elm = $(el);
          if ( elm.hasClass('md-content-editable') && elm.is('div') ) {
            return {type: 'text'};
          }
        },
      }
    });

    comps.addType('non-droppable-ul', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          droppable: false,
          badgable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);

          if ( elm.is('ul') ) {
            return {type: 'non-droppable-ul'};
          }
        },
      }),
      view: originalDefault.view
    });

    comps.addType('non-droppable-li', {
      model: originalText.model.extend({
        defaults: Object.assign({}, originalText.model.prototype.defaults, {
          droppable: false,
          badgable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);

          if (  elm.is('li') ) {
            return {type: 'non-droppable-li'};
          }
        },
      }),
      view: originalText.view
    });

    comps.addType('a-link', {
      model: originalLink.model.extend({
        defaults: Object.assign({}, originalLink.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          badgable: false,
          copyable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          editable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);
          if ( elm.is('a') && (elm.has('img') && !elm.hasClass('md-updatable-anchor')) ) {
            return {type: 'a-link'};
          }
        },
      }),
      view: originalLink.view.extend({
        render: function() {
          originalLink.view.prototype.render.apply(this, arguments);

          // Fix dragging issue of anchor tag element
          const model = this.model;
          model.setAttributes(Object.assign({}, model.getAttributes(), {draggable: false}));

          return this;
        }
      })
    });
    comps.addType('md-uneditable', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          editable: false,
          toolbar: null
        }),
      }, {
        isComponent: function(el) {
          const elm = $(el);
          if ( elm.hasClass('md-uneditable') ) {
            return {type: 'md-uneditable'};
          }
        },
      }),
      view: originalDefault.view
    });

    this.editor.render();

    if ( this.template.category_id === 1 ) {
        const _tmp_html = '#wrapper {' +
              'overflow: auto;' +
              'overflow-x: hidden !important;' +
              'overflow-y: hidden !important;}';
      const iframe = $(this.builder.nativeElement).find('iframe').contents();
      iframe.find('head').append( $('<style>').text(_tmp_html) );
    }

    const iframeBody = this.editor.Canvas.getBody();
    $(iframeBody).on('paste', '[contenteditable="true"]', function(e) {

      if ( !$this.ckeditor_active ) {
        e.preventDefault();
        const text = e.originalEvent.clipboardData.getData('text');
        e.target.ownerDocument.execCommand('insertText', false, text);
      }

      const $el = $(this);
      setTimeout(function () {
        let html = $el.html();
        html = $this.stripSmartQuotes(html);
        $el.html(html);
      });

    });

    $('.gjs-cv-canvas').attr('id', 'gjs-ck-editor-test');
  }

  initBuild() {
    const thisRouter = this.router;
    const thisRoute = this.route;
    const $this = this;

    const panelManager = this.editor.Panels;
    const blockManager = this.editor.BlockManager;
    const commands = this.editor.Commands;

    if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
      const leftPanel = panelManager.addPanel({
        id: 'left-control',
        buttons: [{
          id: 'back',
          className: 'fa fa-arrow-left',
          command: 'back',
          attributes: {['title']: 'Back'}
        }]
      });

      const rightPanel = panelManager.addPanel({
        id: 'right-control',
        buttons: [
        {
          id: 'undo',
          className: 'fa fa-undo',
          command: 'undo',
          attributes: {['title']: 'Undo'}
        }, {
          id: 'redo',
          className: 'fa fa-repeat',
          command: 'redo',
          attributes: {['title']: 'Redo'}
        }, {
          id: 'send',
          className: 'btn-html-send',
          command: 'send',
          attributes: {['title']: 'Send'}
        }, {
          id: 'facebook',
          className: 'fa fa-facebook',
          command: 'fbshare',
          attributes: {['title']: 'Share on Facebook'}
        },  {
          id: 'twitter',
          className: 'fa fa-twitter',
          command: 'twittershare',
          attributes: {['title']: 'Share on Twitter'}
        }, {
          id: 'linkedin',
          className: 'fa fa-linkedin',
          command: 'linkedinshare',
          attributes: {['title']: 'Share on LinkedIn'}
        },
        {
          id: 'save',
          className: 'icon feather icon-save',
          command: 'save',
          attributes: {['title']: 'Save'}
        },
        {
          id: 'saveoptions',
          className: 'btn-html-save-campaign',
          command: 'saveoptions',
          attributes: {['title']: 'Save Options'}
        },
        {
          id: 'save-quick',
          className: 'btn-save-quick',
          command: 'save-quick',
          attributes: {['title']: 'Quick Design'}
        },
        {
          id: 'save-quick-office',
          className: 'btn-save-quick-office',
          command: 'save-quick-office',
          attributes: {['title']: 'Office Quick Design'}
        },
        {
          id: 'pdf',
          className: 'btn-html-pdf',
          command: 'pdf',
          attributes: {['title']: 'PDF'}
        },
        {
          id: 'xhtml',
          className: 'btn-html-html',
          command: 'xhtml',
          attributes: {['title']: 'HTML'}
        },
        {
          id: 'img',
          className: 'btn-html-img',
          command: 'img',
          attributes: {['title']: 'Image'}
        }, {
          id: 'tour',
          className: 'btn-html-tour',
          command: 'tour',
          attributes: {['title']: 'Start Tour'}
        }, {
          id: 'help',
          className: 'btn-html-help',
          command: 'help',
          attributes: {['title']: 'Help'}
        }
        ]
      });
  
      const controlPanel = panelManager.addPanel({
        id: 'controls',
        buttons: [
        {
          id: 'fullscreen',
          command: 'fullscreen',
          className: 'fa fa-arrows-alt html-arrow',
          attributes: {['title']: 'Full Screen'},
        }, {
          id: 'clean-all',
          command: 'clean-all',
          className: 'fa fa-trash html-trash',
          attributes: {['title']: 'Clean Canvas'},
        }
        ]
      });
  
      const devicePanel = panelManager.addPanel({
        id: 'devices',
        buttons: [{
          id: 'set-device-desktop',
          command: 'set-device-desktop',
          className: 'fa fa-desktop html-desktop',
          attributes: {['title']: 'Desktop View'},
          active: true,
        }, {
          id: 'set-device-mobile',
          command: 'set-device-mobile',
          className: 'fa fa-mobile html-mobile',
          attributes: {['title']: 'Mobile View'},
        }]
      });
  
      const titlePanel = panelManager.addPanel({
        id: 'title-control',
        buttons: [
        {
          id: 'template-title',
          command: 'template-title',
          className: 'html-template-title',
          attributes: {['title']: 'Title'},
          active: 1,
        }
        ]
      });
    }

    if ( this.frontService.authService.getApp() === 'Designly' ) {
      const leftPanel = panelManager.addPanel({
        id: 'left-control',
        buttons: [{
          id: 'back',
          className: 'icon feather icon-chevron-left',
          command: 'back',
          attributes: {['title']: 'Back'}
        }]
      });
  
      const rightPanel = panelManager.addPanel({
        id: 'right-control',
        buttons: [
        {
          id: 'clean-all',
          command: 'clean-all',
          className: 'icon feather icon-trash-2 html-trash',
          attributes: {['title']: 'Clean Canvas'},
        },
        {
          id: 'undo',
          className: 'icon feather icon-rotate-ccw',
          command: 'undo',
          attributes: {['title']: 'Undo'}
        }, {
          id: 'redo',
          className: 'icon feather icon-rotate-cw',
          command: 'redo',
          attributes: {['title']: 'Redo'}
        }, {
          id: 'help',
          className: 'icon feather icon-help-circle btn-html-help',
          command: 'help',
          attributes: {['title']: 'Help'}
        }, {
          id: 'fullscreen',
          command: 'fullscreen',
          className: 'icon feather icon-maximize html-arrow',
          attributes: {['title']: 'Full Screen'},
        }, {
          id: 'send',
          className: 'btn-html-new-send',
          command: 'send',
          attributes: {['title']: 'Send'}
        }, {
          id: 'saveoptions',
          className: 'btn-html-save-campaign',
          command: 'saveoptions',
          attributes: {['title']: 'Save Options'}
        }, {
          id: 'facebook',
          className: 'icon feather icon-facebook',
          command: 'fbshare',
          attributes: {['title']: 'Share on Facebook'}
        },  {
          id: 'twitter',
          className: 'icon feather icon-twitter',
          command: 'twittershare',
          attributes: {['title']: 'Share on Twitter'}
        }, {
          id: 'linkedin',
          className: 'icon feather icon-linkedin',
          command: 'linkedinshare',
          attributes: {['title']: 'Share on LinkedIn'}
        },
        {
          id: 'save',
          className: 'btn-html-save',
          command: 'save',
          attributes: {['title']: 'Save'}
        },
        // {
        //   id: 'save-quick',
        //   className: 'btn-save-quick',
        //   command: 'save-quick',
        //   attributes: {['title']: 'Quick Design'}
        // },
        // {
        //   id: 'save-quick-office',
        //   className: 'btn-save-quick-office',
        //   command: 'save-quick-office',
        //   attributes: {['title']: 'Office Quick Design'}
        // },
        {
          id: 'pdf',
          className: 'btn-html-pdf',
          command: 'pdf',
          attributes: {['title']: 'PDF'}
        },
        {
          id: 'xhtml',
          className: 'btn-html-html',
          command: 'xhtml',
          attributes: {['title']: 'HTML'}
        },
        {
          id: 'img',
          className: 'btn-html-img',
          command: 'img',
          attributes: {['title']: 'Image'}
        }
        // {
        //   id: 'tour',
        //   className: 'btn-html-tour',
        //   command: 'tour',
        //   attributes: {['title']: 'Start Tour'}
        // }
        ]
      });
  
      const devicePanel = panelManager.addPanel({
        id: 'devices',
        buttons: [{
          id: 'set-device-desktop',
          command: 'set-device-desktop',
          className: 'icon feather icon-monitor html-desktop',
          attributes: {['title']: 'Desktop View'},
          active: true,
        }, {
          id: 'set-device-mobile',
          command: 'set-device-mobile',
          className: 'icon feather icon-smartphone html-mobile',
          attributes: {['title']: 'Mobile View'},
        }]
      });
    }

    const viewPanel = panelManager.addPanel({
      id: 'views',
      buttons: [{
        id: 'open-blocks',
        command: 'open-blocks',
        className: 'fa fa-desktop',
        attributes: {['title']: 'Blocks'},
        active: true
      }]
    });

    const viewStylePanel = panelManager.addPanel({
      id: 'view-style',
      buttons: [{
        id: 'open-style-manager',
        command: 'open-sm',
        className: 'fa fa-paint-brush btn-view-style-manager',
        attributes: {['title']: 'Styling'},
        active: false
      }]
    });

    const viewElQdPanel = panelManager.addPanel({
      id: 'el-qd-menu',
      buttons: [{
        id: 'show-element',
        command: 'show-element',
        className: 'btn-el-qd-menu btn-el-menu inactive',
        attributes: {['title']: 'Elements'},
        content: 'hello'
      },
      {
        id: 'show-quick-design',
        command: 'show-quick-design',
        className: 'btn-el-qd-menu btn-qd-menu',
        attributes: {['title']: 'Quick Designs'}
      }]
    });

    commands.add('show-element', {
      run:  function(editor, sender){
        sender.set('active', false);
        const conElQd = $('.gjs-pn-views-container');
        conElQd.find('.gjs-block-category').show();

        conElQd.find('.qd-box').parents('.gjs-block-category').hide();
      },
    });

    commands.add('show-quick-design', {
      run:  function(editor, sender){
        sender.set('active', false);
        const conElQd = $('.gjs-pn-views-container');
        conElQd.find('.gjs-block-category').hide();

        conElQd.find('.qd-box').parents('.gjs-block-category').show();
      },
    });

    commands.add('back', {
      run:  function(editor, sender){
        sender.set('active', false);
        const backUrl = $this.campaignService.backUrl;
        if ( $this.is_save === false ) {
          swal({
            title: 'Are you sure you want to leave without saving your changes?',
            text: 'You won\'t be able to revert this!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Proceed'
          }).then(function () {
            if ( backUrl !== null ) {
              thisRouter.navigateByUrl(backUrl);
            } else {
              thisRouter.navigate(['../../'], {relativeTo: thisRoute});
            }
          }).catch(swal.noop);
        } else {
          if ( backUrl !== null ) {
            thisRouter.navigateByUrl(backUrl);
          } else {
            thisRouter.navigate(['../../'], {relativeTo: thisRoute});
          }
        }

      }

    });

    commands.add('undo', {
      run:  function(editor, sender){
        sender.set('active', false);
        editor.UndoManager.undo(true);
      }
    });

    commands.add('redo', {
      run:  function(editor, sender){
        sender.set('active', false);
        editor.UndoManager.redo(true);
      },
    });

    if (this.template.category_id === 4 || this.template.category_id === 5) {
      if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
        $('.btn-html-send').addClass('hidden');
      } else {
        $('.btn-html-new-send').addClass('hidden');
      }
      $('.gjs-pn-devices').addClass('hidden');
    }

    if (this.template.category_id !== 7 ) {
      $('.btn-html-html').addClass('hidden');
    }


    if (this.template.category_id !== 6) {
      if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
        $('.fa-facebook').addClass('hidden');
        $('.fa-twitter').addClass('hidden');
        $('.fa-linkedin').addClass('hidden');
      } else {
        $('.icon-facebook').addClass('hidden');
        $('.icon-twitter').addClass('hidden');
        $('.icon-linkedin').addClass('hidden');
      }
    }

    commands.add('set-device-desktop', {
      run:  function(editor, sender){
        sender.set('active', false);
        editor.setDevice('Desktop');
      },
    });
    commands.add('set-device-mobile', {
      run:  function(editor, sender){
        sender.set('active', false);
        editor.setDevice('Mobile portrait');
      },
    });

    commands.add('clean-all', {
      run:  function(editor, sender){
        sender.set('active', false);
        swal({
          title: 'Are you sure you want to clean the canvas?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'CLEAN'
        }).then(function () {
          editor.DomComponents.clear();
        })
        .catch(swal.noop);

      },
    });

    commands.add('save', {
      run:  function(editor, sender){
        sender.set('active', false);

        // tslint:disable-next-line:forin
        if ( $this.ckeditor_active ) {
          for ( const name in CKEDITOR.instances ) {
            if ( name ) {
              CKEDITOR.instances[name].destroy(true);
            }
          }
        }

        swal({
          title: 'Are you sure you want to save the changes?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'SAVE'
        }).then(function () {
          const _valid = $this.saveHtml(editor);
          if (!_valid) {
            return;
          }
          $this.is_save = true;
          if ($this.loading === false) {
            swal(
              'Saved!',
              'Your template has been saved.',
              'success'
            );
          }
        })
        .catch(swal.noop);
      },
    });

    commands.add('send', {
      run: function(editor, sender){
        sender.set('active', false);
        $this.savePopupShow = false;
        const _valid = $this.saveHtml(editor);
        if ( !_valid ) {
          return;
        }

        let link = 'secure';

        if ($this.authUser.brandid === '12' || $this.authUser.brandid === '19') {
          link = 'raywhite';
        }
        if ($this.authUser.brandid === '13' || $this.authUser.brandid === '15' ) {
          link = 'rhcompass';
        }

        if ( $this.authUser.provider === 'mydesktop' ) {
          if ($this.template.category_id === 2) {
            swal({
              title: 'Send',
              type: 'info',
              html:
                // tslint:disable-next-line:max-line-length
                '<a onclick="onClickSend(\'' + link + '\', ' + '\'mydesktop.com.au/cgi-bin/clients/agents/propsearch2.cgi\'' + ')" class="btn btn-primary">Send</a>',
              showCancelButton: false,
              showConfirmButton: false,
              focusConfirm: false
            });
          } else if ($this.template.category_id === 3) {
            swal({
              title: 'Send',
              type: 'info',
              html:
                // tslint:disable-next-line:max-line-length
                '<a onclick="onClickSend(\'' + link + '\', ' + '\'mydesktop.com.au/cgi-bin/clients/agents/version6/quickenquiry/managev2.cgi\'' + ')" class="btn btn-primary">Send</a>',
              showCancelButton: false,
              showConfirmButton: false,
              focusConfirm: false
            });
          } else {
            swal({
              title: 'Who do you want to send to?',
              type: 'info',
              html:
            // tslint:disable-next-line:max-line-length
            '<a onclick="onClickSend(\'' + link + '\', ' + '\'mydesktop.com.au/cgi-bin/clients/agents/version6/addressbook/addressbook.cgi\'' + ')" class="btn btn-primary">A single contact</a> &nbsp; <a onclick="onClickSend(\'' + link + '\', ' + '\'mydesktop.com.au/cgi-bin/clients/agents/version6/marketreport4/manage.cgi\'' + ')" class="btn btn-info">Multiple Contacts</a>',
              showCancelButton: false,
              showConfirmButton: false,
              focusConfirm: false
            });
          }
        }

        if ( $this.authUser.provider === 'vaultre' ) {
          $this.isSendToVault = true;
        }
      }
    });

    commands.add('tour', {
      run: function(editor, sender){
        sender.set('active', false);

        const intro = introJs();

        intro.setOption('disableInteraction', true);
        intro.setOption('exitOnOverlayClick', false);
        intro.setOption('hidePrev', true);
        intro.setOption('hideNext', true);
        intro.setOption('showStepNumbers', false);
        intro.setOption('overlayOpacity', '0.5');

        intro.addSteps([
          {
            element: document.querySelector('.btn-html-tour'),
            intro: 'Take a Tour - Template Builder - Provides a step-by-step guide to the Template Builder.'
          },
          {
            element: document.querySelector('.html-template-title'),
            intro: 'Template name - Here you can view and change the name for your Template.'
          },
          {
            element: document.querySelector('.btn-el-menu'),
            // tslint:disable-next-line:max-line-length
            intro: 'Elements - Here you can build your Template from scratch by dragging the elements onto the canvas then arranging and editing the Template as required.'
          },
          {
            element: document.querySelector('.btn-qd-menu'),
            intro: 'Quick Design - Quick Designs are a group of elements that make up a complete template.'
          },
          {
            element: document.querySelector('.gjs-pn-devices'),
            // tslint:disable-next-line:max-line-length
            intro: 'Accessibility Mode - Here you can toggle between views to see how the Template will be viewed on Desktop or Mobile devices (This can only be used in eMarketing Templates).'
          },
          {
            element: document.querySelector('.fa-undo'),
            intro: 'Undo Button - Here you can undo your last action if you made a mistake.'
          },
          {
            element: document.querySelector('.fa-repeat'),
            intro: 'Redo Button - Here you can redo your last action if it was undone by mistake.'
          },
          {
            // tslint:disable-next-line:max-line-length
            element: document.querySelector( ( $this.frontService.authService.getApp() === 'MyDesign3' ? '.btn-html-send' : '.btn-html-new-send' )),
            intro: 'Send - This will link you to MyDesktop where you can send the Template to your database.'
          },
          {
            element: document.querySelector('.btn-html-save'),
            intro: 'Save - This will save the Template in its current state.'
          },
          {
            element: document.querySelector('.html-trash'),
            intro: 'Delete - Here you can delete the Template and this CANNOT BE UNDONE.'
          },
          {
            element: document.querySelector('.html-arrow'),
            intro: 'Fullscreen - Here you can expand the Template to view it in fullscreen mode'
          },
          {
            element: document.querySelector('.fa-arrow-left'),
            intro: 'Back to Dashboard - Here you can go back to the Dashboard however this will not save your Template.'
          }
        ]);

        intro.start().onchange(function(element) {
          const step = this._currentStep;

          const bg_00a9dd_steps = [ 1, 4, 5, 6, 7, 8, 9, 10, 11 ];

          if ( bg_00a9dd_steps.includes(step) ) {
            setTimeout(() => {
              $('.introjs-helperLayer').css('background-color', $this.mainColor);
            });
          }

        });
      }
    });

    commands.add('help', {
      run: function(editor, sender) {
        $('.help-box').removeClass('hidden');

        setTimeout(() => {
          $(document).on('click', function (e) {
            if ($(e.target).closest('.help-box').length === 0) {
              $('.help-box').addClass('hidden');

              $(document).off('click');
              sender.set('active', false);
            }
          });
        });
      },
      stop: function(editor, sender) {
        $(document).off('click');
        $('.help-box').addClass('hidden');
      }
    });

    commands.add('saveoptions', {
      run: function(editor, sender) {
        const btnOffset = $('.btn-html-save').offset();
        $('.save-options').css('left', `${btnOffset.left - 50}px`);
        $('.save-options').removeClass('hidden');

        setTimeout(() => {
          $(document).on('click', function (e) {
            if ($(e.target).closest('.save-options').length === 0) {
              $('.save-options').addClass('hidden');

              $(document).off('click');
              sender.set('active', false);
            }
          });
        });
      },
      stop: function(editor, sender) {
        $(document).off('click');
        $('.save-options').addClass('hidden');
      }
    });

    commands.add('fbshare', {
      run:  function(editor, sender){
        sender.set('active', false);
        $this.saveHtml(editor, 'img');
        $this.fbButtonClicked = true;

      },
    });

    commands.add('twittershare', {
      run:  function(editor, sender){
        sender.set('active', false);
        $this.saveHtml(editor, 'img');
        $this.twitterButtonClicked = true;
      },
    });

    commands.add('linkedinshare', {
      run:  function(editor, sender){
        sender.set('active', false);
        $this.saveHtml(editor, 'img');
        $this.linkedinButtonClicked = true;
      },
    });

    if (this.template.category_id === 1 || this.template.category_id === 2 || this.template.category_id === 3) {
      $('.btn-html-pdf').addClass('hidden');
      $('.btn-html-img').addClass('hidden');
    }

    commands.add('pdf', {
      run:  function(editor, sender){
        sender.set('active', false);

        if ( $this.authUser.client.group_id === 10 ) {
          swal({
            title: 'Confirm to save this template as PDF',
            confirmButtonText: 'DOWNLOAD PDF',
            confirmButtonClass: 'btn-rural-pdf',
            html:
              `<div style="text-align: left !important;">
                <ol>
                  <li>I acknowledge that if I
                  have used high quality images that do not have any watermarks.</li>
                  <li>I acknowledge that I am liable to proof check
                  the artwork and ensure images aren’t blurry.</li>
                  <li>I acknowledge that I am
                  liable to supply all final working files to the print company and</li>
                  <li>I acknowledge that I am responsible if
                  artwork is printed and the images are blurry.</li>
                </ol>
                <div class="checkbox">
                  <label>
                  <input id="confirm-1" type="checkbox" onclick="onPdfCheck()" value="1">Check here to indicate that you have read
                   and acknowledge the above.</label>
                </div>
              </div>`,
            preConfirm: function () {
              return new Promise(function (resolve) {
                resolve([
                  $('#confirm-1:checked').val()
                ]);
              });
            }
          }).then(function (results) {
            results.forEach( result => {
              let is_failed = false;
              if ( result === undefined ) {
                is_failed = true;
              }

              if ( is_failed ) {
                swal(
                  'Error',
                  'You need to agree with the terms to save as PDF',
                  'error'
                );
                return false;
              }

              $this.imgButtonClicked = false;
              $this.pdfButtonClicked = true;
              $this.qdtButtonClicked = false;
              $this.saveHtml(editor, 'pdf');
            });
          }).catch(swal.noop);
          $('.btn-rural-pdf').attr('disabled', true).css('width', '200px');
        } else {
          swal({
            title: 'Template will be saved before downloading',
            text: 'You won\'t be able to revert this!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'DOWNLOAD'
          }).then(function () {
            $this.imgButtonClicked = false;
            $this.pdfButtonClicked = true;
            $this.qdtButtonClicked = false;
            $this.saveHtml(editor, 'pdf');
          }).catch(swal.noop);
        }
      },
    });

    commands.add('save-quick', {
      run:  function(editor, sender){
        sender.set('active', false);

        swal({
          title: 'Template will be saved before it will be saved as a quick design.',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Quick Design'
        }).then(function () {
          $this.qdtButtonClicked = true;
          $this.qdoButtonClicked = false;
          $this.imgButtonClicked = false;
          $this.pdfButtonClicked = false;
          $this.saveHtml(editor);
        })
        .catch(swal.noop);

      },
    });

    commands.add('save-quick-office', {
      run:  function(editor, sender){
        sender.set('active', false);

        swal({
          title: 'Template will be saved before it will be saved as a quick design.',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Quick Design'
        }).then(function () {
          $this.qdoButtonClicked = true;
          $this.qdtButtonClicked = false;
          $this.imgButtonClicked = false;
          $this.pdfButtonClicked = false;
          $this.saveHtml(editor);
        })
        .catch(swal.noop);

      },
    });

    commands.add('xhtml', {
      run:  function(editor, sender){
        sender.set('active', false);
        // const body = $this.editor.Canvas.getBody();
        // const html = $(body).find('#wrapper').html();
        const html = $this.editor.getHtml();

        const html_data_css = $this.editor.getCss();
        let html_raw = juice(html + '<style>' + html_data_css + '</style>', { preserveMediaQueries: false,
          preserveImportant: true,
          applyHeightAttributes: false,
          applyWidthAttributes: false
        });

        let htmlStyle = $this.style.style;

        // Non-Class Setting - Merge Field
        if ( $this.clientSetting.color_1 ) {
          htmlStyle = htmlStyle.replace(/\{%COLOR1%\}/ig, $this.clientSetting.color_1);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%COLOR1%\}/ig, $this.groupSetting.color_1);
          }
        }
        if ( $this.clientSetting.color_2 ) {
          htmlStyle = htmlStyle.replace(/\{%COLOR2%\}/ig, $this.clientSetting.color_2);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%COLOR2%\}/ig, $this.groupSetting.color_2);
          }
        }
        if ( $this.clientSetting.color_3 ) {
          htmlStyle = htmlStyle.replace(/\{%COLOR3%\}/ig, $this.clientSetting.color_3);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%COLOR3%\}/ig, $this.groupSetting.color_3);
          }
        }
        if ( $this.clientSetting.color_4 ) {
          htmlStyle = htmlStyle.replace(/\{%COLOR4%\}/ig, $this.clientSetting.color_4);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%COLOR4%\}/ig, $this.groupSetting.color_4);
          }
        }
        if ( $this.clientSetting.color_5 ) {
          htmlStyle = htmlStyle.replace(/\{%COLOR5%\}/ig, $this.clientSetting.color_5);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%COLOR5%\}/ig, $this.groupSetting.color_5);
          }
        }
        if ( $this.clientSetting.color_6 ) {
          htmlStyle = htmlStyle.replace(/\{%FONTCOLOR1%\}/ig, $this.clientSetting.color_6);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%FONTCOLOR1%\}/ig, $this.groupSetting.color_6);
          }
        }
        if ( $this.clientSetting.color_7 ) {
          htmlStyle = htmlStyle.replace(/\{%FONTCOLOR2%\}/ig, $this.clientSetting.color_7);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%FONTCOLOR2%\}/ig, $this.groupSetting.color_7);
          }
        }
        if ( $this.clientSetting.color_8 ) {
          htmlStyle = htmlStyle.replace(/\{%ICONCOLOR1%\}/ig, $this.clientSetting.color_8);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%ICONCOLOR1%\}/ig, $this.groupSetting.color_8);
          }
        }
        if ( $this.clientSetting.font_family ) {
          htmlStyle = htmlStyle.replace(/\{%FONTFAMILY%\}/ig, $this.clientSetting.font_family);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%FONTFAMILY%\}/ig, $this.groupSetting.font_family);
          }
        }

        // low res logo
        if ( $this.clientSetting.primary_logo ) {
          htmlStyle = htmlStyle.replace(/\{%PRIMARYLOGO%\}/ig, $this.clientSetting.primary_logo);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%PRIMARYLOGO%\}/ig, $this.groupSetting.primary_logo);
          }
        }
        if ( $this.clientSetting.secondary_logo ) {
          htmlStyle = htmlStyle.replace(/\{%SECONDARYLOGO%\}/ig, $this.clientSetting.secondary_logo);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%SECONDARYLOGO%\}/ig, $this.groupSetting.secondary_logo);
          }
        }

        // hi res logo
        if ( $this.clientSetting.hires_primary_logo ) {
          htmlStyle = htmlStyle.replace(/\{%PRIMARYLOGOHIRES%\}/ig, $this.clientSetting.hires_primary_logo);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%PRIMARYLOGOHIRES%\}/ig, $this.groupSetting.hires_primary_logo);
          }
        }
        if ( $this.clientSetting.hires_secondary_logo ) {
          htmlStyle = htmlStyle.replace(/\{%SECONDARYLOGOHIRES%\}/ig, $this.clientSetting.hires_secondary_logo);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%SECONDARYLOGOHIRES%\}/ig, $this.groupSetting.hires_secondary_logo);
          }
        }

        if ( $this.clientSetting.primary_icon_bed ) {
          htmlStyle = htmlStyle.replace(/\{%PRIMARYICONBED%\}/ig, $this.clientSetting.primary_icon_bed);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%PRIMARYICONBED%\}/ig, $this.groupSetting.primary_icon_bed);
          }
        }
        if ( $this.clientSetting.primary_icon_bath ) {
          htmlStyle = htmlStyle.replace(/\{%PRIMARYICONBATH%\}/ig, $this.clientSetting.primary_icon_bath);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%PRIMARYICONBATH%\}/ig, $this.groupSetting.primary_icon_bath);
          }
        }
        if ( $this.clientSetting.primary_icon_car ) {
          htmlStyle = htmlStyle.replace(/\{%PRIMARYICONCAR%\}/ig, $this.clientSetting.primary_icon_car);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%PRIMARYICONCAR%\}/ig, $this.groupSetting.primary_icon_car);
          }
        }
        if ( $this.clientSetting.secondary_icon_bed ) {
          htmlStyle = htmlStyle.replace(/\{%SECONDARYICONBED%\}/ig, $this.clientSetting.secondary_icon_bed);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%SECONDARYICONBED%\}/ig, $this.groupSetting.secondary_icon_bed);
          }
        }
        if ( $this.clientSetting.secondary_icon_bath ) {
          htmlStyle = htmlStyle.replace(/\{%SECONDARYICONBATH%\}/ig, $this.clientSetting.secondary_icon_bath);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%SECONDARYICONBATH%\}/ig, $this.groupSetting.secondary_icon_bath);
          }
        }
        if ( $this.clientSetting.secondary_icon_car ) {
          htmlStyle = htmlStyle.replace(/\{%SECONDARYICONCAR%\}/ig, $this.clientSetting.secondary_icon_car);
        } else {
          if (typeof $this.groupSetting !== 'undefined') {
            htmlStyle = htmlStyle.replace(/\{%SECONDARYICONCAR%\}/ig, $this.groupSetting.secondary_icon_car);
          }
        }

        html_raw = '<style>\n' + beautify(htmlStyle, {format: 'css'}) + '\n</style>\n' + beautify(html_raw, {format: 'html'});

        swal({
          title: 'Select & Copy',
          type: false,
          html:
            '<textarea style="width: 100%; height: 300px;">' + html_raw + '</textarea>',
          showConfirmButton: false,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'COPY'
        });

      },
    });

    commands.add('md-el-prop-search', {
      run: function(editor, sender) {
        const model = editor.getSelected();

        const mdPropBox = model.view.$el.parents('.md-box');
        let propBox = null;

        const element_id = mdPropBox.data('id');
        const element_limit = mdPropBox.data('limit');

        if (mdPropBox.hasClass('md-prop-single-box')) {
          propBox = model.view.$el.parents('.md-prop-box');
        }

        const clickQuery = {
            listingtype: '',
            classification: '',
            element_id: '',
            orderby: 'modifydateDesc'
        };

        this.selectedListingIDs = [];
        $('#mdPropSearch').find('#propertyList > ul')
          .children('li')
          .removeClass('selected');

        if (typeof element_id !== 'undefined') {
          $this.element_parent_id = element_id;
          // tslint:disable-next-line:radix
          $this.element_listing_limit = parseInt(element_limit);

          clickQuery.element_id = element_id;
        }

        if ( typeof element_limit === 'undefined' && $this.template.category_id === 6 ) {
          $this.element_listing_limit = 1;
        }

        $this.element_listing_index = 0;
        $this.elementListingHtml = [];
        $this.s2SuburbValueModalInit = true;

        if ( $this.element_parent_id > 0) {
          $this.subLoading = true;
          $this.elementService.httpGetElementListingHtml($this.element_parent_id);
          $this.ref.detectChanges();
        }

        if (propBox !== null) {
          $this.element_listing_index = propBox.data('index');
        }

        $this.selectedListings = [];
        $($this.mdPropSearchModal.nativeElement).modal('show');
      }
    });

    commands.add('md-el-image-gallery', {
      run: function(editor){
        const model = editor.getSelected();
        const mdPropBox = model.view.$el.parents('.md-prop-box');

        $this.subLoading = true;
        $this.selectedFileHolder = model.view.el;
        $this.selectedFile = [];

        $($this.mdLibrarySearchModal.nativeElement).modal('show');
        $this.showImageLibrary = true;
        $this.ref.detectChanges();
      }
    });

    commands.add('md-el-article-search', {
      run: function(){
        $this.showPartica = true;
        $($this.mdParticaSearchModal.nativeElement).modal('show');

        $this.ref.detectChanges();
      }
    });

    commands.add('md-el-image-fit', {
      run: function(editor){
        const model = editor.getSelected();
        const imgEl = model.view.$el;

        imgEl.removeAttr( 'style' );

        const elImgStyle = model.getStyle();
        elImgStyle.width = imgEl.width();
        elImgStyle.height = imgEl.height();
        model.set('style', elImgStyle);

        imgEl.css({top: 0, left: 0, transform: 'scale(1.0)'});
      }
    });

    commands.add('md-el-lock', {
      run: function(editor){
        const selected = editor.getSelected();
        if (typeof selected.view !== 'undefined') {
          if (selected.view.$el.hasClass('md-lock')) {
            selected.removeClass('md-lock');
            selected.setAttributes({
              'data-lock-id': null,
              'data-lock-user': null
            });
          } else {
            swal({
              title: 'Select Locking Option',
              input: 'radio',
              inputOptions: {
                'editable': 'Content can be edited',
                'restricted': 'Content cannot be edited'
              }
            }).then((result) => {
              if ( result === null ) {
                swal(
                  'Error',
                  'You need to select an option',
                  'error'
                ).catch(swal.noop);
              } else {
                selected.addClass('md-lock');
                selected
                  .addAttributes({
                    'data-lock-id': $this.template.client_id,
                    'data-lock-user': $this.frontService.authService.auth.agentid,
                    'data-lock-type': result
                  });
              }
            });
          }

          editor.select();
        }
      }
    });

    commands.add('md-el-locked', {
      run: function(editor){
        swal({
          title: 'This element is locked and has limited editing options available.',
          type: false,
          showConfirmButton: false,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'CLOSE'
        });
      }
    });

    commands.add('md-element-palette', {
      run: function(editor) {
        $('.icon-palette').asColorPicker('open');
        const selectedElement = editor.getSelected();

        $this.color_selected_element = selectedElement.view.$el;
      }
    });

    if (this.template.category_id === 6) {
      if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
        $('.btn-html-send').addClass('hidden');
      } else {
        $('.btn-html-new-send').addClass('hidden');
      }
      $('.btn-html-pdf').addClass('hidden');
      $('.html-mobile').addClass('hidden');
      $('.html-desktop').addClass('hidden');
    }

    if (this.template.category_id !== 6
      && this.template.category_id !== 1
      && this.template.category_id !== 4
      && this.template.category_id !== 9) {
      $('.btn-html-img').addClass('hidden');
    }

    if ( this.template.category_id !== 6
      && this.template.category_id !== 1 ) {
        if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
          $('.btn-html-send').addClass('hidden');
        } else {
          $('.btn-html-new-send').addClass('hidden');
        }
    }

    if (this.template.category_id === 7) {
      if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
        $('.btn-html-send').addClass('hidden');
      } else {
        $('.btn-html-new-send').addClass('hidden');
      }
      $('.btn-html-pdf').addClass('hidden');
      $('.btn-html-img').removeClass('hidden');
    }

    commands.add('img', {
      run:  function(editor, sender){
        sender.set('active', false);

        swal({
          title: 'Template will be save before download',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'DOWNLOAD'
        }).then(function () {
          $this.pdfButtonClicked = false;
          $this.imgButtonClicked = true;
          $this.qdtButtonClicked = false;
          $this.saveHtml(editor, 'img');
        })
        .catch(swal.noop);
      }
    });

    if ($this.frontService.authService.auth.client.is_account_master !== 1 ||
      $this.frontService.authService.auth.client.group.master_client_id !== $this.frontService.authService.auth.client.ID) {
        $('.btn-save-quick').addClass('hidden');
    }

    if ($this.frontService.authService.auth.is_master === true || $this.frontService.authService.auth.is_admin !== true ) {
        $('.btn-save-quick-office').addClass('hidden');
    }

    const openBlocksBtn = this.editor.Panels.getButton('views', 'open-blocks');

    if (openBlocksBtn) {
      openBlocksBtn.set('active', 1);
    }

    for (const element of this.elements) {
      let elementHtml = element.html;

      elementHtml = this.fillMergeText(elementHtml, 'replicate');

      if ( element.block_id !== 0 ) {
        blockManager.add(`${element.title}-${element.block.title}`, {
          category: element.block.title,
          label: element.title,
          content: elementHtml,
          attributes: {
            // tslint:disable-next-line:max-line-length
            style: 'background-image: url("' + element.icon + '"); background-repeat: no-repeat; background-position: center 20px; background-size: 40px 30px; padding: 0 .5em 1em;'
          }
        });
      }
    }

    for (const quickDesign of this.quickDesigns) {
      const quickDesignHtmlStyle = '<style>' + quickDesign.html_data['css'] + '</style>\n';
      let quickDesignHtml = quickDesign.html;

      quickDesignHtml = this.fillMergeText(quickDesignHtml, 'subtitute');

      blockManager.add(quickDesign.title, {
        category: 'Quick Designs',
        label: quickDesign.title,
        content: quickDesignHtmlStyle + quickDesignHtml,
        attributes: {'class': 'qd-box'}
      });
    }

    const conElQd = $('.gjs-pn-views-container');

    conElQd.find('.gjs-block-category').show();

    conElQd.find('.qd-box').parents('.gjs-block-category').hide();

    const builderHtml = this.fillMergeText(this.template.html_raw, 'subtitute');

    this.editor.setComponents(builderHtml);

    this.editor.on('canvas:dragdata', function(e, result) {
      const content = String(result.content);
      if ( !content.includes('md-box') && !content.includes('class="page-divider"') ) {
        return result.content = '';
      }
    });

    this.editor.on('component:add', function(model) {
      if (typeof model.view !== 'undefined') {
        model.view.$el.find('a').click(function(e){
          e.preventDefault();
        });

        const template_agent_id = ( $this.templateAgent.id ) ? $this.templateAgent.id : '';
        model.view.$el.find('.md-user-field-id').html(template_agent_id);

        const template_agent_email = ( $this.templateAgent.email ) ? $this.templateAgent.email : '';
        model.view.$el.find('.md-user-field-email').html(template_agent_email);

        const template_agent_fax = ( $this.templateAgent.fax ) ? $this.templateAgent.fax : '';
        model.view.$el.find('.md-user-field-fax').html(template_agent_fax);

        const template_agent_firstname = ( $this.templateAgent.firstname ) ? $this.templateAgent.firstname : '';
        model.view.$el.find('.md-user-field-fname').html(template_agent_firstname);

        const template_agent_lastname = ( $this.templateAgent.lastname ) ? $this.templateAgent.lastname : '';
        model.view.$el.find('.md-user-field-lname').html(template_agent_lastname);

        model.view.$el.find('.md-user-field-name').html(
          template_agent_firstname + ' ' + template_agent_lastname
        );

        const template_agent_imageurl = ( $this.templateAgent.imageurl ) ? $this.templateAgent.imageurl : '';
        model.view.$el.find('.md-user-field-photo').html(template_agent_imageurl);

        const template_agent_telephone = ( $this.templateAgent.telephone ) ? $this.templateAgent.telephone : '';
        model.view.$el.find('.md-user-field-phone').html(template_agent_telephone);

        let template_agent_mobiledisplay = ( $this.templateAgent.mobile ) ? $this.templateAgent.mobile : '';
        template_agent_mobiledisplay = template_agent_mobiledisplay.replace('+61', '').replace('+64', '').trim();
        if (template_agent_mobiledisplay && template_agent_mobiledisplay.charAt(0) !== '0') {
          template_agent_mobiledisplay = '0' + template_agent_mobiledisplay;
        }
        model.view.$el.find('.md-user-field-mobile').html( template_agent_mobiledisplay );

        // model.view.$el.find('.md-content-editable').attr('contenteditable', 'true');

        // Non-Class Office Details - Merge Field
        model.view.$el.find('.md-office-field-id').html($this.frontService.authService.auth.groupid);

        if ($this.clientSetting.company_name ) {
          model.view.$el.find('.md-business-field-name').html($this.clientSetting.company_name);
        } else {
          if ( typeof $this.groupSetting !== 'undefined') {
            model.view.$el.find('.md-business-field-name').html($this.groupSetting.company_name);
          }
        }
        if ($this.clientSetting.website ) {
          model.view.$el.find('.md-website-field-name').html($this.clientSetting.website);
        } else {
          if ( typeof $this.groupSetting !== 'undefined') {
            model.view.$el.find('.md-website-field-name').html($this.groupSetting.website);
          }
        }
        if ( $this.clientSetting.name ) {
          model.view.$el.find('.md-office-field-name').html($this.clientSetting.name);
        } else {
          if ( typeof $this.groupSetting !== 'undefined') {
            model.view.$el.find('.md-office-field-name').html($this.groupSetting.name);
          }
        }
        if ( $this.clientSetting.phone ) {
          model.view.$el.find('.md-office-field-phone').html($this.clientSetting.phone);
        } else {
          if ( typeof $this.groupSetting !== 'undefined') {
            model.view.$el.find('.md-office-field-phone').html($this.groupSetting.phone);
          }
        }
        if ( $this.clientSetting.email ) {
          model.view.$el.find('.md-office-field-email').html($this.clientSetting.email);
        } else {
          if ( typeof $this.groupSetting !== 'undefined') {
            model.view.$el.find('.md-office-field-email').html($this.groupSetting.email);
          }
        }
        if ( $this.clientSetting.street ) {
          model.view.$el.find('.md-office-field-street').html($this.clientSetting.street);
        } else {
          if ( typeof $this.groupSetting !== 'undefined') {
            model.view.$el.find('.md-office-field-street').html($this.groupSetting.street);
          }
        }
        if ( $this.clientSetting.suburb ) {
          model.view.$el.find('.md-office-field-suburb').html($this.clientSetting.suburb);
        } else {
          if ( typeof $this.groupSetting !== 'undefined') {
            model.view.$el.find('.md-office-field-suburb').html($this.groupSetting.suburb);
          }
        }

        model.view.$el.find('.md-office-field-state').html($this.clientSetting.state_abbr);
        model.view.$el.find('.md-office-field-postcode').html($this.clientSetting.postcode);
      }

      $this.initScript();
    });

    this.editor.on('component:selected', function(model) {
      $('#gjs-tools .gjs-toolbar').removeClass('tb_overwrite');
      $this.enable_zoom = false;
      if (typeof model.view !== 'undefined') {
        if (model.view.$el.hasClass('md-prop-search') || model.view.$el.hasClass('md-library-search')) {
          $('#gjs-tools .gjs-toolbar').addClass('tb_overwrite');
        }

        if (model.view.$el.hasClass('md-box')) {
          const tb = model.get('toolbar');

          // const paletteExist = tb.find(
          //   function (tbi) {
          //     return tbi.command === 'md-element-palette';
          //   }
          // );

          // if ( typeof paletteExist === 'undefined' ) {
          //   tb.push({
          //     attributes: { class: 'icon-palette', title: 'Background Color' },
          //     command: 'md-element-palette'
          //   });
          // }

          // setTimeout(() => {
          //   if ( !$this.init_colorpicker ) {
          //     // tslint:disable-next-line:max-line-length
          //     $('head').append('<style>.asColorPicker-trigger { display: none; } .asColorPicker-input { border: unset !important; } .asColorPicker-clear { display: none; }</style>');
          //     $this.init_colorpicker = true;
          //   }
          //   $('.icon-palette').asColorPicker({
          //     onChange: function(picker) {
          //       $($this.color_selected_element).css('background', picker);
          //     }
          //   });
          // }, 200);


          if ( $this.authUser.is_master || $this.authUser.is_admin ) {
            const isExist = tb.find(
              function (tbi) {
                return tbi.command === 'md-el-lock';
              }
            );

            if (typeof isExist !== 'undefined' && isExist) {
              tb.pop();
            }
            let md_lock_icon = 'fa-unlock';
            let md_lock_title = 'Unlocked';

            if (model.view.$el.hasClass('md-lock')) {
              md_lock_icon = 'fa-lock';
              md_lock_title = 'Locked';
            }
            tb.push({
              attributes: {class: 'fa ' + md_lock_icon, title: md_lock_title},
              command: 'md-el-lock',
            });
            model.set('toolbar', tb);
          } else {
            if (model.view.$el.hasClass('md-lock')) {
              const isExist = tb.find(
                function (tbi) {
                  return tbi.command === 'md-el-locked';
                }
              );
              if (typeof isExist === 'undefined') {
                tb.push({
                  attributes: {class: 'fa fa-lock', title: 'Locked'},
                  command: 'md-el-locked',
                });
                model.set('toolbar', tb);
              }
            }
          }
        }
        if ( model.view.$el.parents().hasClass('md-lock') || model.view.$el.hasClass('md-lock') ) {
          const parent = model.view.$el.attr('data-lock-id');
          const child = model.view.$el.parents().find('.md-lock').attr('data-lock-id');
          const type = model.view.$el.parents().find('.md-lock').attr('data-lock-type');

          if ( parent !== null && child !== null ) {
            // tslint:disable-next-line:radix
            if ( parseInt(parent) !== $this.authUser.client.ID ) {
              const _tb = [{
                attributes: {class: 'fa fa-lock lock-' + type, title: 'Edit Image'},
                command: 'md-el-locked',
              }];
              model.set('toolbar', _tb);
            }
          } else {
            // tslint:disable-next-line:radix
            if ( parseInt(child) !== $this.authUser.client.ID &&
            ( !model.view.$el.hasClass('md-library-search') && !model.view.$el.hasClass('md-prop-search') ) ) {
              if ( type === 'restricted' ) {
                model.set({
                draggable: false,
                droppable: false,
                copyable: false,
                removable: false,
                selectable: false,
                editable: false,
                toolbar: []
                });
              } else {
                model.set('toolbar', []);
              }
            }
          }
        }
      }
    });


    this.editor.on('change', function() {
      /*
       * Override Styles Tooltip
       */
      $('.fa-arrows').attr({'title': 'Drag'});
      $('.fa-clone').attr({'title': 'Duplicate'});
      $('.fa-trash-o').attr({'title': 'Delete'});

      $('.gjs-cv-canvas').find('iframe').contents().find('a').click(function(e){
        e.preventDefault();
      });
    });

    this.editor.on('load', function() {
      if ($this.template.media_attribute.size === 'A3') {
        if ($this.template.media_attribute.orientation === 'Landscape') {
          $this.editor.setDevice('A3 landscape');
        } else {
          $this.editor.setDevice('A3 portrait');
        }
      } else if ($this.template.media_attribute.size === 'fb-cover') {
        $this.editor.setDevice('FB cover');
      } else if ($this.template.media_attribute.size === 'fb-post') {
        $this.editor.setDevice('FB post');
      } else if ($this.template.media_attribute.size === 'insta-post') {
        $this.editor.setDevice('IG post');
      } else if ($this.template.media_attribute.size === 'DL') {
        $this.editor.setDevice('DL card');
      } else if ($this.template.media_attribute.size === 'A4') {
        if ($this.template.media_attribute.orientation === 'Landscape') {
          $this.editor.setDevice('A4 landscape');
        } else {
          $this.editor.setDevice('A4 portrait');
        }
      } else if ($this.template.media_attribute.size === '1200x1800') {
        $this.editor.setDevice('Portrait 1200x1800');
      } else if ($this.template.media_attribute.size === '1200x2400'
        || $this.template.media_attribute.size === '1800x1200'
        || $this.template.media_attribute.size === '1750x1130' ) {
        $this.editor.setDevice('Portrait 1200x2400');
      } else if ( $this.template.media_attribute.size === 'custom' ) {
        $this.editor.setDevice($this.template.media_attribute.slug);
      } else {
        $this.editor.setDevice('Desktop View');
      }
    });

    /*
    * Custom $ style append
    */

    $('.btn-el-menu').text('Elements');
    $('.btn-qd-menu').text('Quick Design');

    $('.btn-el-menu').click(() => {
      if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
        $('.btn-el-menu').attr('style', 'background: #37AAE1 !important; color: #ffffff !important;');
        $('.btn-qd-menu').attr('style', 'background: #ffffff !important; color: #37AAE1 !important;');
      } else {
        $('.btn-el-menu').attr('style', `background: #FFF !important; color: ${$this.mainColor} !important;`);
        $('.btn-qd-menu').attr('style', 'background: #F4F4F5 !important; color: #5B6A72 !important;');
      }
    });

    $('.btn-qd-menu').click(() => {
      if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
        $('.btn-el-menu').attr('style', 'background: #ffffff !important; color: #37AAE1 !important;');
        $('.btn-qd-menu').attr('style', 'background: #37AAE1 !important; color: #ffffff !important;');
      } else {
        $('.btn-el-menu').attr('style', 'background: #F4F4F5 !important; color: #5B6A72 !important;');
        $('.btn-qd-menu').attr('style', `background: #FFF !important; color: ${$this.mainColor} !important;`);
      }
    });

    $('.btn-html-tour').html('Start Tour');

    if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
      $('.gjs-pn-btn.fa.fa-arrow-left').after(' <span style="font-size: 2.5em">Back to Dashboard</div>');
    } else {
      $('.gjs-pn-btn.icon.feather.icon-chevron-left')
      .after(`<span title="Title" class="gjs-pn-btn html-template-title">${$this.template.title}</span>`);
    }

    $('.html-template-title').click(function() {
      swal({
        title: 'Change Template Name',
        input: 'text',
        showCancelButton: true,
        confirmButtonText: 'Submit',
        showLoaderOnConfirm: true,
        preConfirm: function (text) {
          return new Promise(function (resolve, reject) {
            setTimeout(function() {
                resolve();
            }, 2000);
          });
        },
        allowOutsideClick: false
      }).then(function (text) {
        swal({
          type: 'success',
          title: 'Success'
        });
        $this.new_template_name = text;
        $('.html-template-title').text(text);

        const template = <any> {
          title: text
        };

        $this.templateService.httpPutTemplate($this.id, template);
      });
    });

    if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
      $('.btn-html-save').html('<span class="fa fa-floppy-o"></span> Save');
      $('.btn-save-quick').html('<span class="fa fa-file-picture-o"></span> Quick Design');
      $('.btn-save-quick-office').html('<span class="fa fa-file-picture-o"></span> Quick Design');
      $('.btn-html-send').html('<span class="fa fa-send-o"></span> Send');
      $('.btn-html-pdf').html('<span class="fa fa-file-pdf-o"></span> Save as PDF');
      $('.btn-html-img').html('<span class="fa fa-picture-o"></span> Save as Image');
      $('.btn-html-html').html('<span class="fa fa-file-pdf-o"></span> View HTML');
      $('.btn-html-help').html('<span class="fa fa-question-circle"></span>');

      $('.btn-html-save-campaign').insertAfter('.btn-html-save');
      $('.btn-html-save-campaign').html('<i class="icon feather icon-chevron-down"></i>');
    }

    if ( this.frontService.authService.getApp() === 'Designly' ) {
      $('.btn-save-quick').html('<span class="fa fa-file-picture-o"></span> Quick Design');
      $('.btn-save-quick-office').html('<span class="fa fa-file-picture-o"></span> Quick Design');
      $('.btn-html-pdf').html('<i class="icon feather icon-file-text"></i> <span>Save as PDF</span>');
      $('.btn-html-img').html('<i class="icon feather icon-image"></i> <span>Save as Image</span>');
      $('.btn-html-html').html('<span class="fa fa-file-pdf-o"></span> View HTML');

      $('.btn-html-save').html('<i class="icon feather icon-save"></i> Save');
      $('.btn-html-save-campaign').insertAfter('.btn-html-save');
      $('.btn-html-save-campaign').html('<i class="icon feather icon-chevron-down"></i>');

      $('.btn-html-new-send').insertAfter('.btn-html-save-campaign');
      $('.btn-html-new-send').html('<i class="icon feather icon-mail"></i> <span>Send</span>');

      $('<span style="border-left: 2px solid #F4F4F5; height: 25px; margin: 0 5px 0 5px;"></span>').insertAfter('.icon-rotate-cw');
    }

    $('.btn-view-style-manager').trigger('click');

    const view_sm = $('.gjs-pn-views-container > div:nth-child(2)');
    view_sm.addClass('view-style-manager-container');

    const iframe = $(this.builder.nativeElement).find('iframe');

    $('.html-template-title').text(this.template.title);

    /*
    * Restrict resize desktop mobile to eMarketing
    */

    if (this.template.category_id !== 1) {
      $('.html-desktop').css('display', 'none');
      $('.html-mobile').css('display', 'none');
    }

    if ( localStorage.getItem('first_builder') === '1' ) {
      $('.btn-html-tour').trigger('click');

      // set builder tour to 0
      localStorage.setItem('first_builder', '0');
    }

  }

  initStyle() {
    const iframe = $(this.builder.nativeElement).find('iframe').contents();
    let htmlStyle = this.style.style;
    // iframe.find('.md-content-editable').attr('data-gjs-type', 'text');

    iframe.find('.gjs-css-rules').remove();

    const clientSetting = this.frontService.authService.auth.client;
    const groupSetting = this.clientSetting.group.master;

    // Non-Class Setting - Merge Field
    if ( this.clientSetting.color_1 ) {
      htmlStyle = htmlStyle.replace(/\{%COLOR1%\}/ig, this.clientSetting.color_1);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%COLOR1%\}/ig, this.groupSetting.color_1);
      }
    }
    if ( this.clientSetting.color_2 ) {
      htmlStyle = htmlStyle.replace(/\{%COLOR2%\}/ig, this.clientSetting.color_2);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%COLOR2%\}/ig, this.groupSetting.color_2);
      }
    }
    if ( this.clientSetting.color_3 ) {
      htmlStyle = htmlStyle.replace(/\{%COLOR3%\}/ig, this.clientSetting.color_3);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%COLOR3%\}/ig, this.groupSetting.color_3);
      }
    }
    if ( this.clientSetting.color_4 ) {
      htmlStyle = htmlStyle.replace(/\{%COLOR4%\}/ig, this.clientSetting.color_4);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%COLOR4%\}/ig, this.groupSetting.color_4);
      }
    }
    if ( this.clientSetting.color_5 ) {
      htmlStyle = htmlStyle.replace(/\{%COLOR5%\}/ig, this.clientSetting.color_5);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%COLOR5%\}/ig, this.groupSetting.color_5);
      }
    }
    if ( this.clientSetting.color_6 ) {
      htmlStyle = htmlStyle.replace(/\{%FONTCOLOR1%\}/ig, this.clientSetting.color_6);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%FONTCOLOR1%\}/ig, this.groupSetting.color_6);
      }
    }
    if ( this.clientSetting.color_7 ) {
      htmlStyle = htmlStyle.replace(/\{%FONTCOLOR2%\}/ig, this.clientSetting.color_7);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%FONTCOLOR2%\}/ig, this.groupSetting.color_7);
      }
    }
    if ( this.clientSetting.color_8 ) {
      htmlStyle = htmlStyle.replace(/\{%ICONCOLOR1%\}/ig, this.clientSetting.color_8);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%ICONCOLOR1%\}/ig, this.groupSetting.color_8);
      }
    }
    if ( this.clientSetting.font_family ) {
      htmlStyle = htmlStyle.replace(/\{%FONTFAMILY%\}/ig, this.clientSetting.font_family);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%FONTFAMILY%\}/ig, this.groupSetting.font_family);
      }
    }

    // low res logo
    if ( this.clientSetting.primary_logo ) {
      htmlStyle = htmlStyle.replace(/\{%PRIMARYLOGO%\}/ig, this.clientSetting.primary_logo);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%PRIMARYLOGO%\}/ig, this.groupSetting.primary_logo);
      }
    }
    if ( this.clientSetting.secondary_logo ) {
      htmlStyle = htmlStyle.replace(/\{%SECONDARYLOGO%\}/ig, this.clientSetting.secondary_logo);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%SECONDARYLOGO%\}/ig, this.groupSetting.secondary_logo);
      }
    }

    // high res logo
    if ( this.clientSetting.hires_primary_logo ) {
      htmlStyle = htmlStyle.replace(/\{%PRIMARYLOGOHIRES%\}/ig, this.clientSetting.hires_primary_logo);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%PRIMARYLOGOHIRES%\}/ig, this.groupSetting.hires_primary_logo);
      }
    }
    if ( this.clientSetting.hires_secondary_logo ) {
      htmlStyle = htmlStyle.replace(/\{%SECONDARYLOGOHIRES%\}/ig, this.clientSetting.hires_secondary_logo);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%SECONDARYLOGOHIRES%\}/ig, this.groupSetting.hires_secondary_logo);
      }
    }

    if ( this.clientSetting.primary_icon_bed ) {
      htmlStyle = htmlStyle.replace(/\{%PRIMARYICONBED%\}/ig, this.clientSetting.primary_icon_bed);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%PRIMARYICONBED%\}/ig, this.groupSetting.primary_icon_bed);
      }
    }
    if ( this.clientSetting.primary_icon_bath ) {
      htmlStyle = htmlStyle.replace(/\{%PRIMARYICONBATH%\}/ig, this.clientSetting.primary_icon_bath);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%PRIMARYICONBATH%\}/ig, this.groupSetting.primary_icon_bath);
      }
    }
    if ( this.clientSetting.primary_icon_car ) {
      htmlStyle = htmlStyle.replace(/\{%PRIMARYICONCAR%\}/ig, this.clientSetting.primary_icon_car);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%PRIMARYICONCAR%\}/ig, this.groupSetting.primary_icon_car);
      }
    }
    if ( this.clientSetting.secondary_icon_bed ) {
      htmlStyle = htmlStyle.replace(/\{%SECONDARYICONBED%\}/ig, this.clientSetting.secondary_icon_bed);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%SECONDARYICONBED%\}/ig, this.groupSetting.secondary_icon_bed);
      }
    }
    if ( this.clientSetting.secondary_icon_bath ) {
      htmlStyle = htmlStyle.replace(/\{%SECONDARYICONBATH%\}/ig, this.clientSetting.secondary_icon_bath);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%SECONDARYICONBATH%\}/ig, this.groupSetting.secondary_icon_bath);
      }
    }
    if ( this.clientSetting.secondary_icon_car ) {
      htmlStyle = htmlStyle.replace(/\{%SECONDARYICONCAR%\}/ig, this.clientSetting.secondary_icon_car);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        htmlStyle = htmlStyle.replace(/\{%SECONDARYICONCAR%\}/ig, this.groupSetting.secondary_icon_car);
      }
    }

    const external_font_list = (this.style.external_font).split('\n');
    for (const external_font of external_font_list) {
      if (external_font) {
        const externalFont = $('<link>').attr('rel', 'stylesheet')
          .attr('href', external_font);

        iframe.find('head').append(externalFont);
      }
    }

    const external_css_list = (this.style.external_css).split('\n');
    for (const external_css of external_css_list) {
      if (external_css) {
        const externalLink = $('<link>').attr('rel', 'stylesheet')
          .attr('type', 'text/css')
          .attr('href', external_css);

        iframe.find('head').append(externalLink);
      }
    }

    const $this = this;

    iframe.find('head').append(
      $('<style>').text(htmlStyle)
    );

    iframe.find('head').append(
      $('<style>').text(`
      .page-divider {
        border-bottom: 2px dashed #8da3b0;
        display: block;
        padding: 20px 0 0;
        margin: 0 0 20px 0;
      }
      .page {
        margin:0 auto 40px auto;
        box-shadow: 0 0 40px rgba(0,0,0,0.3);
      }
      .md-hidden {
        display: none;
      }
      .md-prop-search.ui-draggable, .md-library-search.ui-draggable  {
        cursor: pointer;
      }
      p.gjs-comp-selected {
          outline: 1px dashed ${$this.mainColor} !important;
          outline-offset: -1px;
      }
      .gjs-badge, .gjs-com-badge, .gjs-com-badge-red {
        display:none!important;
      }
      body {
        height: auto !important;
      }
      .gjs-comp-selected {
        outline: 3px solid ${$this.mainColor} !important;
      }
      `)
    );

    const external_js_list = (this.style.external_js).split('\n');

    for (const external_js of external_js_list) {
      if (external_js) {
        const externalLink = $('<script>').attr('type', 'text/javascript')
          .attr('src', external_js);

        iframe.find('head').append(externalLink);
      }
    }

    iframe.find('body').append($('<div>').attr('id', 'after-body-script').html(''));

    this.initScript();
  }

  initScript() {
    const iframe = $(this.builder.nativeElement).find('iframe').contents();
    const afterBody = iframe.find('#after-body-script').html('');

    afterBody.append(
      $('<script type="text/javascript">').text(
        `` + this.style.script + ``
      )
    );
  }

  saveHtml(editor: any, download: string = '', loading: boolean = true) {
    this.loading = loading;

    if (this.template.category_id === 4 || this.template.category_id === 8) {
      const selectedElement = editor.getSelected();

      if ( typeof selectedElement !== 'undefined' ) {
        const elementBox = selectedElement.view.$el;
        const elementBlock = elementBox.parents('#wrapper');

        if ( elementBox.length > 0 && elementBlock.length > 0 ) {
          editor.setComponents(elementBlock.html());
        }
      }

    }

    let html = editor.getHtml();
    let html_data_css = this.editor.getCss();

    const body = this.editor.Canvas.getBody();
    if ( this.template.category_id === 1 ) {
      const property_ids = [];
      $(html).find('[data-propid]').each(function() {
        property_ids.push($(this).data('propid'));
      });

      if ( property_ids.length > 0 ) {
        const unique_property_ids = Array.from(new Set(property_ids));

        if ( this.authUser.provider === 'mydesktop' ) {
          const pid_list_comment = '<!--PIDLIST:' + unique_property_ids.join() + ':PIDLIST-->';
          $(body).find('#wrapper').append(pid_list_comment);
        }
      }
    } else {
      html_data_css = String(html_data_css).replace(/(\..*?\})/gm, '');
    }
    html = $(body).find('#wrapper').html();

    const html_raw = juice.inlineContent(html, html_data_css, {
      preserveMediaQueries: false, preserveImportant: true, applyHeightAttributes: false, applyWidthAttributes: false
    });

    const templateValues: Object = {};

    const _validation = this._validateCodeElement(this.template.master.validation_code, html);
    const _is_valid = _validation.status;

    if ( _is_valid ) {

      if (this.new_template_name !== '') {
        templateValues['title'] = this.new_template_name;
      }
      if (this.qdtButtonClicked) {
        templateValues['qdt'] = true;
        this.qdtButtonClicked = false;
      }
      if (this.qdoButtonClicked) {
        templateValues['qdt'] = true;
        templateValues['client_id'] = this.client.ID;
        this.qdoButtonClicked = false;
      }

      templateValues['html'] = html;
      templateValues['html_raw'] = html_raw;
      templateValues['html_data'] = { style: '' , css: html_data_css};
      templateValues['download'] = download;

      this.templateService.httpBuildTemplate(this.id, <Template>templateValues);
    } else {
      swal({
        title: _validation.title,
        html: _validation.message,
        type: 'error'
      });
      this.loading = false;
    }

    return _is_valid;


  }

  _validateCodeElement(_code: string = '', _html: string = '') {
    const result = {'status': true, title: '', message: ''};
    if (_code) {
      const validation_codes = (_code).split('\n');
      if (validation_codes.length > 0) {
        validation_codes.forEach( function (validation_code) {
          const vc_rules = validation_code.split(':');
          if (vc_rules.length > 0) {
            if ( vc_rules[0] ) {
              const _elm = $('<div>').html(_html).find(vc_rules[0]);
              const _title = (typeof vc_rules[3] !== 'undefined' && vc_rules[3]) ? vc_rules[3] : 'Element';

              result.title = _title;

              if (_elm.length < 1 ) {
                result.message = 'Element is required.';
                result.status = false;
              }

              if (typeof vc_rules[1] !== 'undefined' && +vc_rules[1] > 0 && _elm.length < +vc_rules[1] )  {
                result.message = vc_rules[1] + ' number of element is required.';
                result.status = false;
              }

              if (typeof vc_rules[1] !== 'undefined' && +vc_rules[1] < 0 && _elm.length > +vc_rules[1] )  {
                result.message = 'Element is not required.';
                result.status = false;
              }

              if (typeof vc_rules[2] !== 'undefined' && +vc_rules[2] > 0 && _elm.length > +vc_rules[2] )  {
                result.message = 'Exceed maximum (' + vc_rules[2] + ') number of element required.';
                result.status = false;
              }
            }
          }
        });
      }
    }

    return result;
  }

  listingSearchChange(current, page = 1) {
    this.subLoading = true;
    const formValues = this.mdListingsForm.value;

    this.mdListingCount = 0;
    this.mdListingTotal = 0;
    this.mdListingPages = [];
    this.mdListingCurrentPage = 1;

    if (page > 0) {
      formValues['page'] = page;
      this.mdListingCurrentPage = page;
    }

    if ( this.isMultipleOffice && formValues['officeid'] ) {
      const officeData = this.authUser.multiple.slice(0);
      const officeIndex = officeData.findIndex(sOffice => sOffice.groupid === +formValues['officeid']);

      if ( officeIndex >= 0 && typeof officeData[officeIndex] !== 'undefined' ) {
        formValues['office_token'] = officeData[officeIndex].token;
      }
    }

    this.selectedListingIDs = [];
    this.listingSearchValues = formValues;

    this.myDesktopService.httpGetMDListings(
      formValues,
      this.authUser.provider
    );
  }

  selectProperty(listing, elRef: HTMLElement) {
    const isIndex = this.selectedListings.findIndex(sListing => sListing.id === listing.id);
    const indexOfListingID = this.selectedListingIDs.indexOf(listing.id);

    if (this.template.category_id === 4 || this.template.category_id === 8) {
      this.element_listing_limit = 1;
    }

    if ( this.template.category_id !== 5 && ( this.element_listing_limit !== 0 &&
      this.selectedListings.length >= this.element_listing_limit ) ) {
      if (isIndex === -1) {
        swal('Listing limit of ' + this.element_listing_limit + ' reached.');
        return false;
      }
    }

    if (isIndex === -1) {
      this.selectedListingIDs.push(listing.id);
      this.selectedListings.push(listing);
      elRef.classList.add('selected');
      $(elRef).find( 'input' ).prop('checked', true);
    } else {
      this.selectedListingIDs.splice(indexOfListingID, 1);

      this.selectedListings.splice(isIndex, 1);
      elRef.classList.remove('selected');
      $(elRef).find( 'input' ).prop('checked', false);

    }

    if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
      if ( this.selectedListings.length > 0 ) {
        this.getCustomParams(listing.id);
        this.subLoading = true;
      }
    } else {
      if ( this.authUser.provider === 'domain' ) {
        this.domainService.httpGetListing(listing.id);
        this.loadingInsertListing = true;
        this.activateInsertListing = false;
      }

      if ( this.authUser.provider === 'vaultre' ) {
        this.vaultService.httpGetListing(listing.id, this.listingSearchValues);
        this.loadingInsertListing = true;
        this.activateInsertListing = false;
      }
      this.subLoading = true;
      this.vaultService.httpGetListing(listing.id, this.listingSearchValues);
      this.ref.detectChanges();
    }

    this.activateInsertListing = false;
    this.loadingInsertListing = true;
  }

  getCustomParams(property_id: number) {
    this.myDesktopService.httpGetMDListingByCustomParams(
      {
        ID: property_id
      }
    );
  }

  onSelectedArticle(article) {
    try {
      let selectedElement = this.editor.getSelected();
      let elementBox = selectedElement.view.$el;

      if (elementBox.hasClass('md-article-search')) {
        elementBox = elementBox.parents('.md-box');
        elementBox.trigger('click');

        selectedElement = this.editor.getSelected();
      }

      const selectedHtmlEl = selectedElement.view.$el;

      let articleText = '';

      if ( typeof article.text !== 'undefined' ) {
        articleText = String(article.text);
        articleText = articleText.replace(new RegExp('<p>', 'g'), '');
        articleText = articleText.replace(new RegExp('</p>', 'g'), '<br><br>');
        articleText = articleText.replace(new RegExp('<strong>', 'g'), '<b>').replace(new RegExp('</strong>', 'g'), '</b>');
      }

      selectedHtmlEl.find('.md-partica-image').attr('src', environment.particaViewerEndpoint + article.image_src);
      selectedHtmlEl.find('.md-partica-heading').text(article.title);
      selectedHtmlEl.find('.md-partica-description').text(articleText);
      // tslint:disable-next-line:max-line-length
      selectedHtmlEl.find('.md-partica-url').attr('href', `${environment.particaArticleEndpoint}/static/article/${article.slug}_a${article.articleId}`);
      selectedHtmlEl.find('.md-partica-abstract').text(article.abstract);

      let tmpHtml = selectedHtmlEl.html();

      // tslint:disable-next-line:max-line-length
      tmpHtml = tmpHtml.replace(/\{%PARTICAURL%\}/ig, `${environment.particaArticleEndpoint}/static/article/${article.slug}_a${article.articleId}`);

      selectedElement.components('');
      selectedElement.set('content', tmpHtml);

      const html = this.editor.getHtml();

      const html_data_css = this.editor.getCss();
      const html_raw = juice(html + '<style>' + html_data_css + '</style>', {
        preserveMediaQueries: false,
        preserveImportant: true,
        applyHeightAttributes: false,
        applyWidthAttributes: false
      });

      this.editor.setComponents(html_raw);
    } catch (err) {
      console.log(err);
    }
  }

  onSelectListings() {
    try {
      const $this = this;
      this.subLoading = true;
      const listings = this.selectedListings.slice();
      let selectedElement = this.editor.getSelected();

      let singleElement = false;
      let elementBox = selectedElement.view.$el;

      console.log(elementBox.html());

      if (elementBox.hasClass('md-prop-search')) {
        elementBox = elementBox.parents('.md-box');
        elementBox.trigger('click');

        selectedElement = this.editor.getSelected();
      }

      let elementBlock = elementBox.find('.md-prop-box');
      let selectedBlock = (selectedElement.find('.md-prop-box'))[0];

      if (elementBox.hasClass('md-prop-box')) {
        elementBlock = elementBox;
        selectedBlock = selectedElement;
      }

      if (this.element_listing_index > 0 && elementBox.hasClass('md-prop-single-box')) {
        singleElement = true;
        elementBlock = elementBox.find('.md-prop-box').eq(this.element_listing_index - 1);
        selectedBlock = (selectedElement.find('.md-prop-box'))[this.element_listing_index - 1];
      }

      if (this.template.category_id === 4 || this.template.category_id === 8 || this.template.category_id === 9) {
        elementBlock = elementBox.parents('#wrapper');
      }

      let elementBlockGroup = null;
      let elementParentProperty = null;

      if (this.template.category_id === 5) {
        elementBlockGroup = elementBlock.parents('.md-prop-group-box');
        elementParentProperty = elementBlock.parents('[data-limit]');
        elementBlockGroup.html('');
      }

      let idxListing = 0;
      let propGuideCount = 0;
      for (const listing of listings) {
        idxListing++;

        if ( this.template.category_id === 5 && propGuideCount >= this.element_listing_limit ) {
          this.property_guide_skip = true;
          const iframe = $(this.builder.nativeElement).find('iframe').contents();
          const lastStocklist = iframe.find('[data-limit]').last();

          const newStockList = elementParentProperty.clone().insertAfter(lastStocklist);

          singleElement = false;
          elementBox = newStockList.find('.md-prop-search').first();
          selectedElement = newStockList;

          if (elementBox.hasClass('md-prop-search')) {
            elementBox = elementBox.parents('.md-box');
            elementBox.trigger('click');
          }


          elementBlock = elementBox.find('.md-prop-box');

          if (elementBox.hasClass('md-prop-box')) {
            elementBlock = elementBox;
            selectedBlock = selectedElement;
          }

          if (this.element_listing_index > 0 && elementBox.hasClass('md-prop-single-box')) {
            singleElement = true;
            elementBlock = elementBox.find('.md-prop-box').eq(this.element_listing_index - 1);
            selectedBlock = (selectedElement.find('.md-prop-box'))[this.element_listing_index - 1];
          }

          elementBlockGroup = null;

          if (this.template.category_id === 5) {
            elementBlockGroup = elementBlock.parents('.md-prop-group-box');
            elementParentProperty = elementBlock.parents('[data-limit]');
            elementBlockGroup.html('');
          }

          propGuideCount = 0;
        }
        propGuideCount++;

        let listingHtml = '';
        if ( Object.keys(this.elementListingHtml).length > 0 ) {
          listingHtml = this.elementListingHtml[ String(listing.listing_category).toLowerCase() ];
        }

        if ( typeof listingHtml !== 'undefined' && listingHtml !== '' ) {
          const tmpHtmlDOM = $(listingHtml);

          if (this.template.category_id === 5) {
            elementBlock =  tmpHtmlDOM;
          }

          let tmpHtml = tmpHtmlDOM.html();

          tmpHtml = tmpHtml.replace(/\{%DATE%\}/ig, moment().format('Do, MMM YYYY'));

          if ( this.clientSetting.name ) {
            tmpHtml = tmpHtml.replace(/\{%OFFICENAME%\}/ig, this.clientSetting.name);
          } else {
            tmpHtml = tmpHtml.replace(/\{%OFFICENAME%\}/ig, '');
          }
          if ( this.clientSetting.company_name ) {
            tmpHtml = tmpHtml.replace(/\{%OFFICEBUSINESS%\}/ig, this.clientSetting.company_name);
          } else {
            tmpHtml = tmpHtml.replace(/\{%OFFICEBUSINESS%\}/ig, '');
          }
          if ( this.clientSetting.branch_name ) {
            tmpHtml = tmpHtml.replace(/\{%OFFICEBRANCH%\}/ig, this.clientSetting.branch_name);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%OFFICEBRANCH%\}/ig, this.groupSetting.branch_name);
            }
          }
          if ( this.clientSetting.phone ) {
            tmpHtml = tmpHtml.replace(/\{%OFFICEPHONE%\}/ig, this.clientSetting.phone);
          } else {
            tmpHtml = tmpHtml.replace(/\{%OFFICEPHONE%\}/ig, '');
          }
          if ( this.clientSetting.email ) {
            tmpHtml = tmpHtml.replace(/\{%OFFICEEMAIL%\}/ig, this.clientSetting.email);
          } else {
            if ( typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%OFFICEEMAIL%\}/ig, this.groupSetting.email);
            }
          }
          if ( this.clientSetting.fax ) {
            tmpHtml = tmpHtml.replace(/\{%OFFICEFAX%\}/ig, this.clientSetting.fax);
          } else {
            if ( typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%OFFICEFAX%\}/ig, this.groupSetting.fax);
            }
          }
          if ( this.clientSetting.street ) {
            tmpHtml = tmpHtml.replace(/\{%OFFICESTREET%\}/ig, this.clientSetting.street);
          } else {
            tmpHtml = tmpHtml.replace(/\{%OFFICESTREET%\}/ig, '');
          }
          if ( this.clientSetting.suburb ) {
            tmpHtml = tmpHtml.replace(/\{%OFFICESUBURB%\}/ig, this.clientSetting.suburb);
          } else {
            tmpHtml = tmpHtml.replace(/\{%OFFICESUBURB%\}/ig, '');
          }
          if ( this.clientSetting.state_abbr ) {
            tmpHtml = tmpHtml.replace(/\{%OFFICESTATE%\}/ig, this.clientSetting.state_abbr);
          } else {
            if ( typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%OFFICESTATE%\}/ig, this.groupSetting.state_abbr);
            }
          }
          if ( this.clientSetting.postcode ) {
            tmpHtml = tmpHtml.replace(/\{%OFFICEPOSTCODE%\}/ig, this.clientSetting.postcode);
          } else {
            if ( typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%OFFICEPOSTCODE%\}/ig, this.groupSetting.postcode);
            }
          }

          // Non-Class Setting - Merge Field
          if ( this.clientSetting.color_1 ) {
            tmpHtml = tmpHtml.replace(/\{%COLOR1%\}/ig, this.clientSetting.color_1);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%COLOR1%\}/ig, this.groupSetting.color_1);
            }
          }
          if ( this.clientSetting.color_2 ) {
            tmpHtml = tmpHtml.replace(/\{%COLOR2%\}/ig, this.clientSetting.color_2);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%COLOR2%\}/ig, this.groupSetting.color_2);
            }
          }
          if ( this.clientSetting.color_3 ) {
            tmpHtml = tmpHtml.replace(/\{%COLOR3%\}/ig, this.clientSetting.color_3);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%COLOR3%\}/ig, this.groupSetting.color_3);
            }
          }
          if ( this.clientSetting.color_4 ) {
            tmpHtml = tmpHtml.replace(/\{%COLOR4%\}/ig, this.clientSetting.color_4);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%COLOR4%\}/ig, this.groupSetting.color_4);
            }
          }
          if ( this.clientSetting.color_5 ) {
            tmpHtml = tmpHtml.replace(/\{%COLOR5%\}/ig, this.clientSetting.color_5);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%COLOR5%\}/ig, this.groupSetting.color_5);
            }
          }
          if ( this.clientSetting.color_6 ) {
            tmpHtml = tmpHtml.replace(/\{%FONTCOLOR1%\}/ig, this.clientSetting.color_6);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%FONTCOLOR1%\}/ig, this.groupSetting.color_6);
            }
          }
          if ( this.clientSetting.color_7 ) {
            tmpHtml = tmpHtml.replace(/\{%FONTCOLOR2%\}/ig, this.clientSetting.color_7);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%FONTCOLOR2%\}/ig, this.groupSetting.color_7);
            }
          }
          if ( this.clientSetting.color_8 ) {
            tmpHtml = tmpHtml.replace(/\{%ICONCOLOR1%\}/ig, this.clientSetting.color_8);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%ICONCOLOR1%\}/ig, this.groupSetting.color_8);
            }
          }
          if ( this.clientSetting.font_family ) {
            tmpHtml = tmpHtml.replace(/\{%FONTFAMILY%\}/ig, this.clientSetting.font_family);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%FONTFAMILY%\}/ig, this.groupSetting.font_family);
            }
          }

          // low res logo
          if ( this.clientSetting.primary_logo ) {
            tmpHtml = tmpHtml.replace(/\{%PRIMARYLOGO%\}/ig, this.clientSetting.primary_logo);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%PRIMARYLOGO%\}/ig, this.groupSetting.primary_logo);
            }
          }
          if ( this.clientSetting.secondary_logo ) {
            tmpHtml = tmpHtml.replace(/\{%SECONDARYLOGO%\}/ig, this.clientSetting.secondary_logo);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%SECONDARYLOGO%\}/ig, this.groupSetting.secondary_logo);
            }
          }

          // high res logo
          if ( this.clientSetting.hires_primary_logo ) {
            tmpHtml = tmpHtml.replace(/\{%PRIMARYLOGOHIRES%\}/ig, this.clientSetting.hires_primary_logo);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%PRIMARYLOGOHIRES%\}/ig, this.groupSetting.hires_primary_logo);
            }
          }
          if ( this.clientSetting.hires_secondary_logo ) {
            tmpHtml = tmpHtml.replace(/\{%SECONDARYLOGOHIRES%\}/ig, this.clientSetting.hires_secondary_logo);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%SECONDARYLOGOHIRES%\}/ig, this.groupSetting.hires_secondary_logo);
            }
          }

          if ( this.clientSetting.link_facebook ) {
            tmpHtml = tmpHtml.replace(/\{%FACEBOOKURL%\}/ig, this.clientSetting.link_facebook);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%FACEBOOKURL%\}/ig, this.groupSetting.link_facebook);
            }
          }
          if ( this.clientSetting.link_twitter ) {
            tmpHtml = tmpHtml.replace(/\{%TWITTERURL%\}/ig, this.clientSetting.link_twitter);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%TWITTERURL%\}/ig, this.groupSetting.link_twitter);
            }
          }
          if ( this.clientSetting.link_instagram ) {
            tmpHtml = tmpHtml.replace(/\{%INSTAGRAMURL%\}/ig, this.clientSetting.link_instagram);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%INSTAGRAMURL%\}/ig, this.groupSetting.link_instagram);
            }
          }
          if ( this.clientSetting.link_youtube ) {
            tmpHtml = tmpHtml.replace(/\{%YOUTUBEURL%\}/ig, this.clientSetting.link_youtube);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%YOUTUBEURL%\}/ig, this.groupSetting.link_youtube);
            }
          }
          if ( this.clientSetting.link_linkedin ) {
            tmpHtml = tmpHtml.replace(/\{%LINKEDINURL%\}/ig, this.clientSetting.link_linkedin);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%LINKEDINURL%\}/ig, this.groupSetting.link_linkedin);
            }
          }
          if ( this.clientSetting.link_gplus ) {
            tmpHtml = tmpHtml.replace(/\{%GPLUSURL%\}/ig, this.clientSetting.link_gplus);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%GPLUSURL%\}/ig, this.groupSetting.link_gplus);
            }
          }
          if ( this.clientSetting.link_pinterest ) {
            tmpHtml = tmpHtml.replace(/\{%PINTERESTURL%\}/ig, this.clientSetting.link_pinterest);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%PINTERESTURL%\}/ig, this.groupSetting.link_pinterest);
            }
          }
          if ( this.clientSetting.link_website ) {
            tmpHtml = tmpHtml.replace(/\{%WEBSITEURL%\}/ig, this.clientSetting.link_website);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%WEBSITEURL%\}/ig, this.groupSetting.link_website);
            }
          }
          if ( this.clientSetting.link_short_website ) {
            tmpHtml = tmpHtml.replace(/\{%SHORTWEBSITEURL%\}/ig, this.clientSetting.link_short_website);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%SHORTWEBSITEURL%\}/ig, this.groupSetting.link_short_website);
            }
          }
          if ( this.clientSetting.link_buy ) {
            tmpHtml = tmpHtml.replace(/\{%BUYURL%\}/ig, this.clientSetting.link_buy);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%BUYURL%\}/ig, this.groupSetting.link_buy);
            }
          }
          if ( this.clientSetting.link_sell ) {
            tmpHtml = tmpHtml.replace(/\{%SELLURL%\}/ig, this.clientSetting.link_sell);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%SELLURL%\}/ig, this.groupSetting.link_sell);
            }
          }
          if ( this.clientSetting.link_rent ) {
            tmpHtml = tmpHtml.replace(/\{%RENTURL%\}/ig, this.clientSetting.link_rent);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%RENTURL%\}/ig, this.groupSetting.link_rent);
            }
          }
          if ( this.clientSetting.link_unsubscribe ) {
            tmpHtml = tmpHtml.replace(/\{%UNSUBSCRIBEURL%\}/ig, this.clientSetting.link_unsubscribe);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%UNSUBSCRIBEURL%\}/ig, this.groupSetting.link_unsubscribe);
            }
          }
          if ( this.clientSetting.link_home ) {
            tmpHtml = tmpHtml.replace(/\{%HOMEURL%\}/ig, this.clientSetting.link_home);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%HOMEURL%\}/ig, this.groupSetting.link_home);
            }
          }
          if ( this.clientSetting.link_about ) {
            tmpHtml = tmpHtml.replace(/\{%ABOUTURL%\}/ig, this.clientSetting.link_about);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%ABOUTURL%\}/ig, this.groupSetting.link_about);
            }
          }
          if ( this.clientSetting.link_careers ) {
            tmpHtml = tmpHtml.replace(/\{%CAREERSURL%\}/ig, this.clientSetting.link_careers);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%CAREERSURL%\}/ig, this.groupSetting.link_careers);
            }
          }
          if ( this.clientSetting.link_blog ) {
            tmpHtml = tmpHtml.replace(/\{%BLOGURL%\}/ig, this.clientSetting.link_blog);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%BLOGURL%\}/ig, this.groupSetting.link_blog);
            }
          }
          if ( this.clientSetting.link_contact ) {
            tmpHtml = tmpHtml.replace(/\{%CONTACTURL%\}/ig, this.clientSetting.link_contact);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%CONTACTURL%\}/ig, this.groupSetting.link_contact);
            }
          }
          if ( this.clientSetting.primary_icon_bed ) {
            tmpHtml = tmpHtml.replace(/\{%PRIMARYICONBED%\}/ig, this.clientSetting.primary_icon_bed);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%PRIMARYICONBED%\}/ig, this.groupSetting.primary_icon_bed);
            }
          }
          if ( this.clientSetting.primary_icon_bath ) {
            tmpHtml = tmpHtml.replace(/\{%PRIMARYICONBATH%\}/ig, this.clientSetting.primary_icon_bath);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%PRIMARYICONBATH%\}/ig, this.groupSetting.primary_icon_bath);
            }
          }
          if ( this.clientSetting.primary_icon_car ) {
            tmpHtml = tmpHtml.replace(/\{%PRIMARYICONCAR%\}/ig, this.clientSetting.primary_icon_car);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%PRIMARYICONCAR%\}/ig, this.groupSetting.primary_icon_car);
            }
          }
          if ( this.clientSetting.secondary_icon_bed ) {
            tmpHtml = tmpHtml.replace(/\{%SECONDARYICONBED%\}/ig, this.clientSetting.secondary_icon_bed);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%SECONDARYICONBED%\}/ig, this.groupSetting.secondary_icon_bed);
            }
          }
          if ( this.clientSetting.secondary_icon_bath ) {
            tmpHtml = tmpHtml.replace(/\{%SECONDARYICONBATH%\}/ig, this.clientSetting.secondary_icon_bath);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%SECONDARYICONBATH%\}/ig, this.groupSetting.secondary_icon_bath);
            }
          }
          if ( this.clientSetting.secondary_icon_car ) {
            tmpHtml = tmpHtml.replace(/\{%SECONDARYICONCAR%\}/ig, this.clientSetting.secondary_icon_car);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%SECONDARYICONCAR%\}/ig, this.groupSetting.secondary_icon_car);
            }
          }
          if ( this.clientSetting.disclaimer_email ) {
            tmpHtml = tmpHtml.replace(/\{%DISCLAIMEREMAIL%\}/ig, this.clientSetting.disclaimer_email);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%DISCLAIMEREMAIL%\}/ig, this.groupSetting.disclaimer_email);
            }
          }
          if ( this.clientSetting.disclaimer_print ) {
            tmpHtml = tmpHtml.replace(/\{%DISCLAIMERPRINT%\}/ig, this.clientSetting.disclaimer_print);
          } else {
            if (typeof this.groupSetting !== 'undefined') {
              tmpHtml = tmpHtml.replace(/\{%DISCLAIMERPRINT%\}/ig, this.groupSetting.disclaimer_print);
            }
          }

          let legal_1 = '';
          let legal_2 = '';
          let legal_3 = '';

          if ( this.clientSetting.legal_1 !== null ) {
            legal_1 = this.clientSetting.legal_1;
          } else {
            if ( typeof this.groupSetting !== 'undefined' && this.groupSetting.legal_1 !== null ) {
              legal_1 = this.clientSetting.legal_1;
            }
          }
          tmpHtml = tmpHtml.replace(/\{%LEGAL1%\}/ig, legal_1);

          if ( this.clientSetting.legal_2 !== null ) {
            legal_2 = this.clientSetting.legal_2;
          } else {
            if ( typeof this.groupSetting !== 'undefined' && this.groupSetting.legal_2 !== null ) {
              legal_2 = this.clientSetting.legal_2;
            }
          }
          tmpHtml = tmpHtml.replace(/\{%LEGAL2%\}/ig, legal_2);

          if ( this.clientSetting.legal_3 !== null ) {
            legal_3 = this.clientSetting.legal_3;
          } else {
            if ( typeof this.groupSetting !== 'undefined' && this.groupSetting.legal_3 !== null ) {
              legal_3 = this.clientSetting.legal_3;
            }
          }
          tmpHtml = tmpHtml.replace(/\{%LEGAL3%\}/ig, legal_3);

          if (this.template.category_id !== 4 &&
              this.template.category_id !== 8 &&
              this.template.category_id !== 5) {

                selectedBlock.components('');
                selectedBlock.set('content', tmpHtml);

                const selectedBlockHTML = selectedBlock.toHTML();

                elementBlock = $(selectedBlockHTML);
          } else {
            elementBlock.html(tmpHtml);
          }
        }

        if ( this.template.category_id === 1 ) {
          elementBlock.find('table').first().attr('data-propid', listing.id);
        }

        if ( typeof this._tmp_order_images[listing.id] !== 'undefined' ) {
          listing.images = this._tmp_order_images[listing.id];
        }

        if (listing.images !== null && listing.images.length > 0) {
          const imgEl = elementBlock.find('.md-prop-field-image')
            .attr('src', listing.images[0].url);
          const imgElHighRes = elementBlock.find('.md-prop-field-hiresimage')
            .attr('src', listing.images[0].hiresurl);

          if (this.template.category_id !== 7 &&
            this.template.category_id !== 1 &&
            this.template.category_id !== 2 &&
            this.template.category_id !== 3) {
              if ( typeof imgEl !== 'undefined' ) {
                imgEl.css({top: 0, left: 0});
              }

              if ( typeof imgElHighRes !== 'undefined' ) {
                imgElHighRes.css({top: 0, left: 0});
              }
          }
          // const imgParentEl = imgEl.parent();

          for ( let i = 0; i < (listing.images).length; i++ ) {
            const idx = i + 1;

            const imgElSub = elementBlock.find('.md-prop-field-image-' + idx)
              .attr('src', listing.images[i].url);
            const imgElSubHighRes = elementBlock.find('.md-prop-field-hiresimage-' + idx)
              .attr('src', listing.images[i].hiresurl);

            if (this.template.category_id !== 7 &&
              this.template.category_id !== 1 &&
              this.template.category_id !== 2 &&
              this.template.category_id !== 3) {
                if ( typeof imgElSub !== 'undefined' ) {
                  imgElSub.css({top: 0, left: 0});
                }

                if ( typeof imgElSubHighRes !== 'undefined' ) {
                  imgElSubHighRes.css({top: 0, left: 0});
                }
            }
          }
        }

        const listing_floorplans = ( listing.floorplans ) ? listing.floorplans : '';
        elementBlock.find('.md-prop-field-imagefloorplan-sml')
          .attr('src', listing_floorplans).removeAttr('style');
        elementBlock.find('.md-prop-field-imagefloorplan-lrg')
          .attr('src', listing_floorplans).removeAttr('style');

        if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
          if ( elementBlock.find('[class*="md-prop-field-bulletpoint-"]').length > 0 ) {
            for ( let i = 0; i < elementBlock.find('[class*="md-prop-field-bulletpoint-"]').length; i++ ) {
              const bullet_number = i + 1;
  
              if ( typeof listing.bulletpoints[i] !== 'undefined' ) {
                elementBlock.find('.md-prop-field-bulletpoint-' + bullet_number).html(listing.bulletpoints[i].item);
              } else {
                elementBlock.find('.md-prop-field-bulletpoint-' + bullet_number).html('');
              }
            }
          }
        }

        elementBlock.find('.md-prop-field-auctiondate-title').html('');
        if (listing.auctiondate != null) {
          elementBlock.find('.md-prop-field-listing-type').html('For Auction');
          elementBlock.find('.md-prop-field-status').html('For Auction');
          elementBlock.find('.md-prop-field-rh-status').html('Guide');

          elementBlock.find('.md-prop-field-auctiondate-title').html('<b>Auction</b> ' + listing.auctiondate);
        } else {
          if (listing.listing_type === 'sale') {
            elementBlock.find('.md-prop-field-listing-type').html('For Sale');
            elementBlock.find('.md-prop-field-status').html('For Sale');
            elementBlock.find('.md-prop-field-rh-status').html('Guide');
          }
          if (listing.listing_type === 'rent') {
            elementBlock.find('.md-prop-field-listing-type').html('For Rent');
            elementBlock.find('.md-prop-field-status').html('For Rent');
            elementBlock.find('.md-prop-field-rh-status').html('Lease');
          }
          if (listing.listing_type === 'rent' && listing.listing_category === 'commercial') {
            elementBlock.find('.md-prop-field-listing-type').html('For Lease');
            elementBlock.find('.md-prop-field-status').html('For Lease');
            elementBlock.find('.md-prop-field-rh-status').html('Lease');
          }
          if (listing.listing_type === 'rent') {
            elementBlock.find('.md-prop-field-listing-type').html('For Rent');
            elementBlock.find('.md-prop-field-status').html('For Rent');
            elementBlock.find('.md-prop-field-rh-status').html('Lease');
          }
          if (listing.listing_type === 'rent' &&  ( listing.status === 'settled' || listing.status === 'leased' ) ) {
            elementBlock.find('.md-prop-field-status').html('Leased');
            elementBlock.find('.md-prop-field-rh-status').html('Leased');
          }
          if (listing.listing_type === 'sale' && listing.status === 'settled') {
            elementBlock.find('.md-prop-field-status').html('Sold');
            elementBlock.find('.md-prop-field-rh-status').html('Sold');
          }
          if (listing.listing_category === 'holidayRental') {
            elementBlock.find('.md-prop-field-status').html('Holiday Rental');
          }
        }

        elementBlock.find('.md-prop-field-heading').html(listing.heading);
        elementBlock.find('.md-prop-field-beds').html(listing.beds);
        elementBlock.find('.md-prop-field-baths').html(listing.baths);
        elementBlock.find('.md-prop-field-cars').html(listing.cars);
        elementBlock.find('.md-prop-field-open-parking').html(listing.openparkingspaces);
        elementBlock.find('.md-prop-field-price').html(listing.price);
        if ( listing.sales && typeof listing.sales.saleprice !== 'undefined' && listing.sales.saleprice ) {
          elementBlock.find('.md-prop-field-price').html(listing.sales.saleprice);
        }

        if ( this.frontService.authService.getApp() === 'Designly' ) {
          elementBlock.find('[href*="rh.com.au"]').each(function() {
            if ( $this.authUser.client.group_id === 12 ) {
              let propertyUrl = 'https://www.raineandhorne.com.au/';

              if ( listing.saleLifeId !== null ) {
                propertyUrl = `${propertyUrl}L${listing.saleLifeId}`;
              }

              if ( listing.leaseLifeId !== null ) {
                propertyUrl = `${propertyUrl}R${listing.leaseLifeId}`;
              }

              $(this).attr('href', propertyUrl);
            }
          });
        }

        let address_unitnum = '';

        if ( listing.address_unitnum !== null ) {
          address_unitnum = listing.address_unitnum + '/';
          elementBlock.find('.md-prop-field-unitnum').html(listing.address_unitnum);
        }

        elementBlock.find('.md-prop-field-address').html(listing.displayaddress);
        if ( listing.address_streetnum !== null ) {
          elementBlock.find('.md-prop-field-streetnum').html(address_unitnum + listing.address_streetnum);
        }
        if ( listing.address_street !== null ) {
          elementBlock.find('.md-prop-field-street').html(listing.address_street);
        }
        if ( listing.address_suburb !== null ) {
          elementBlock.find('.md-prop-field-suburb').html(listing.address_suburb);
        }
        if ( listing.address_state !== null ) {
          elementBlock.find('.md-prop-field-state').html(listing.address_state);
        }

        elementBlock.find('.md-prop-field-landarea').html(listing.landarea);
        if ( typeof listing.landarea !== 'undefined' && listing.landarea !== 0 && listing.landarea !== null ) {
          elementBlock.find('.md-prop-field-landareatype').html(listing.landareatype);
          elementBlock.find('.md-prop-field-landarea-title').html('<b>Land size</b>&nbsp' + listing.landarea + listing.landareatype);
        }

        elementBlock.find('.md-prop-field-description').html(listing.description);
        elementBlock.find('.md-prop-field-description-50').html(listing.description.substring(0, 50));
        elementBlock.find('.md-prop-field-description-100').html(listing.description.substring(0, 100));
        elementBlock.find('.md-prop-field-description-200').html(listing.description.substring(0, 200));
        elementBlock.find('.md-prop-field-description-300').html(listing.description.substring(0, 300));
        elementBlock.find('.md-prop-field-description-400').html(listing.description.substring(0, 400));
        elementBlock.find('.md-prop-field-description-500').html(listing.description.substring(0, 500));
        elementBlock.find('.md-prop-field-description-600').html(listing.description.substring(0, 600));

        const listing_id = ( listing.id ) ? listing.id : ' ';
        elementBlock.find('.md-prop-field-id').html(listing_id);

        const listing_refid = ( listing.refid ) ? listing.refid : ' ';
        elementBlock.find('.md-prop-field-refid').html(listing_refid);

        const listing_propertytype = ( listing.propertytype ) ? listing.propertytype : ' ';
        elementBlock.find('.md-prop-field-proptype').html(listing_propertytype);

        if ( listing.listing_category !== 'land' ) {
          const listing_buildingarea = ( listing.buildingarea ) ? listing.buildingarea  : ' ';
          elementBlock.find('.md-prop-field-buildingarea').html(listing_buildingarea);
        } else {
          elementBlock.find('.md-prop-field-buildingarea').html(' ');
        }

        const listing_landarea = ( listing.landarea ) ? listing.landarea : ' ';
        elementBlock.find('.md-prop-field-landarea').html(listing_landarea);

        const listing_tenderdate = ( listing.tenderdate ) ? listing.tenderdate : ' ';
        elementBlock.find('.md-prop-field-tenderenddate').html(listing_tenderdate);

        let listing_agent1_name = ' ';
        let listing_agent1_imageurl = '';
        let listing_agent1_email = ' ';

        let listing_agent2_name = ' ';
        let listing_agent2_imageurl = '';
        let listing_agent2_email = ' ';

        if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
          if ( typeof listing.rates.water.amount !== 'undefined' && listing.rates.water.amount !== null) {
            elementBlock.find('.md-prop-field-waterrates').html(listing.rates.water.amount);
          }

          if ( typeof listing.rates.strata.amount !== 'undefined' && listing.rates.strata.amount !== null) {
            elementBlock.find('.md-prop-field-stratarates').html(listing.rates.strata.amount);
          }

          if ( typeof listing.rates.council.amount !== 'undefined' && listing.rates.council.amount !== null) {
            elementBlock.find('.md-prop-field-councilrate').html(listing.rates.council.amount);
          }

          if (listing.agent1.firstname && listing.agent1.lastname) {
            listing_agent1_name = listing.agent1.firstname + ' ' + listing.agent1.lastname;
          }
          elementBlock.find('.md-prop-field-lname').html(listing_agent1_name);

          let listing_agent1_mobiledisplay = ( listing.agent1.mobiledisplay ) ? listing.agent1.mobiledisplay : ' ';
          listing_agent1_mobiledisplay = listing_agent1_mobiledisplay.replace('+61', '').replace('+64', '').trim();

          if ( listing_agent1_mobiledisplay ) {
            listing_agent1_mobiledisplay = String(listing_agent1_mobiledisplay);
            if ( !listing_agent1_mobiledisplay.startsWith('1800') && listing_agent1_mobiledisplay.charAt(0) !== '0' ) {
              listing_agent1_mobiledisplay = '0' + listing_agent1_mobiledisplay;
            }
          }
          elementBlock.find('.md-prop-field-lmobile').html( listing_agent1_mobiledisplay );

          listing_agent1_email = ( listing.agent1.email ) ? listing.agent1.email : ' ';
          elementBlock.find('.md-prop-field-lemail').html(listing_agent1_email);

          listing_agent1_imageurl = ( listing.agent1.imageurl ) ? listing.agent1.imageurl : '';
          elementBlock.find('.md-prop-field-limage').attr('src', listing_agent1_imageurl).css('display', 'inline');
          if ( !listing_agent1_imageurl ) {
            elementBlock.find('.md-prop-field-limage').css('display', 'none');
          }

          const listing_agent1_telephone = ( listing.agent1.telephone ) ? listing.agent1.telephone : ' ';
          elementBlock.find('.md-prop-field-lphone').html(listing_agent1_telephone);

          if (listing.agent2.firstname  && listing.agent2.lastname) {
            listing_agent2_name = listing.agent2.firstname + ' ' + listing.agent2.lastname;
          }
          elementBlock.find('.md-prop-field-lname2').html(listing_agent2_name);

          let listing_agent2_mobiledisplay = ( listing.agent2.mobiledisplay ) ? listing.agent2.mobiledisplay : ' ';
          listing_agent2_mobiledisplay = listing_agent2_mobiledisplay.replace('+61', '').replace('+64', '').trim();
          if ( listing_agent2_mobiledisplay ) {
            listing_agent2_mobiledisplay = String(listing_agent2_mobiledisplay);
            if ( !listing_agent2_mobiledisplay.startsWith('1800') && listing_agent2_mobiledisplay.charAt(0) !== '0' ) {
              listing_agent2_mobiledisplay = '0' + listing_agent2_mobiledisplay;
            }
          }
          elementBlock.find('.md-prop-field-lmobile2').html( listing_agent2_mobiledisplay );

          listing_agent2_email = ( listing.agent2.email ) ? listing.agent2.email : ' ';
          elementBlock.find('.md-prop-field-lemail2').html(listing_agent2_email);

          listing_agent2_imageurl = ( listing.agent2.imageurl ) ? listing.agent2.imageurl : '';
          elementBlock.find('.md-prop-field-limage2').attr('src', listing_agent2_imageurl).css('display', 'inline');
          if ( !listing_agent2_imageurl ) {
            elementBlock.find('.md-prop-field-limage2').css('display', 'none');
          }

          const listing_agent2_telephone = ( listing.agent2.telephone ) ? listing.agent2.telephone : ' ';
          elementBlock.find('.md-prop-field-lphone2').html(listing_agent2_telephone);
        }

        if ( this.frontService.authService.getApp() === 'Designly' ) {
          if ( listing.agent1 !== null ) {
            if (listing.agent1.firstname && listing.agent1.lastname) {
              listing_agent1_name = listing.agent1.firstname + ' ' + listing.agent1.lastname;
            }
            elementBlock.find('.md-prop-field-lname').html(listing_agent1_name);

            let listing_agent1_mobiledisplay = ( listing.agent1.mobiledisplay ) ? listing.agent1.mobiledisplay : ' ';
            listing_agent1_mobiledisplay = listing_agent1_mobiledisplay.replace('+61', '').replace('+64', '').trim();

            if ( listing_agent1_mobiledisplay ) {
              listing_agent1_mobiledisplay = String(listing_agent1_mobiledisplay);
              if ( !listing_agent1_mobiledisplay.startsWith('1800') && listing_agent1_mobiledisplay.charAt(0) !== '0' ) {
                listing_agent1_mobiledisplay = '0' + listing_agent1_mobiledisplay;
              }
            }
            elementBlock.find('.md-prop-field-lmobile').html( listing_agent1_mobiledisplay );

            listing_agent1_email = ( listing.agent1.email ) ? listing.agent1.email : ' ';
            elementBlock.find('.md-prop-field-lemail').html(listing_agent1_email);

            listing_agent1_imageurl = ( listing.agent1.imageurl ) ? listing.agent1.imageurl : '';
            elementBlock.find('.md-prop-field-limage').attr('src', listing_agent1_imageurl).css('display', 'inline');
            if ( !listing_agent1_imageurl ) {
              elementBlock.find('.md-prop-field-limage').css('display', 'none');
            }

            const listing_agent1_telephone = ( listing.agent1.telephone ) ? listing.agent1.telephone : ' ';
            elementBlock.find('.md-prop-field-lphone').html(listing_agent1_telephone);
          }

          if ( listing.agent2 !== null ) {
            if (listing.agent2.firstname  && listing.agent2.lastname) {
              listing_agent2_name = listing.agent2.firstname + ' ' + listing.agent2.lastname;
            }
            let listing_agent2_mobiledisplay = ( listing.agent2.mobiledisplay ) ? listing.agent2.mobiledisplay : ' ';
            listing_agent2_mobiledisplay = listing_agent2_mobiledisplay.replace('+61', '').replace('+64', '').trim();
            if ( listing_agent2_mobiledisplay ) {
              listing_agent2_mobiledisplay = String(listing_agent2_mobiledisplay);
              if ( !listing_agent2_mobiledisplay.startsWith('1800') && listing_agent2_mobiledisplay.charAt(0) !== '0' ) {
                listing_agent2_mobiledisplay = '0' + listing_agent2_mobiledisplay;
              }
            }
            elementBlock.find('.md-prop-field-lmobile2').html( listing_agent2_mobiledisplay );

            listing_agent2_email = ( listing.agent2.email ) ? listing.agent2.email : ' ';
            elementBlock.find('.md-prop-field-lemail2').html(listing_agent2_email);

            listing_agent2_imageurl = ( listing.agent2.imageurl ) ? listing.agent2.imageurl : '';
            elementBlock.find('.md-prop-field-limage2').attr('src', listing_agent2_imageurl).css('display', 'inline');
            if ( !listing_agent2_imageurl ) {
              elementBlock.find('.md-prop-field-limage2').css('display', 'none');
            }

            const listing_agent2_telephone = ( listing.agent2.telephone ) ? listing.agent2.telephone : ' ';
            elementBlock.find('.md-prop-field-lphone2').html(listing_agent2_telephone);
          } else {
            elementBlock.find('.md-prop-field-lmobile2').html('');
            elementBlock.find('.md-prop-field-lphone2').html('');
            elementBlock.find('.md-prop-field-limage2').html('');
            elementBlock.find('.md-prop-field-lname2').html('');
            elementBlock.find('.md-prop-field-lemail2').html('');
          }

          elementBlock.find('.md-prop-field-lname2').html(listing_agent2_name);
        }

        if ( typeof listing.buildingareatype !== 'undefined' && listing.listing_category !== 'land' ) {
          elementBlock.find('.md-prop-field-buildingareatype').html( listing.buildingareatype );
        }

        if ( this.authUser.provider === 'mydesktop' ) {
          elementBlock.find('.md-prop-field-buildingareatype').html( 'sqm' );
        }

        const listing_dateavailable = ( listing.dateavailable ) ? listing.dateavailable : ' ';
        elementBlock.find('.md-prop-field-dateavailable').html(listing_dateavailable);

        const listing_tenancydetails = ( listing.tenancydetails ) ? listing.tenancydetails : ' ';
        elementBlock.find('.md-prop-field-tenancydetails').html(listing_tenancydetails);

        const listing_legal_description = ( listing.legal_description ) ? listing.legal_description : ' ';
        elementBlock.find('.md-prop-field-legaldescription').html(listing_legal_description);

        const listing_legal_landvalue = ( listing.legal_landvalue ) ? listing.legal_landvalue : ' ';
        elementBlock.find('.md-prop-field-landvalue').html(listing_legal_landvalue);

        const listing_legal_localauthority = ( listing.legal_localauthority ) ? listing.legal_localauthority : ' ';
        elementBlock.find('.md-prop-field-localauthority').html(listing_legal_localauthority);

        const listing_legal_lot = ( listing.legal_lot ) ? listing.legal_lot : ' ';
        elementBlock.find('.md-prop-field-lot').html(listing_legal_lot);

        const listing_legal_rpdp = ( listing.legal_rpdp ) ? listing.legal_rpdp : ' ';
        elementBlock.find('.md-prop-field-rpdp').html(listing_legal_rpdp);

        const listing_legal_gvyear = ( listing.legal_gvyear ) ? listing.legal_gvyear : ' ';
        elementBlock.find('.md-prop-field-gvyear').html(listing_legal_gvyear);

        const listing_legal_governmentvalue = ( listing.legal_governmentvalue ) ? listing.legal_governmentvalue : ' ';
        elementBlock.find('.md-prop-field-govvalue').html(listing_legal_governmentvalue);

        const listing_legal_zoning = ( listing.legal_zoning ) ? listing.legal_zoning : ' ';
        elementBlock.find('.md-prop-com-zoning').html(listing_legal_zoning);

        elementBlock.find('.md-prop-com-leasesale').html(listing.leasesale);
        elementBlock.find('.md-prop-com-type').html(listing.commercialtypes);

        const listing_listingdate = ( listing.auctiondate ) ? listing.listingdate : ' ';
        elementBlock.find('.md-prop-field-listingdate').html(listing_listingdate);

        const listing_auctiondate = ( listing.auctiondate ) ? listing.auctiondate : '';
        elementBlock.find('.md-prop-field-auctiondate').html(listing_auctiondate);

        const listing_auctionvenue = ( listing.auctionvenue ) ? listing.auctionvenue : '';
        elementBlock.find('.md-prop-field-auctionvenue').html(listing_auctionvenue);

        if ( this.clientSetting.branch_name ) {
          elementBlock.find('.md-office-field-branch').html(this.clientSetting.branch_name);
        } else {
          if (typeof this.groupSetting !== 'undefined') {
            elementBlock.find('.md-office-field-branch').html(this.groupSetting.branch_name);
          }
        }

        let listing_auction_details = '';
        if ( listing_auctiondate !== ' ' ) {
          listing_auction_details = listing_auctiondate;
        }

        if ( listing_auctionvenue !== ' ' ) {
          listing_auction_details = `${listing_auction_details} ${listing_auctionvenue}`;
        }

        elementBlock.find('.md-prop-field-auction').html(listing_auction_details);

        // Non Class Property - Merge Field
        let elementBlockHtml = elementBlock.html();

        let listing_url = '#';

        if ( listing.url && listing.url !== '' ) {
          listing_url = listing.url;
        } else {
          if ( this.clientSetting.link_website !== '' ) {
            listing_url = this.clientSetting.link_website;
          } else {
            if ( this.groupSetting.link_website !== '' ) {
              listing_url = this.groupSetting.link_website;
            }
          }
        }

        elementBlockHtml = elementBlockHtml.replace(/\{%VIEWLINKURL%\}/ig, listing_url);

        const listing_videourl = ( listing.videourl ) ? listing.videourl : '';
        elementBlockHtml = elementBlockHtml.replace(/\{%VIDEOURL%\}/ig, listing_videourl);

        const listing_virtualtour = ( listing.virtualtour ) ? listing.virtualtour : '';
        elementBlockHtml = elementBlockHtml.replace(/\{%VIRTUALTOURURL%\}/ig, listing_virtualtour);
        elementBlockHtml = elementBlockHtml.replace(/\{%LPHOTO%\}/ig, listing_agent1_imageurl);
        elementBlockHtml = elementBlockHtml.replace(/\{%LPHOTO2%\}/ig, listing_agent2_imageurl);
        elementBlockHtml = elementBlockHtml.replace(/\{%LEMAIL%\}/ig, listing_agent1_email);
        elementBlockHtml = elementBlockHtml.replace(/\{%LEMAIL2%\}/ig, listing_agent2_email);
        elementBlockHtml = elementBlockHtml.replace(/\{%ID%\}/ig, listing_id);
        elementBlockHtml = elementBlockHtml.replace(/\{%OFFICEID%\}/ig, this.frontService.authService.auth.groupid);
        elementBlockHtml = elementBlockHtml.replace(/\{%REFID%\}/ig, listing_refid);
        elementBlockHtml = elementBlockHtml.replace(/\{%LEMAIL%\}/ig, listing_agent1_email);
        elementBlockHtml = elementBlockHtml.replace(/\{%LEMAIL2%\}/ig, listing_agent2_email);

        elementBlock.html(elementBlockHtml);

        elementBlock.find('.md-prop-field-opentime').html('By appointment');
        elementBlock.find('.md-prop-field-opentimes-title').html('');
        if ( listing.inspections && listing.inspections.length > 0 ) {

          if ( typeof listing.inspections[0].opendate !== 'undefined' && listing.inspections[0].opendate) {
            let listing_opentimes = moment(listing.inspections[0].opendate).format('dddd MMMM D [at] h:mma');
            if ( typeof listing.inspections[0].closedate !== 'undefined' && listing.inspections[0].closedate) {
              listing_opentimes += ' - ' + moment(listing.inspections[0].closedate).format('h:mma');
            }
            elementBlock.find('.md-prop-field-opentime').html(listing_opentimes);

            elementBlock.find('.md-prop-field-opentimes-title').html('<b>View</b> ' + listing_opentimes);
          }
        }

        if ( listing.sales ) {
          if ( typeof listing.sales.saledate !== 'undefined' && listing.sales.saledate ) {
            elementBlock.find('.md-prop-field-saledate')
              .html(moment(listing.sales.saledate).format('Do, MMM YYYY'));
          }
          let sale_price = listing.pricefrom;
          if ( typeof listing.sales.saleprice !== 'undefined' && listing.sales.saleprice ) {
            sale_price = listing.sales.saleprice;
          }
          const ratePerM2 = parseInt(sale_price, 0) / parseInt(listing.buildingarea, 0);

          elementBlock.find('.md-prop-field-rate').html(ratePerM2);
        }
        this.initScript();

        if (this.template.category_id === 5) {
          elementBlockGroup.append(elementBlock);
        } else if (this.template.category_id === 4 || this.template.category_id === 8) {
          this.editor.setComponents(elementBlock.html());
        } else {
          selectedBlock.set('content', elementBlock.html());

          if (idxListing < listings.length) {
            this.editor.runCommand('tlb-clone');

            if ( !this.property_guide_skip ) {
              selectedElement = this.editor.getSelected();
              elementBox = selectedElement.view.$el;

              if (elementBox.hasClass('md-prop-search')) {
                elementBox = elementBox.parents('.md-box');
                elementBox.trigger('click');

                selectedElement = this.editor.getSelected();
              }

              elementBlock = elementBox.find('.md-prop-box');
              selectedBlock = (selectedElement.find('.md-prop-box'))[0];

              if (elementBox.hasClass('md-prop-box')) {
                elementBlock = elementBox;
                selectedBlock = selectedElement;
              }
            }
          }
        }
      }

      let html = this.editor.getHtml();

      if (this.template.category_id === 5 || this.template.category_id === 6 || this.template.category_id === 9) {
        const body = this.editor.Canvas.getBody();
        html = $(body).find('#wrapper').html();
      }

      const html_data_css = this.editor.getCss();
      const html_raw = juice(html + '<style>' + html_data_css + '</style>', {
        preserveMediaQueries: false,
        preserveImportant: true,
        applyHeightAttributes: false,
        applyWidthAttributes: false
      });

      this.editor.setComponents(html_raw);

      setTimeout(
        () => {
          this.mdListingsForm.reset();
          this.mdListingsForm.setValue({
            'suburb': '',
            'classification': '',
            'listingtype': '',
            'status': '',
            'officeid': '',
            'agentid': '',
            'pricefrom': '',
            'priceto': '',
            'bedfrom': '',
            'bedto': '',
            'bathfrom': '',
            'bathto': '',
            'carfrom': '',
            'carto': '',
            'local_search': '0',
            'client_id': '',
            'orderby': 'modifydateDesc',
            'substatus': '',
            'available': '',
            'multioffice': false,
            'basedon': ''
          });
          this.mdPropSearchModalClose.nativeElement.click();
          this.subLoading = false;
        }, 200
      );

      this.selectedListings = [];
      this.selectedListingIDs = [];

      if ( this.ckeditor_active ) {
        for ( const name in CKEDITOR.instances ) {
          if ( name ) {
            CKEDITOR.instances[name].destroy(true);
          }
        }
      }
    } catch (err) {
      console.log(err);
      this.subLoading = false;
      swal(
        'Opps, something went wrong!',
        // tslint:disable-next-line:max-line-length
        'Kindly close this window then save your template and refresh the page to try again. If error persists please submit a support request',
        'error'
      );
    }
  }

  getLink(item: any) {
    if (item.type === 'file') {
      return this.frontService.appConfig.S3_URL + item.path;
    }
  }

  replace(text: string, search: string, replace: string) {
    return text.replace(search, replace);
  }

  clearListingResult() {
    this.mdListings = [];
    this.mdListingTotal = 0;
    this.mdListingCount = 0;
    this.mdListingCurrentPage = 1;
    this.mdListingPages = [];
  }

  onFeedback() {
    swal({
      title: 'We would love to hear from you about the new MyDesign',
      imageUrl: 'http://mydesign3.wbclients.com/mydesign/assets/images/message-square.svg',
      imageWidth: 300,
      imageHeight: 100,
      showConfirmButton: false,
      html: `
        <p>Please choose to provide either Feedback or log a Support Ticket</p>` +
        `<a
          class="btn btn-success btn-bh-feedback">
          Send Feedback
        </a> &nbsp;
        <a
          href="` + this.supportLink + `"
          target="_blank"
          class="btn btn-info btn-support-log">
          Log Support Ticket
        </a>`
      } );

      $('.btn-bh-feedback').click(function() {
        swal.close();
        _bugHerd.win.bugherd.applicationView.anonymousbar.toggleOptions();
      });

  }

  ngAfterViewInit() {
    const $this = this;

    if ( this.clientSetting.group.master_client_id === this.clientSetting.ID &&
        this.clientSetting.group.builder_ckeditor_font_family === 3
      ) {
      $('head').append(
        $('<style>').text(`
        .cke_combo.cke_combo__font {
          display: none;
        }
        `)
      );
    }
    if ( this.clientSetting.group.master_client_id !== this.clientSetting.ID &&
        this.clientSetting.group.builder_ckeditor_font_family === 2
      ) {
      $('head').append(
        $('<style>').text(`
        .cke_combo.cke_combo__font {
          display: none;
        }
        `)
      );
    }
    if ( this.clientSetting.group.builder_ckeditor_font_family === 0 ) {
      $('head').append(
        $('<style>').text(`
        .cke_combo.cke_combo__font {
          display: none;
        }
        `)
      );
    }

  }

  fillMergeText(html: string, type = 'replicate') {
    let elementHtml = html;

    const elementObj = $('<div>' + elementHtml + '</div>');

    if (type === 'subtitute') {
      elementObj.find('a[data-url*=\'{$\']').each(function(){
        const hrefValue = $(this).attr('data-url').replace(/\{\$/ig, '{%').replace(/\$\}/ig, '%}');

        if ( !$(this).data('updated') ) {
          $(this).attr('href', hrefValue);
        }
      });

      elementObj.find('[data-style*=\'{$\']').each(function(){
        const styleValue = $(this).attr('data-style').replace(/\{\$/ig, '{%').replace(/\$\}/ig, '%}');
        $(this).attr('style', styleValue);
      });

      elementObj.find('[data-bgcolor*=\'{$\']').each(function(){
        const bgcolorValue = $(this).attr('data-bgcolor').replace(/\{\$/ig, '{%').replace(/\$\}/ig, '%}');
        $(this).attr('bgcolor', bgcolorValue);
      });

      elementObj.find('img[data-src*=\'{$\']').each(function(){
        const imgValue = $(this).attr('data-src').replace(/\{\$/ig, '{%').replace(/\$\}/ig, '%}');
        $(this).attr('src', imgValue);
      });

      elementObj.find('[data-text*=\'{$\']').each(function(){
        const textValue = $(this).attr('data-text').replace(/\{\$/ig, '{%').replace(/\$\}/ig, '%}');
        $(this).html(textValue);
      });
    } else {
      elementObj.find('a[href*=\'{%\']').each(function(){
        const hrefValue = $(this).attr('href').replace(/\{%/ig, '{$').replace(/%\}/ig, '$}');
        $(this).attr('data-url', hrefValue);
      });

      elementObj.find('[style*=\'{%\']').each(function(){
        const styleValue = $(this).attr('style').replace(/\{%/ig, '{$').replace(/%\}/ig, '$}');
        $(this).attr('data-style', styleValue);
      });

      elementObj.find('[bgcolor*=\'{%\']').each(function(){
        const bgcolorValue = $(this).attr('bgcolor').replace(/\{%/ig, '{$').replace(/%\}/ig, '$}');
        $(this).attr('data-bgcolor', bgcolorValue);
      });

      elementObj.find('img[src*=\'{%\']').each(function(){
        const imgValue = $(this).attr('src').replace(/\{%/ig, '{$').replace(/%\}/ig, '$}');
        $(this).attr('data-src', imgValue);
      });

      elementObj.find(':not(:has(*)):contains(\'{%\')').each(function(){
        const textValue = $(this).html().replace(/\{%/ig, '{$').replace(/%\}/ig, '$}');
        $(this).attr('data-text', textValue);
        // return false;
      });
    }

    elementHtml = elementObj.html();

    // Non-Class User - Merge Field
    const template_agent_id = ( this.templateAgent.id ) ? this.templateAgent.id : '';
    elementHtml = elementHtml.replace(/\{%USERID%\}/ig, template_agent_id);

    const template_agent_email = ( this.templateAgent.email ) ? this.templateAgent.email : '';
    elementHtml = elementHtml.replace(/\{%USEREMAIL%\}/ig, template_agent_email);

    const template_agent_fax = ( this.templateAgent.fax ) ? this.templateAgent.fax : '';
    elementHtml = elementHtml.replace(/\{%USERFAX%\}/ig, template_agent_fax);

    const template_agent_firstname = ( this.templateAgent.firstname ) ? this.templateAgent.firstname : '';
    elementHtml = elementHtml.replace(/\{%USERFNAME%\}/ig, template_agent_firstname);

    const template_agent_lastname = ( this.templateAgent.lastname ) ? this.templateAgent.lastname : '';
    elementHtml = elementHtml.replace(/\{%USERLNAME%\}/ig, template_agent_lastname);

    elementHtml = elementHtml.replace(/\{%USERNAME%\}/ig, template_agent_firstname + ' ' + template_agent_lastname);

    const template_agent_imageurl = ( this.templateAgent.imageurl ) ? this.templateAgent.imageurl : '';
    elementHtml = elementHtml.replace(/\{%USERPHOTO%\}/ig, template_agent_imageurl);

    const template_agent_telephone = ( this.templateAgent.telephone ) ? this.templateAgent.telephone : '';
    elementHtml = elementHtml.replace(/\{%USERPHONE%\}/ig, template_agent_telephone);

    let template_agent_mobiledisplay = ( this.templateAgent.mobile ) ? this.templateAgent.mobile : '';
    template_agent_mobiledisplay = template_agent_mobiledisplay.replace('+61', '').replace('+64', '').trim();
    if (template_agent_mobiledisplay && template_agent_mobiledisplay.charAt(0) !== '0') {
      template_agent_mobiledisplay = '0' + template_agent_mobiledisplay;
    }
    elementHtml = elementHtml.replace(/\{%USERMOBILE%\}/ig, template_agent_mobiledisplay);

    // Non-Class Office Details - Merge Field
    elementHtml = elementHtml.replace(/\{%OFFICEID%\}/ig, this.frontService.authService.auth.groupid);
    elementHtml = elementHtml.replace(/\{%DATE%\}/ig, moment().format('Do, MMM YYYY'));

    if ( this.clientSetting.name) {
      elementHtml = elementHtml.replace(/\{%OFFICENAME%\}/ig, this.clientSetting.name);
    } else {
        elementHtml = elementHtml.replace(/\{%OFFICENAME%\}/ig, '');
    }

    if ( this.clientSetting.company_name ) {
      elementHtml = elementHtml.replace(/\{%OFFICEBUSINESS%\}/ig, this.clientSetting.company_name);
    } else {
      elementHtml = elementHtml.replace(/\{%OFFICEBUSINESS%\}/ig, '');
    }

    if ( this.clientSetting.branch_name ) {
      elementHtml = elementHtml.replace(/\{%OFFICEBRANCH%\}/ig, this.clientSetting.branch_name);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%OFFICEBRANCH%\}/ig, this.groupSetting.branch_name);
      }
    }

    if ( this.clientSetting.phone ) {
      elementHtml = elementHtml.replace(/\{%OFFICEPHONE%\}/ig, this.clientSetting.phone);
    } else {
        elementHtml = elementHtml.replace(/\{%OFFICEPHONE%\}/ig, '');
    }
    if ( this.clientSetting.email ) {
      elementHtml = elementHtml.replace(/\{%OFFICEEMAIL%\}/ig, this.clientSetting.email);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%OFFICEEMAIL%\}/ig, this.groupSetting.email);
      }
    }
    if ( this.clientSetting.fax ) {
      elementHtml = elementHtml.replace(/\{%OFFICEFAX%\}/ig, this.clientSetting.fax);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%OFFICEFAX%\}/ig, this.groupSetting.fax);
      }
    }
    if ( this.clientSetting.street ) {
      elementHtml = elementHtml.replace(/\{%OFFICESTREET%\}/ig, this.clientSetting.street);
    } else {
      elementHtml = elementHtml.replace(/\{%OFFICESTREET%\}/ig, '');
    }
    if ( this.clientSetting.suburb ) {
      elementHtml = elementHtml.replace(/\{%OFFICESUBURB%\}/ig, this.clientSetting.suburb);
    } else {
      elementHtml = elementHtml.replace(/\{%OFFICESUBURB%\}/ig, '');
    }
    if ( this.clientSetting.state_abbr ) {
      elementHtml = elementHtml.replace(/\{%OFFICESTATE%\}/ig, this.clientSetting.state_abbr);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%OFFICESTATE%\}/ig, this.groupSetting.state_abbr);
      }
    }
    if ( this.clientSetting.postcode ) {
      elementHtml = elementHtml.replace(/\{%OFFICEPOSTCODE%\}/ig, this.clientSetting.postcode);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%OFFICEPOSTCODE%\}/ig, this.groupSetting.postcode);
      }
    }

    // Non-Class Setting - Merge Field
    if ( this.clientSetting.color_1 ) {
      elementHtml = elementHtml.replace(/\{%COLOR1%\}/ig, this.clientSetting.color_1);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%COLOR1%\}/ig, this.groupSetting.color_1);
      }
    }
    if ( this.clientSetting.color_2 ) {
      elementHtml = elementHtml.replace(/\{%COLOR2%\}/ig, this.clientSetting.color_2);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%COLOR2%\}/ig, this.groupSetting.color_2);
      }
    }
    if ( this.clientSetting.color_3 ) {
      elementHtml = elementHtml.replace(/\{%COLOR3%\}/ig, this.clientSetting.color_3);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%COLOR3%\}/ig, this.groupSetting.color_3);
      }
    }
    if ( this.clientSetting.color_4 ) {
      elementHtml = elementHtml.replace(/\{%COLOR4%\}/ig, this.clientSetting.color_4);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%COLOR4%\}/ig, this.groupSetting.color_4);
      }
    }
    if ( this.clientSetting.color_5 ) {
      elementHtml = elementHtml.replace(/\{%COLOR5%\}/ig, this.clientSetting.color_5);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%COLOR5%\}/ig, this.groupSetting.color_5);
      }
    }
    if ( this.clientSetting.color_6 ) {
      elementHtml = elementHtml.replace(/\{%FONTCOLOR1%\}/ig, this.clientSetting.color_6);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%FONTCOLOR1%\}/ig, this.groupSetting.color_6);
      }
    }
    if ( this.clientSetting.color_7 ) {
      elementHtml = elementHtml.replace(/\{%FONTCOLOR2%\}/ig, this.clientSetting.color_7);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%FONTCOLOR2%\}/ig, this.groupSetting.color_7);
      }
    }
    if ( this.clientSetting.color_8 ) {
      elementHtml = elementHtml.replace(/\{%ICONCOLOR1%\}/ig, this.clientSetting.color_8);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%ICONCOLOR1%\}/ig, this.groupSetting.color_8);
      }
    }
    if ( this.clientSetting.font_family ) {
      elementHtml = elementHtml.replace(/\{%FONTFAMILY%\}/ig, this.clientSetting.font_family);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%FONTFAMILY%\}/ig, this.groupSetting.font_family);
      }
    }

    // low res logo
    if ( this.clientSetting.primary_logo ) {
      elementHtml = elementHtml.replace(/\{%PRIMARYLOGO%\}/ig, this.clientSetting.primary_logo);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%PRIMARYLOGO%\}/ig, this.groupSetting.primary_logo);
      }
    }
    if ( this.clientSetting.secondary_logo ) {
      elementHtml = elementHtml.replace(/\{%SECONDARYLOGO%\}/ig, this.clientSetting.secondary_logo);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%SECONDARYLOGO%\}/ig, this.groupSetting.secondary_logo);
      }
    }

    // high res logo
    if ( this.clientSetting.hires_primary_logo ) {
      elementHtml = elementHtml.replace(/\{%PRIMARYLOGOHIRES%\}/ig, this.clientSetting.hires_primary_logo);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%PRIMARYLOGOHIRES%\}/ig, this.groupSetting.hires_primary_logo);
      }
    }
    if ( this.clientSetting.hires_secondary_logo ) {
      elementHtml = elementHtml.replace(/\{%SECONDARYLOGOHIRES%\}/ig, this.clientSetting.hires_secondary_logo);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%SECONDARYLOGOHIRES%\}/ig, this.groupSetting.hires_secondary_logo);
      }
    }

    if ( this.clientSetting.link_facebook ) {
      elementHtml = elementHtml.replace(/\{%FACEBOOKURL%\}/ig, this.clientSetting.link_facebook);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%FACEBOOKURL%\}/ig, this.groupSetting.link_facebook);
      }
    }
    if ( this.clientSetting.link_twitter ) {
      elementHtml = elementHtml.replace(/\{%TWITTERURL%\}/ig, this.clientSetting.link_twitter);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%TWITTERURL%\}/ig, this.groupSetting.link_twitter);
      }
    }
    if ( this.clientSetting.link_instagram ) {
      elementHtml = elementHtml.replace(/\{%INSTAGRAMURL%\}/ig, this.clientSetting.link_instagram);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%INSTAGRAMURL%\}/ig, this.groupSetting.link_instagram);
      }
    }
    if ( this.clientSetting.link_youtube ) {
      elementHtml = elementHtml.replace(/\{%YOUTUBEURL%\}/ig, this.clientSetting.link_youtube);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%YOUTUBEURL%\}/ig, this.groupSetting.link_youtube);
      }
    }
    if ( this.clientSetting.link_linkedin ) {
      elementHtml = elementHtml.replace(/\{%LINKEDINURL%\}/ig, this.clientSetting.link_linkedin);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%LINKEDINURL%\}/ig, this.groupSetting.link_linkedin);
      }
    }
    if ( this.clientSetting.link_gplus ) {
      elementHtml = elementHtml.replace(/\{%GPLUSURL%\}/ig, this.clientSetting.link_gplus);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%GPLUSURL%\}/ig, this.groupSetting.link_gplus);
      }
    }
    if ( this.clientSetting.link_pinterest ) {
      elementHtml = elementHtml.replace(/\{%PINTERESTURL%\}/ig, this.clientSetting.link_pinterest);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%PINTERESTURL%\}/ig, this.groupSetting.link_pinterest);
      }
    }
    if ( this.clientSetting.link_website ) {
      elementHtml = elementHtml.replace(/\{%WEBSITEURL%\}/ig, this.clientSetting.link_website);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%WEBSITEURL%\}/ig, this.groupSetting.link_website);
      }
    }
    if ( this.clientSetting.link_short_website ) {
      elementHtml = elementHtml.replace(/\{%SHORTWEBSITEURL%\}/ig, this.clientSetting.link_short_website);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%SHORTWEBSITEURL%\}/ig, this.groupSetting.link_short_website);
      }
    }
    if ( this.clientSetting.link_buy ) {
      elementHtml = elementHtml.replace(/\{%BUYURL%\}/ig, this.clientSetting.link_buy);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%BUYURL%\}/ig, this.groupSetting.link_buy);
      }
    }
    if ( this.clientSetting.link_sell ) {
      elementHtml = elementHtml.replace(/\{%SELLURL%\}/ig, this.clientSetting.link_sell);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%SELLURL%\}/ig, this.groupSetting.link_sell);
      }
    }
    if ( this.clientSetting.link_rent ) {
      elementHtml = elementHtml.replace(/\{%RENTURL%\}/ig, this.clientSetting.link_rent);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%RENTURL%\}/ig, this.groupSetting.link_rent);
      }
    }
    if ( this.clientSetting.link_unsubscribe ) {
      elementHtml = elementHtml.replace(/\{%UNSUBSCRIBEURL%\}/ig, this.clientSetting.link_unsubscribe);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%UNSUBSCRIBEURL%\}/ig, this.groupSetting.link_unsubscribe);
      }
    }
    if ( this.clientSetting.link_home ) {
      elementHtml = elementHtml.replace(/\{%HOMEURL%\}/ig, this.clientSetting.link_home);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%HOMEURL%\}/ig, this.groupSetting.link_home);
      }
    }
    if ( this.clientSetting.link_about ) {
      elementHtml = elementHtml.replace(/\{%ABOUTURL%\}/ig, this.clientSetting.link_about);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%ABOUTURL%\}/ig, this.groupSetting.link_about);
      }
    }
    if ( this.clientSetting.link_careers ) {
      elementHtml = elementHtml.replace(/\{%CAREERSURL%\}/ig, this.clientSetting.link_careers);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%CAREERSURL%\}/ig, this.groupSetting.link_careers);
      }
    }
    if ( this.clientSetting.link_blog ) {
      elementHtml = elementHtml.replace(/\{%BLOGURL%\}/ig, this.clientSetting.link_blog);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%BLOGURL%\}/ig, this.groupSetting.link_blog);
      }
    }
    if ( this.clientSetting.link_contact ) {
      elementHtml = elementHtml.replace(/\{%CONTACTURL%\}/ig, this.clientSetting.link_contact);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%CONTACTURL%\}/ig, this.groupSetting.link_contact);
      }
    }
    if ( this.clientSetting.primary_icon_bed ) {
      elementHtml = elementHtml.replace(/\{%PRIMARYICONBED%\}/ig, this.clientSetting.primary_icon_bed);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%PRIMARYICONBED%\}/ig, this.groupSetting.primary_icon_bed);
      }
    }
    if ( this.clientSetting.primary_icon_bath ) {
      elementHtml = elementHtml.replace(/\{%PRIMARYICONBATH%\}/ig, this.clientSetting.primary_icon_bath);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%PRIMARYICONBATH%\}/ig, this.groupSetting.primary_icon_bath);
      }
    }
    if ( this.clientSetting.primary_icon_car ) {
      elementHtml = elementHtml.replace(/\{%PRIMARYICONCAR%\}/ig, this.clientSetting.primary_icon_car);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%PRIMARYICONCAR%\}/ig, this.groupSetting.primary_icon_car);
      }
    }
    if ( this.clientSetting.secondary_icon_bed ) {
      elementHtml = elementHtml.replace(/\{%SECONDARYICONBED%\}/ig, this.clientSetting.secondary_icon_bed);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%SECONDARYICONBED%\}/ig, this.groupSetting.secondary_icon_bed);
      }
    }
    if ( this.clientSetting.secondary_icon_bath ) {
      elementHtml = elementHtml.replace(/\{%SECONDARYICONBATH%\}/ig, this.clientSetting.secondary_icon_bath);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%SECONDARYICONBATH%\}/ig, this.groupSetting.secondary_icon_bath);
      }
    }
    if ( this.clientSetting.secondary_icon_car ) {
      elementHtml = elementHtml.replace(/\{%SECONDARYICONCAR%\}/ig, this.clientSetting.secondary_icon_car);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%SECONDARYICONCAR%\}/ig, this.groupSetting.secondary_icon_car);
      }
    }
    if ( this.clientSetting.disclaimer_email ) {
      elementHtml = elementHtml.replace(/\{%DISCLAIMEREMAIL%\}/ig, this.clientSetting.disclaimer_email);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%DISCLAIMEREMAIL%\}/ig, this.groupSetting.disclaimer_email);
      }
    }
    if ( this.clientSetting.disclaimer_print ) {
      elementHtml = elementHtml.replace(/\{%DISCLAIMERPRINT%\}/ig, this.clientSetting.disclaimer_print);
    } else {
      if (typeof this.groupSetting !== 'undefined') {
        elementHtml = elementHtml.replace(/\{%DISCLAIMERPRINT%\}/ig, this.groupSetting.disclaimer_print);
      }
    }
    let legal_1 = '';
    let legal_2 = '';
    let legal_3 = '';

    if ( this.clientSetting.legal_1 !== null ) {
      legal_1 = this.clientSetting.legal_1;
    } else {
      if ( typeof this.groupSetting !== 'undefined' && this.groupSetting.legal_1 !== null ) {
        legal_1 = this.clientSetting.legal_1;
      }
    }
    elementHtml = elementHtml.replace(/\{%LEGAL1%\}/ig, legal_1);

    if ( this.clientSetting.legal_2 !== null ) {
      legal_2 = this.clientSetting.legal_2;
    } else {
      if ( typeof this.groupSetting !== 'undefined' && this.groupSetting.legal_2 !== null ) {
        legal_2 = this.clientSetting.legal_2;
      }
    }
    elementHtml = elementHtml.replace(/\{%LEGAL2%\}/ig, legal_2);

    if ( this.clientSetting.legal_3 !== null ) {
      legal_3 = this.clientSetting.legal_3;
    } else {
      if ( typeof this.groupSetting !== 'undefined' && this.groupSetting.legal_3 !== null ) {
        legal_3 = this.clientSetting.legal_3;
      }
    }
    elementHtml = elementHtml.replace(/\{%LEGAL3%\}/ig, legal_3);

    if ( this.authUser.provider === 'vaultre' ) {
      elementHtml = elementHtml
      .replace(/%GREETING%/ig, '\$\$$greeting\$\$$')
      .replace(/%UNSUBSCRIBE%/ig, '\$\$$unsubscribe\$\$$');
    }

    return elementHtml;
  }

  s2ValueChanged(field: string, value = '') {
    if ( field === 'campaign' ) {
      this.s2CampaignValue = value;
      return true;
    }
    switch (field) {
      case 'classification':
        this.s2StatusDisabled = false;
        this.s2ClassificationValue = value.trim();
        this.s2SelectingCategory = true;

        if ( this.frontService.authService.getApp() === 'Designly' ) {
          let s2StatusData = [];

          this.s2SubStatusValue = '';
          this.s2SubStatusDisabled = true;
          this.s2AvailableDisabled = false;
          switch (this.s2ClassificationValue) {
            case 'residential':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'rental', text: 'Rental'},
                {id: 'auction', text: 'Auction'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'},
                {id: 'unconditional', text: 'Unconditional'},
                {id: 'pricechange', text: 'Price Change'},
                {id: 'appraisal', text: 'Appraisal'}
              ];
              break;
            case 'commercial':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'lease', text: 'Lease'},
                {id: 'salelease', text: 'For Sale & Lease'},
                {id: 'leased', text: 'Leased'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'},
                {id: 'pricechange', text: 'Price Change'},
                {id: 'appraisal', text: 'Appraisal'}
              ];
              break;
            case 'business':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'},
                {id: 'pricechange', text: 'Price Change'},
                {id: 'appraisal', text: 'Appraisal'}
              ];
              break;
            case 'rural':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'auction', text: 'Auction'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'},
                {id: 'pricechange', text: 'Price Change'},
                {id: 'appraisal', text: 'Appraisal'}
              ];
              break;
            case 'land':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'auction', text: 'Auction'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'}
              ];
              break;
            case 'holidayRental':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'lease', text: 'Lease'},
                {id: 'appraisal', text: 'Appraisal'},
                {id: 'management', text: 'Management'}
              ];
              break;
            default:
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'auction', text: 'Auction'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'},
                {id: 'pricechange', text: 'Price Change'},
              ];
              break;
          }

          if ( this.authUser.provider === 'domain' ) {
            switch (this.s2ClassificationValue) {
              default:
                s2StatusData = [
                  {id: '', text: 'Select a Type'},
                  {id: 'Sale', text: 'Sales'},
                  {id: 'Rent', text: 'Rental'},
                  {id: 'Share', text: 'Share'},
                  {id: 'Sold', text: 'Sold'},
                  {id: 'NewHomes', text: 'New Homes'}
                ];
                break;
            }
          }

          if ( this.authUser.provider === 'vaultre' ) {
            s2StatusData.forEach( (element, index) => {
              if ( element.id === 'all' ||
              element.id === 'pricechange' ||
              element.id === 'salelease' ) {
                s2StatusData.splice(index, 1);
              }
            });
            this.s2StatusData = s2StatusData;
          } else {
            this.s2StatusData = s2StatusData;
          }
          this.s2SubStatusValue = '';
        }
        break;
      case 'status':
        this.s2StatusValue = value.trim();

        if ( this.frontService.authService.getApp() === 'MyDesign3' ) {
          this.canSearch = true;
          this.s2SelectingCategory = false;
        }

        if ( this.frontService.authService.getApp() === 'Designly' ) {
          this.s2SubStatusValue = 'management';
          this.s2SubStatusDisabled = true;
          this.s2AvailableDisabled = true;

          if ( !this.s2SelectingCategory ) {
            this.s2StatusValue = value.trim();
          }

          if ( this.s2StatusValue === 'pricechange' ||
          this.s2StatusValue === 'appraisal' ||
          this.s2StatusValue === 'listing' ||
          this.s2StatusValue === 'rental' ||
          this.s2StatusValue === 'conditional' ||
          this.s2StatusValue === 'auction' ) {
            this.filterPeriodType = 'Listing Date';
          } else {
            this.filterPeriodType = 'n/a';
            this.mdListingsForm.patchValue({
              'period': 'any'
            });
          }

          if ( this.s2StatusValue === 'pricechange' ) {
            this.canSearch = false;
            this.filterPeriodType = 'Price Modify Date';
          } else {
            this.canSearch = true;
          }

          if ( this.s2StatusValue === 'auction' ) {
            this.filterPeriodType = 'Auction Date';
          }

          if ( this.s2StatusValue === 'sold' ) {
            this.canSearch = false;
            this.s2BasedOnDisabled = false;
          } else {
            this.s2BasedOnDisabled = true;
            this.mdListingsForm.patchValue({
              'basedon': ' '
            });
            this.s2BasedOnValue = '';
          }

          switch (this.s2StatusValue) {
            case 'rental':
              if (this.s2ClassificationValue === 'residential') {
                this.s2SubStatusDisabled = false;
                this.s2AvailableDisabled = false;
              }
            break;
          }
        }
        break;
      case 'substatus':
          this.s2SubStatusValue = value.trim();
          if (this.s2SubStatusValue === 'all') {
            this.s2SubStatusValue = '';
          }
        break;
      case 'available':
          this.s2AvailableValue = value.trim();
          break;
      case 'basedon':
          this.s2BasedOnValue = value.trim();

          if ( this.s2BasedOnValue !== '' ) {
            this.canSearch = true;
          } else {
            this.canSearch = false;
          }
          break;
      case 'suburb':
        if (Array.isArray(value)) {
          this.s2SuburbValue = value;
        } else {
          if (this.s2SuburbValue === value) {
            value = '';
          }
          this.s2SuburbValue = value.trim();
        }
        break;
      case 'officeid':
        this.s2OfficeIdValue = value.trim();
        break;
      case 'agentid':
        this.s2AgentIdValue = value.trim();
        break;
      case 'pricefrom':
        this.s2PriceFromValue = value.trim();
        break;
      case 'priceto':
        this.s2PriceToValue = value.trim();
        break;
      case 'bedfrom':
        this.s2BedFromValue = value.trim();
        break;
      case 'bedto':
        this.s2BedToValue = value.trim();
        break;
      case 'bathfrom':
        this.s2BathFromValue = value.trim();
        break;
      case 'bathto':
        this.s2BathToValue = value.trim();
        break;
      case 'carfrom':
        this.s2CarFromValue = value.trim();
        break;
      case 'carto':
        this.s2CarToValue = value.trim();
        break;
      case 'orderby':
        this.s2OrderByValue = value.trim();
        break;
    }
    this.ref.detectChanges();
    this.mdListingsForm.patchValue(
      {
        'classification' : this.s2ClassificationValue,
        'status' : this.s2StatusValue,
        'substatus' : this.s2SubStatusValue,
        'suburb' : this.s2SuburbValue,
        'officeid' : this.s2OfficeIdValue,
        'agentid' : this.s2AgentIdValue,
        'pricefrom' : this.s2PriceFromValue,
        'priceto' : this.s2PriceToValue,
        'bedfrom' : this.s2BedFromValue,
        'bedto' : this.s2BedToValue,
        'bathfrom' : this.s2BathFromValue,
        'bathto' : this.s2BathToValue,
        'carfrom' : this.s2CarFromValue,
        'carto' : this.s2CarToValue,
        'local_search': this.client.is_local_search,
        'client_id': this.client.ID,
        'orderby' : this.s2OrderByValue,
        'available': this.s2AvailableValue,
        'basedon': this.s2BasedOnValue
      }
    );

    if ( !this.s2SelectingCategory && this.canSearch ) {
      this.listingSearchChange('');
    }

    if ( field !== 'classification' && this.s2SelectingCategory ) {
      this.s2SelectingCategory = false;
    }
  }

  closeListingSearchModal() {
    this.loading = false;
  }

  /* End Library Storage Functions */
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();

    $('.modal-backdrop').hide();
  }

  enableZoom() {
    if (this.template.category_id !== 7 &&
      this.template.category_id !== 1 &&
      this.template.category_id !== 2 &&
      this.template.category_id !== 3) {

      const elemMd = $('.gjs-cv-canvas')
        .find('iframe')
        .contents()
        .find('.md-prop-search, .md-library-search');

      if ( elemMd.length ) {
        const $this = this;

        elemMd
        .draggable({
          start: function() {
            const elImg = $this.editor.getSelected();

            if ( elImg.view.$el.is('.md-library-search, .md-prop-search') === false ) {
              return false;
            }

          },
          stop: function() {
            const elImg = $this.editor.getSelected();
            const elImgStyle = elImg.getStyle();

            const dragTop = $(this).css('top');
            const dragLeft = $(this).css('left');

            elImgStyle.position = 'absolute';
            elImgStyle.top = dragTop;
            elImgStyle.left = dragLeft;

            elImg.set('style', elImgStyle);

            setTimeout(() => {
              $(elImg.view.$el).trigger('click');
            }, 10);
          }
        })
        .parent()
        .css({overflow: 'hidden'})
        .find('img')
        .unbind('wheel mousewheel DOMMouseScroll')
        .bind('wheel mousewheel DOMMouseScroll', function(e){
          const elImg = $this.editor.getSelected();
          const elImgStyle = elImg.getStyle();

          if (e.type === 'DOMMouseScroll' || e.type === 'wheel') {
            e.preventDefault();

            return;
          }

          let delta;

          if (e.originalEvent.wheelDelta !== undefined) {
              delta = e.originalEvent.wheelDelta;
          } else {
              delta = e.originalEvent.deltaY * -1;
          }

          const naturalWidth = $(this).get(0).naturalWidth;
          const naturalHeight = $(this).get(0).naturalHeight;

          let sizeWidth = $(this).width();
          let sizeHeight = $(this).height();

          if (delta > 0) {
            sizeHeight += 30;
            sizeWidth += 30;
          } else {
            sizeHeight -= 30;
            sizeWidth -= 30;
          }

          const new_size = $this.calculateAspectRatioFit(
            naturalWidth,
            naturalHeight,
            sizeWidth,
            sizeHeight
          );

          sizeHeight = Math.round(new_size.height);
          sizeWidth = Math.round(new_size.width);

          sizeWidth += 'px';
          sizeHeight += 'px';

          $(this).width(sizeWidth);
          $(this).height(sizeHeight);

          elImgStyle.width = sizeWidth;
          elImgStyle.height = sizeHeight;

          elImg.set('style', elImgStyle);
        });
      }
    }
  }

  disableZoom() {
    const elemMd = $('.gjs-cv-canvas')
        .find('iframe')
        .contents()
        .find('.md-prop-search, .md-library-search');

        elemMd
        .unbind('wheel mousewheel DOMMouseScroll');
  }

  stripSmartQuotes(string) {
    return String(string)
            .replace(/[“]/g, '"')
            .replace(/[”]/g, '"')
            .replace(/[‘]/g, '&#39;')
            .replace(/[’]/g, '&#39;');
  }

  blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return <File>theBlob;
  }

  reorderImages(listing) {
    this.subLoading = true;

    this._tmp_order_id = listing.id;

    if ( typeof this._tmp_order_images[this._tmp_order_id] !== 'undefined' ) {
      this.listingImages = this._tmp_order_images[this._tmp_order_id];
    } else {
      this.listingImages = listing.images;
    }

    $('#mdReorderImage').modal('show');

    setTimeout(() => {
      $('#sortable').sortable();
      $( '#sortable' ).disableSelection();
      this.subLoading = false;
    }, 1000);
  }

  saveImageOrder() {
    const _tmp_order = [];

    $('#sortable').find('li').each( function() {
      _tmp_order.push( { url: $(this).find('img').attr('src') } );
    });

    this._tmp_order_images[this._tmp_order_id] = _tmp_order;
    $('#mdReorderImage').modal('hide');
    swal({
      position: 'top-end',
      type: 'success',
      title: 'Order saved',
      showConfirmButton: false,
      timer: 1500
    }).catch(swal.noop);
  }

  onPdfDownloadCheck() {
    if ( typeof $('#confirm-1:checked').val() !== 'undefined' ) {
      $('.btn-rural-pdf').removeAttr('disabled');
    } else {
      $('.btn-rural-pdf').attr('disabled', true);
    }
  }

  onModalLinkTypeChange() {
    const link_type = $('#mdl-link-type').val();

    if ( link_type === 'url' ) {
      this.updateable_link_type = 'url';

      $('.mdl-link-holder').removeClass('hidden');
    } else {
      if ( link_type === 'tel' ) {
        this.updateable_link_type = 'tel';
      } else {
        this.updateable_link_type = 'mail';
      }

      $('.mdl-link-holder').addClass('hidden');
    }
  }

  onClickSend(link, val) {
    if ( link !== 'secure' ) {
      window.location.href = 'http://' + link + '.' + val;
    } else {
      swal({
        title: 'I am signed in via',
        type: 'info',
        html:
          // tslint:disable-next-line:max-line-length
          '<a href="http://login.' + val + '" target="_blank" class="btn btn-primary btn-send-trigger">MyDesktop</a> &nbsp; <a href="http://secure.' + val + '" target="_blank" class="btn btn-info btn-send-trigger">Domain Group</a>',
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false
      });

      $('.btn-send-trigger').click(function() {
        swal.close();
      });
    }
  }

  onAnchorPaste() {
    setTimeout(() => {
      const link_type = $('#mdl-link-type').val();

      if ( link_type === 'url' ) {
        const linkValue = $('#anchorLink').val();

        if ( String(linkValue).includes('https') ) {
          $('#mdl-url-types').val('https://');
        } else {
          $('#mdl-url-types').val('http://');
        }
      }
    }, 100);
  }

  openSupportModal() {
    $('#supportModal').modal('show');
  }

  onSupportCapture() {
    this.supportService.onCapture.next(true);
    this.showScreenshot = false;

    this.loading = true;
  }

  onSupportCancel() {
    this.showScreenshot = false;
    $('#supportModal').modal('show');
  }

  closeLibraryModal() {
    this.showImageLibrary = false;
    this.ref.detectChanges();
  }

  onCheckMulti() {
    const isMulti = $('#multi-office').is(':checked');
    this.mdListingsForm.patchValue({
      'multioffice': isMulti
    });
    if ( !this.s2SelectingCategory && this.canSearch ) {
      this.listingSearchChange('');
    }
  }

  /*
  * Thanks to https://stackoverflow.com/a/14731922/382536
  * */
  calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  onPaginate(type) {
    const formValues = [];
    if ( type === 'prev' ) {
      formValues['paginate_link'] = this.designlyPreviousLink;
    }

    if ( type === 'next' ) {
      formValues['paginate_link'] = this.designlyNextLink;
    }

    this.myDesktopService.httpGetMDListings(
      formValues,
      'vaultre'
    );
  }

  onCampaignSave() {
    if ( this.s2CampaignValue === undefined ) {
      swal(
        'Select Category',
        '',
        'error'
      );

      return false;
    }
    const data = {
      client_id: this.authUser.client.ID,
      group_id: this.authUser.client.group_id,
      user_id: this.authUser.user.ID,
      category: this.s2CampaignValue,
      template_id: this.id
    };

    this.campaignService.httpPostCampaignTemplate(data);
    this.loading  = true;
  }

  selectCampaign() {
    $('#selectCampaign').modal('show');
  }

}



// WEBPACK FOOTER //
// ./src/app/front/templates-front/template-front-build/template-front-build.component.ts